var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g4, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _g5, _g6, _g7, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _g8, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _g9, _g10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPioneer10Optimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2216 1789.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radialGradient7111",
    cx: 1349.8,
    cy: 1035.2,
    r: 281.85,
    gradientTransform: "matrix(1 0 0 1.5473 -86.626 -706.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7c5d0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef2f2",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7121",
    x1: 1722.8,
    x2: 1674.1,
    y1: 1151.1,
    y2: 1239.9,
    gradientTransform: "translate(-86.626 -110.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbe2e9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.33333
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbe2e9",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spacecraft",
    transform: "translate(-654.3 -118.95)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1581.7 1058c14.68-10.871 40.139-16.843 65.535-22.844 33.103 11.621 20.679 77.013 3.3704 100.36-17.835 22.173-39.016 23.516-54.301 16.103-13.706-19.061-23.117-39.734-28.836-61.79z",
    fill: "url(#linearGradient7121)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1579 1056.8c4.3251-5.8257 10.416 1.3241 10.327 10.327-0.9702 14.288-8.3413 22.143-13.24 25.156-5.3269 1.1639-12.331 1.9752-10.857-2.9129z",
    fill: "#dbe2ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1574 1054.9c4.0378-4.0369 10.138-1.8704 10.857 9.0033 1.3034 9.8448-7.2517 24.208-13.77 26.745-4.8583 2.2192-10.3-0.01-11.916-2.648z",
    fill: "#d9e2e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1561.8 1056.2c4.5143-7.4261 13.279-6.783 15.888 0 4.4137 13.039-6.2353 30.613-12.181 32.571-5.8017 3.242-15.118-2.7124-11.122-11.651z",
    fill: "#dee7f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1554.1 1051.7 9.0033 1.8536c4.4708 1.0976 5.4844 3.6769 5.0312 6.8848-1.2761 6.1027-3.4521 12.55-6.62 18.536-1.997 4.3548-5.7022 4.1542-9.7977 2.9129l-9.2681-5.0313z",
    fill: "#a7b9c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1549.3 1045.1c14.885 2.3357 1.5845 39.626-13.77 31.247z",
    fill: "#c9d2dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1544 1039.5c15.945 5.7781-1.5931 42.803-15.358 37.072z",
    fill: "#c9d2dc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "MA-Main",
    d: "m1029.3 1111c-14.522 157.91 49.036 267.63 124.37 300.32l14.829-2.1184 3.1776-50.842c4.9494-20.173 37.797-32.112 40.25-10.592l-3.1776 34.954c42.648-19.297 86.704-27.334 131.34-30.717 181.81-153.25 236.73-383.89 244.68-513.72 7.4409-120.44-19.26-275.55-142.12-293.71-23.123-2.9838-65.543 8.5273-91.97 20.435-14.525 37.36-42.024 66.658-75.204 69.908z",
    fill: "url(#radialGradient7111)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "RTG-Arm-Bottom",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arm-Bottom-Pole",
    d: "m844.35 1654.2 204.66-530.65 17.226 4.6811-208.4 537.95z",
    fill: "#d1ba4b",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Arm-Bottom-Center-Wire",
    d: "m1023.4 1114.7c-0.598 0.041-1.1141 0.4344-1.3125 1l-193.34 501.12c-0.30202 0.7767 0.0828 1.6511 0.8594 1.9531 0.77665 0.302 1.6511-0.083 1.9531-0.8594l193.31-501.16c0.1931-0.4755 0.1297-1.0166-0.168-1.4346-0.2976-0.418-0.7883-0.6549-1.3008-0.6279z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arm-Bottom-Generator",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m826.75 1810.3 8.0515-19.661-21.72-2.8086-5.9918 14.043z",
    fill: "#b7c5d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m730.88 1751.5-18.35-11.609-9.7367 26.589 23.967 1.1235z",
    fill: "#b7c5d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m861.37 1667.1-83.148 222.96c-7.7604 8.0207-91.628-15.476-89.503-40.25l84.737-215.55c7.9019-14.063 93.361 16.131 87.914 32.836z",
    fill: "#e3e8ec"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m726.11 1755.5c11.947 23.784 70.375 40.449 88.637 36.138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m774.11 1633.9c-4.0898 13.152 80.324 44.702 87.408 31.831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m768.7 1646.3c20.256 19.531 57.797 34.825 88.379 32.58"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m854.27 1680 20.222 2.9959-7.1153 19.473-20.035-10.673z",
    fill: "#b7c5d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m772.45 1642.6-18.35-11.984-10.486 25.465 28.087 6.3663z",
    fill: "#b7c5d1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m749.6 1746.7c16.474 9.6822 34.339 15.889 52.803 20.597",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m820.46 1613.2c-2.5664 5.3689 17.666 12.716 19.463 8.3413 1.6831-6.4318-16.287-12.704-19.463-8.3413z",
    fill: "#e3e8ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m820.59 1613.2-18.801 23.7c2.8689 5.6488 25.209 15.921 36.41 14.432l1.5888-29.658",
    fill: "#e3e8ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m735.37 1745.9c20.629 15.675 45.299 24.615 71.902 30.334",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m751.48 1749.7-55.05-10.86 34.827-91.749 54.675 10.486z",
    fill: "#d0d9e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m834.61 1679.3 47.56 28.836-38.198 91.375-45.687-28.461z",
    fill: "#d0d9e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m703.02 1856.7c18.968 13.542 37.339 18.732 55.609 22.508",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m762.34 1784.9-13.482 22.095-32.206 86.132 13.482-22.095z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m655.23 1848.1 55.424 10.486 35.576-92.873-55.799-10.111z",
    fill: "#d0d9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m757.09 1879.2 45.687 28.461 37.823-91.375-46.436-28.461z",
    fill: "#d0d9e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arm-Bottom-Wires"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m953.62 1026.3c-0.6097 0.029-1.141 0.4243-1.3438 1l-232.03 601.31 0.65625 1.8437 14.125 8 27.25 143.75 2.3438 0.9375 120.62-86.469 12.719 5.625 2-0.8437 215.78-541.62c0.208-0.4982 0.1322-1.0698-0.1985-1.4966-0.3306-0.4268-0.8651-0.643-1.3995-0.5661-0.5344 0.077-0.9863 0.435-1.1832 0.9377l-215.22 540.22-12.062-5.3437-1.5 0.1563-119.38 85.594-26.969-142.12-0.71875-1-13.625-7.75 231.56-600.09c0.1904-0.4702 0.1304-1.0048-0.1597-1.4209-0.29-0.4162-0.7708-0.6576-1.2778-0.6417z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m733.94 1633.9a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z",
    fill: "#ecf0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m894.59 1697.9a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z",
    fill: "#ecf0f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Arm-Bottom-top-object",
    d: "m803.16 1675.1-34.078 91-15.354 25.84 34.453-92.124z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RTG-Arm-Top",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arm-Top-Pole",
    d: "m1085.5 681.24-71.902-295.85-14.23 10.111 70.404 290.98z",
    fill: "#d1ba4b",
    fillRule: "evenodd",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arm-Top-Generator"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#b7c5d0",
    fillRule: "evenodd",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m981.06 423.88-1.8536 26.48-8.2089-28.599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m945.09 400-39.321 16.852-10.111-39.696 44.19-17.975z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m911.76 301.89-31.082 11.984 9.3622 40.445 45.313-16.103-11.235-33.329z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.9 302.26 18.724 7.4898 5.6173 34.078-29.959-8.2387-9.3622-5.9918-7.1152-22.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1010.2 394.39 39.321 18.35-9.7367-40.445-20.222-8.6132-23.218 8.9877z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m992.65 336.34 46.811-18.724 8.2388 40.445-44.564 16.103z",
    fill: "#e3e8ec",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m920.52 277.17-40.357-18.571 8.5714 39.286 41.429 19.643z",
    fill: "#e3e8ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m980.53 268.97c-6.203-30.229-65.974-31.089-66.201 9.5329l28.599 118.63 63.553-15.888z",
    fill: "#e3e9ed",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m933.85 340.83c1.7575-15.897 44.722-32.526 61.79-5.9918",
    fill: "none",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m935.87 340.03-41.429-19.286 9.6429 40.714 40.714 18.571z",
    fill: "#e3e8ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1023 254.33-41.568 17.226 7.8642 40.07 43.815-16.852z",
    fill: "#e3e8ec",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#e3e9ed",
    fillRule: "evenodd",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1009.9 393.03a34.158 31.63 0 1 1-68.315 0 34.158 31.63 0 1 1 68.315 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1009.9 396.86a32.754 27.792 0 1 1-65.506 0 32.754 27.792 0 1 1 65.506 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1003.5 399.11a25.357 21.613 0 1 1-50.714 0 25.357 21.613 0 1 1 50.714 0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m980.66 403.62a1.986 1.986 0 1 1-3.972 0 1.986 1.986 0 1 1 3.972 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m981.46 400.64a1.3902 1.3902 0 1 1-2.7804 0 1.3902 1.3902 0 1 1 2.7804 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m980.66 406.6a1.3902 1.3902 0 1 1-2.7804 0 1.3902 1.3902 0 1 1 2.7804 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m999.76 402.01a21.613 18.71 0 1 1-43.225 0 21.613 18.71 0 1 1 43.225 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m981.79 274.18c-18.708-30.453-60.604-12.558-63.288 4.8683",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "m957.3 297.17-9.6429-38.571 1.4286-34.643 9.6428 34.643z",
    fill: "#b7c5d0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m920.75 276.8 9.7367 40.07-41.568-19.473-7.8642-37.823z",
    fill: "#e3e8ec",
    fillRule: "evenodd",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arm-Top-Wires"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m998.47 415.46c-0.7245 0.0398-1.3166 0.59247-1.4063 1.3125l-8.8125 55.406-28.094-52.969c-0.3883-0.73349-1.2977-1.0133-2.0312-0.625-0.7335 0.38835-1.0133 1.2978-0.625 2.0312l30.188 56.938h0.062l53.562 222.88c0.098 0.55071 0.4974 0.98932 1.0313 1.1562 0.534 0.1669 1.1054 0.0216 1.5-0.375 0.3946-0.39657 0.5445-0.96688 0.375-1.5l-53.624-223.22 9.4374-59.25c0.088-0.45488-0.038-0.933-0.3437-1.2812-0.3055-0.34823-0.7564-0.52759-1.2187-0.5z",
    fill: "#fff",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m965.47 293.27c-0.3465 0.0129-0.6778 0.14541-0.9376 0.375l-70.312 60.969c-0.4266 0.37161-0.60785 0.95161-0.46875 1.5l92.344 395.66c0.077 0.56522 0.4686 1.0376 1.0096 1.2189 0.5409 0.18129 1.1378 0.0401 1.5402-0.36436 0.4023-0.40444 0.5405-1.0021 0.3564-1.5421l-92.125-394.78 68.75-59.656 90.344 58.844c0.241 0.15991 0.5232 0.24673 0.8124 0.25l11.344 0.0625 91.031 299.69c0.2416 0.79391 1.0811 1.2416 1.875 1s1.2416-1.0811 1-1.875l-91.344-300.75c-0.1928-0.63215-0.7766-1.0636-1.4375-1.0625l-12-0.0625-90.906-59.219c-0.2587-0.17192-0.5645-0.25928-0.875-0.25z",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051.8 693.6-71.527-289.1",
    fill: "#fafafa",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m899.26 354.47a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1061.5 353.67a4.2858 4.2858 0 1 1-8.5715 0 4.2858 4.2858 0 1 1 8.5715 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1071.4 357.12a4.2858 4.2858 0 1 1-8.5715 0 4.2858 4.2858 0 1 1 8.5715 0z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Arm-Top-top-object",
    d: "m962.3 322.17 2.5-38.929 8.9285 37.5-0.7142 40.714z",
    fill: "#b7c5d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m939.47 938.89-14.98 82.387 113.84 74.898 167.77-106.35 53.926-356.51-77.519-6.7408-23.593 63.663-92.498-14.231-76.021 79.391z",
    fill: "#b7c5d0",
    fillRule: "evenodd",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1380.5 784.31 5.3571 12.857-12.5 7.3214-4.8214-12.321z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1337.7 781.37c-0.7477 0.062-1.3346 0.66695-1.374 1.4162-0.039 0.74924 0.4807 1.4124 1.2178 1.5526l37.469 9.875c0.8025 0.20711 1.621-0.27559 1.8281-1.0781 0.2071-0.80253-0.2756-1.621-1.0781-1.8281l-37.469-9.875c-0.1917-0.0604-0.3937-0.0817-0.5938-0.0625z",
    fill: "#ecf0f3",
    fillRule: "evenodd",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1305.9 1055 4.8214 12.679-12.678 6.9643-5-12.322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1370.2 936.64 5.1786 13.036-13.214 6.9643-4.1072-11.964z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1230.9 1149.9 5.3571 12.679-13.214 6.9643-4.2858-11.786z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1176.3 1137.3c-0.7016 0.062-1.2657 0.6038-1.3558 1.3023-0.09 0.6986 0.3179 1.3658 0.9808 1.6039l48.438 19.312c0.4978 0.2059 1.0679 0.129 1.4934-0.2014s0.6412-0.8636 0.565-1.3969c-0.076-0.5333-0.4324-0.9849-0.9334-1.183l-48.469-19.312c-0.2256-0.1002-0.4725-0.1431-0.7187-0.125z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1187 1001.6c-0.7811 0.015-1.42 0.6265-1.4688 1.4062l-26.188 331.62c-0.1148 0.5695 0.1096 1.1542 0.5759 1.5007 0.4664 0.3465 1.0909 0.3925 1.6031 0.1181 0.5121-0.2743 0.8198-0.8198 0.7897-1.4l26.219-331.59c0.045-0.4296-0.097-0.8578-0.3904-1.1749-0.2933-0.3172-0.709-0.4926-1.1408-0.4813z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785.64 895.2 27.274-63.64 46.467-3.5355 30.81 57.074-16.162 130.31-103.04 11.112z",
    fill: "#97aabb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m859.38 828.02-15.657 129.8 29.8 55.558 16.162-129.3z",
    fill: "#ecf0f3",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#dbe2ea",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1023.4 741.54-13.669-5.9918 0.749 21.72 13.294 2.8087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1035.2 727.49-13.107-5.0556-0.1873 40.445 12.545 4.3066z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1047.9 716.63-13.107-5.8046-4.1193 55.799 12.545 4.8683z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1060.8 708.58-13.107-2.8087-8.9877 62.727 10.86 1.6852z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1072.4 703.34-12.358-2.0597-15.167 67.969 10.486 3.3704z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1083.1 702.4-11.235-2.6214-21.158 71.34 9.3621 3.7449z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1083.8 699.59-26.963 73.025 8.2387 3.3704 31.644-71.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1093.4 704.84-31.082 70.216 8.8004 2.8087 34.453-66.659z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1115.9 714.95-13.107-5.2428-34.266 67.408 11.235 5.0556z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1071.7 785.35 39.883-66.659 12.545 4.4938-39.134 66.472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1074.7 793.59 41.006-57.858 20.035 12.733-39.883 52.054z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1139.3 765.32-21.908-9.9239-41.194 47.185 18.912 8.2387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1140.4 783.67-21.533-9.3622-41.194 38.759 21.72 11.609z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1076.7 825.23 39.883-29.585 24.154 9.3622-42.13 27.899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1094.9 845.64-18.724-8.426 38.572-20.222 23.78 9.1749z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PA",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1356.3 890.21-41.943 26.589 6.3663-51.679z",
    fill: "#a6b7c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1331.2 798.83 32.58 13.856-7.4898 77.519-36.325-15.354z",
    fill: "#dbe2ea"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1272 990.2 33.329 14.23 32.58-30.334-34.827-21.346z",
    fill: "#a6b7c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1263.7 999.15c-0.5313 0.022-1.0114 0.323-1.2619 0.792-0.2506 0.469-0.2341 1.0356 0.043 1.4893l36.156 61.812c0.4228 0.7163 1.3462 0.9541 2.0625 0.5313s0.9541-1.3462 0.5313-2.0625l-36.156-61.781c-0.2727-0.5005-0.8055-0.8032-1.375-0.7813z",
    fill: "#ecf0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1332 943.37c-0.8284-0.017-1.514 0.6403-1.5313 1.4687-0.017 0.8284 0.6403 1.514 1.4687 1.5313l33.531 0.5625c0.5393 0.011 1.0428-0.2688 1.3188-0.7322 0.276-0.4633 0.282-1.0392 0.016-1.5083-0.2662-0.469-0.7638-0.759-1.3032-0.7595l-33.5-0.5625z",
    fill: "#ecf0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1318.1 919.42 14.605 5.9918 4.8684 49.432-36.7-16.103z",
    fill: "#c9d3dd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1242.3 632.17 103.57 37.857-28.929 274.64-111.07-41.429z",
    fill: "#e3e8ec"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1239.2 852.77-14.142-10.48 12.879-10.733z",
    fill: "#dce2ea",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(61.777 1361.7 819.94)",
    fill: "#dce2ea",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1330.3 912.73-12.123 13.772c-3.8219 5.1555 5.0579 22.008 16.512 16.228l11.86-14.61",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.5273 -1.4402 1.4426 1.5247 -2040.1 1493.2)",
    d: "m1359.5 905.79a2.9464 5.3572 0 1 1-5.8929 0 2.9464 5.3572 0 1 1 5.8929 0z",
    strokeWidth: 0.95279
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1343.6 907.39-11.429 7.0536c-2.0885 5.8385 8.9396 14.9 12.143 12.411l7.5-12.143",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-43.367 1358.8 919.69)",
    d: "m1359.5 905.79a2.9464 5.3572 0 1 1-5.8929 0 2.9464 5.3572 0 1 1 5.8929 0z",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(61.777 1380.1 813.41)",
    fill: "#dce2ea",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1330.3 912.73-12.123 13.772 16.512 16.228 11.86-14.61",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.5273 -1.4402 1.4426 1.5247 -2040.1 1493.2)",
    d: "m1359.5 905.79a2.9464 5.3572 0 1 1-5.8929 0 2.9464 5.3572 0 1 1 5.8929 0z",
    strokeWidth: 0.95279
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1343.6 907.39-11.429 7.0536c-2.0885 5.8385 8.9396 14.9 12.143 12.411l7.5-12.143",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-43.367 1358.8 919.69)",
    d: "m1359.5 905.79a2.9464 5.3572 0 1 1-5.8929 0 2.9464 5.3572 0 1 1 5.8929 0z",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-86.626 -110.76)",
    fill: "#dce2ea",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1330.3 912.73-12.123 13.772 16.512 16.228 11.86-14.61",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.5273 -1.4402 1.4426 1.5247 -2040.1 1493.2)",
    d: "m1359.5 905.79a2.9464 5.3572 0 1 1-5.8929 0 2.9464 5.3572 0 1 1 5.8929 0z",
    strokeWidth: 0.95279
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1343.6 907.39-11.429 7.0536c-2.0885 5.8385 8.9396 14.9 12.143 12.411l7.5-12.143",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-43.367 1358.8 919.69)",
    d: "m1359.5 905.79a2.9464 5.3572 0 1 1-5.8929 0 2.9464 5.3572 0 1 1 5.8929 0z",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(64.766 1365.7 808.82)",
    fill: "#dce2ea",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1330.3 912.73-16.831 20.207 16.512 16.228 16.568-21.046",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.5273 -1.4402 1.4426 1.5247 -2040.1 1493.2)",
    d: "m1359.5 905.79a2.9464 5.3572 0 1 1-5.8929 0 2.9464 5.3572 0 1 1 5.8929 0z",
    strokeWidth: 0.95279
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1343.6 907.39-11.429 7.0536c-2.0885 5.8385 8.9396 14.9 12.143 12.411l7.5-12.143",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-43.367 1358.8 919.69)",
    d: "m1359.5 905.79a2.9464 5.3572 0 1 1-5.8929 0 2.9464 5.3572 0 1 1 5.8929 0z",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1200.1 1202.5-26.963-2.247-18.35 14.231-35.202-79.017 71.902 54.675z",
    fill: "#a6b7c7",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "MDS-panels",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1515.9 717.89 50.357-18.929 12.143 104.64-50.357 19.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1519.1 832.89 55.357 3.5714-21.786 114.64-55-3.2142z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1341.4 704.49 49.821-65-29.821-5.8929-29.107 38.214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1248.7 1297.9 27.857 56.428 85-47.5-28.929-56.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1386.9 556.1 33.929-1.4286-56.071 65.357-33.572 1.7857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1439.1 551.81 33.571 10-72.5 68.571-33.214-8.9286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1486.6 567.53 30 21.429-83.571 63.214-30-20.714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1209.1 1203.6 43.929 27.857-10.357 109.64-43.929-27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1287.3 1067.2 70.714 83.214-44.643 47.143-70.714-83.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1376.2 1129 71.072 67.5-35.357 56.786-71.071-67.143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1383.4 1124 87.5 47.857 28.214-58.214-88.571-47.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1495.9 970.03 48.214 22.143-40.357 110-48.571-21.786z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1254.4 643.67 82.327 33.335-26.264 246.98-87.378-32.325zm2.0203-6.566 79.802 33.335c7.1154 2.4137 7.8326 5.6206 7.5761 9.0914l-26.264 245.47c-0.3956 5.7534-2.9788 8.5472-9.0913 6.566l-86.873-32.325c-5.3055-1.8967-5.8649-5.5731-5.0507-11.617l31.315-243.95c0.6404-6.4612 3.5688-8.5223 8.5863-6.566z",
    fill: "#e3e8ec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1164.5 1336.4a4.2858 4.2858 0 1 1-8.5715 0 4.2858 4.2858 0 1 1 8.5715 0z",
    fill: "#ecf0f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1280.5 681.81 22.857 9.2857 39.821-33.571c7.4745-6.6052 4.5736-12.133-13.214-11.25l-49.464 0.89286c3.493 2.3872 3.8037 5.8353 3.0357 9.6429z",
    fill: "#e3e8ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1329.1 652.89-48.036 28.571",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#dbe2ea",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m945.09 953.12-15.354-6.7408 10.486-8.9877 13.482 6.7408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m944.34 972.6-14.23-6.3663 21.72-22.095 11.609 6.3663z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m945.84 989.07-13.107-4.8683 27.338-35.202 11.235 4.1194z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m950.33 1004.4-12.733-5.2428 29.959-47.186 10.486 2.9959z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m952.95 1016.4-10.111-4.4939 32.58-57.671 7.4897 3.3704z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m984.39 949.53a4.2858 4.2858 0 1 1-8.5715 0 4.2858 4.2858 0 1 1 8.5715 0z",
    fill: "#ecf0f3",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#dbe2ea",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1072.4 863.99 34.453-1.1235 20.597 8.9877-34.453 1.1235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069 878.22 28.461 7.1153 23.218 9.7367-26.589-7.1153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1063.8 891.71 25.091 16.852 22.844 9.3622-28.086-19.473z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1057.8 904.06 20.971 7.4898 23.967 29.21-22.095-9.3622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m951.08 1021.3 29.959-64.786 9.3622 3.7449-25.465 70.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m960.44 1028.4 26.589-69.28 8.6132 4.8683-22.095 68.906z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m992.27 961.36-22.844 70.778 22.844 9.7366 15.354-73.774z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m981.04 1032.5 22.095 10.111 13.107-74.523-16.852-6.7408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.5 959.49-13.482 70.029 22.469 10.111 9.7367-71.527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1028.6 1033.3-23.218-10.86 8.2387-67.033 20.597 9.7367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1020.4 951.25-1.1235 64.412 22.469 9.3622-1.1235-67.033z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1027.8 943.39 19.473 9.3622 7.1152 60.292-24.716-11.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1067.2 997.31-9.3622-53.552-22.844-8.9877 9.3622 53.552z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1044 926.16 13.107 44.564 23.218 9.7367-17.601-46.436z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1051.1 915.67 21.346 8.2387 19.099 36.7-21.346-8.2388z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1132.7 848.64-36.325 10.86-21.72-9.3622 37.823-10.486z",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m928.03 931.49c-0.3364 0.052-0.645 0.2178-0.875 0.4688l-56.469 57.375c-0.48872 0.497-0.57073 1.2651-0.19796 1.8541 0.37278 0.589 1.1021 0.8436 1.7605 0.6146l56.375-19.312c0.7853-0.2761 1.198-1.1366 0.9219-1.9219s-1.1366-1.198-1.9219-0.9219l-50.375 17.25 52.062-52.844c0.4738-0.455 0.5965-1.1654 0.3027-1.7529-0.2938-0.5876-0.9357-0.9157-1.584-0.8096z",
    fill: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1090 695.62c-21.248-8.0919-47.758 4.0806-73.122 29.538-25.364 25.458-49.869 64.3-67.722 110.57-17.853 46.267-25.725 91.336-23.989 127.11 1.7355 35.778 13.226 62.531 34.474 70.623 21.248 8.0918 47.794-4.1752 73.158-29.633 25.364-25.458 49.766-64.231 67.618-110.5 17.853-46.267 25.828-91.405 24.093-127.18-1.7354-35.778-13.262-62.436-34.51-70.528zm-2.5546 6.6207c19.205 7.3139 29.994 31.699 31.657 65.97 1.6626 34.272-5.9573 78.191-23.376 123.33-17.419 45.143-41.302 82.868-65.598 107.25-24.296 24.386-48.728 35.357-67.932 28.043-19.205-7.3139-30.062-31.724-31.724-65.996s5.9575-78.191 23.376-123.33 41.302-82.868 65.598-107.25c24.296-24.386 48.795-35.332 68-28.018z",
    fill: "#fdfdfb",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1007 750.91c-33.681-6.6728-57.994 34.668-80.5 85.266-9.4993 43.236-17.387 85.472 13.24 103.8 41.4 9.0553 73.455-21.35 102.21-65.671 1.6435-45.453 16.901-95.332-34.954-123.4z",
    fill: "#a6b7c7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1135.2 754.62-17.212-6.3553-4.2369-20.919 17.212 6.3553z",
    fill: "#d1d8de",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1145.1 719.74c-0.1391 0.0122-0.2758 0.0438-0.4062 0.0937l-112 40.25c-0.5558 0.13632-0.9856 0.57694-1.108 1.1359-0.1225 0.55897 0.084 1.1389 0.5316 1.4951 0.4478 0.3562 1.0593 0.42659 1.5764 0.18146l112.03-40.25c0.7052-0.25549 1.1133-0.99255 0.9556-1.7258s-0.8327-1.2374-1.5806-1.1804z",
    fill: "#fefefc",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1015.2 754.09c27.977 71.76-6.3792 161.75-66.201 189.86l45.811 17.742c66.16-7.6319 109.71-167.35 61.964-190.66z",
    fill: "#e3e8ec",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ecf0f3",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m980.03 949.74c-0.4161 0.073-0.7822 0.3181-1.0082 0.675-0.2261 0.3569-0.2911 0.7926-0.1792 1.2l35 135.28c0.2071 0.8025 1.0256 1.2852 1.8281 1.0781s1.2852-1.0256 1.0781-1.8281l-35-135.28c-0.186-0.77-0.9387-1.2626-1.7188-1.125z",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1020.3 1089.5a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m915.22 871.06-32.469 11.375-2.75 0.9375 2.375 1.6875 33.219 23.5 1.7187-2.4687-30.812-21.813 29.688-10.375z",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m914.12 892.49-61.375 62 1.5625 2.4688 70.969-24.75-1-2.8126-64.812 22.625 56.781-57.406z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m929.41 825.02-64.187 21.812-2.8438 0.9375 2.4688 1.7188 50.719 35 1.6875-2.5-48.219-33.312 61.344-20.812z",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m772 1022.5 25.759-60.104 45.962-4.5457 30.545 57.314-102.27 11.882",
    fill: "#b7c5d0",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m786.65 895.7 25.254-2.0203",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m812.84 831.33-15.584 131.05 45.962-4.5457 16.668-129.3z",
    fill: "#dbe2ea",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m849.28 946.72 4.3671 7.8593-0.60968 10.902-4.7676-9.1958z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m866.71 981.68 4.7242 7.5634-0.96682 11.26-4.7676-8.8387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.84 876.12 4.2192 6.9231-1.0408 10.354-4.1886-7.2928z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m862.66 841.66 4.3977 7.6374-0.86221 9.2825-4.5457-7.8285z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ecf0f3",
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m870.74 849.34a3.9286 3.9286 0 1 1-7.8572 0 3.9286 3.9286 0 1 1 7.8572 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m887.68 884.26a3.9286 3.9286 0 1 1-7.8572 0 3.9286 3.9286 0 1 1 7.8572 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m857.48 955.21a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m875.34 990.56a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1000.8 790.83a3.3146 2.7148 0 0 1-6.6291 0 3.3146 2.7148 0 1 1 6.6291 0z",
    fill: "#e2e1dd",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1316.6 615.6-32.306 5.296-20.919-19.331 32.836-15.359z",
    fill: "#b7c5d0",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1262.8 601.3 1.324-19.066 30.982-4.7664 23.303 18.801-1.324 19.595-25.156-19.86z",
    fill: "#dbe2ea",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1066.1 674.74c-0.7355 0.12222-1.2696 0.76603-1.2539 1.5114 0.016 0.7454 0.5764 1.3662 1.3164 1.4573l78.375 10.344c0.5445 0.10298 1.1015-0.10264 1.4485-0.53476s0.4274-1.0203 0.2093-1.5298c-0.2182-0.50944-0.6994-0.85712-1.2516-0.9042l-78.375-10.344c-0.1553-0.0246-0.3134-0.0246-0.4687 0z",
    fill: "#fafafa",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1229.2 590.24c-0.1852 0.0187-0.3654 0.0717-0.5312 0.15625l-162.12 83.156-0.4375 0.3125-66.188 72.875c-0.4192 0.38554-0.584 0.97524-0.4253 1.5222 0.1588 0.54699 0.6135 0.95693 1.174 1.0582s1.13-0.12358 1.4701-0.58045l66.031-72.688 161.88-82.969c0.6712-0.31528 1.0113-1.0736 0.8004-1.7846-0.211-0.7109-0.9097-1.161-1.6442-1.0592z",
    fill: "#fafafa",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1006.7 748.49c-13.378-5.0863-28.897 2.2451-43.094 16.711-14.197 14.466-27.499 36.413-36.854 62.681s-13.004 51.918-11.268 72.443c1.7359 20.524 8.9542 36.5 22.332 41.587s28.897-2.2451 43.094-16.711c14.197-14.466 27.482-36.453 36.837-62.721 9.3549-26.268 13.022-51.879 11.286-72.403s-8.9542-36.5-22.332-41.587zm-2.0367 5.7189c10.211 3.8825 16.864 17.056 18.5 36.386 1.6349 19.33-1.8357 44.253-10.93 69.788-9.094 25.535-22.086 46.838-35.457 60.463-13.371 13.624-26.712 19.229-36.923 15.347-10.212-3.8825-16.854-17.085-18.489-36.415s1.8356-44.253 10.93-69.788c9.0941-25.535 22.086-46.838 35.457-60.463s26.702-19.2 36.913-15.318z",
    fill: "#dae1e9",
    stroke: "#000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1152.1 808.8a3.9144 7.8287 20.303 0 1-7.3423-2.7164 3.9144 7.8287 20.303 1 1 7.3423 2.7164z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m983.66 744.31-1.0624 2.7812 167.19 62.406 1.0626-2.8125z",
    fill: "#fefefc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m973.91 751.99c0.6963 2.0495 2.9324 4.2949 7.6786-1.6072 4.0299-5.1532 4.441-8.8152 4.1071-14.107 0.1132-4.9815-3.5489-3.1757-4.8214-1.25z",
    fill: "#dbe2ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m969.98 749.85c1.6403 6.2508 7.9271 1.5699 11.072-3.2143 2.1421-5.0195 2.5367-10.018 1.7857-12.143-1.3337-3.5457-3.4288-3.9514-5.8929-1.4286z",
    fill: "#cdd6df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m953.6 728.82-2.8125 7.2321 19.375 13.795c5.4611-2.3403 9.6247-10.114 6.7857-16.786z",
    fill: "#dbe2ea",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m952.99 732.71a1.3073 4.357 20.847 1 1-2.4547-0.90097 1.3073 4.357 20.847 1 1 2.4547 0.90097z",
    fill: "#dbe2ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m872.52 876.84c-1.544 0.96145-3.9758-0.95005-5.4281-4.2667-1.4523-3.3167-1.378-6.7888 0.166-7.7503l4.6846-2.4737 5.0415 12.069z",
    fill: "#dee3e9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m877.33 866.59a6.5819 3.2496 69.057 1 1-5.5941 3.4835 6.5819 3.2496 69.057 0 1 5.5941-3.4835z",
    fill: "#d9e0e8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ecf0f3",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1305.4 1064.2a4.2858 4.2858 0 1 1-8.5715 0 4.2858 4.2858 0 1 1 8.5715 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1370.4 945.63a4.2858 4.2858 0 1 1-8.5715 0 4.2858 4.2858 0 1 1 8.5715 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1380.4 793.49a4.2858 4.2858 0 1 1-8.5715 0 4.2858 4.2858 0 1 1 8.5715 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1230.2 1159.7a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1024.2 870.21c-0.7219 0.0108-1.3337 0.53415-1.4561 1.2456s0.2793 1.4092 0.9561 1.6606l98.156 38.344c0.7767 0.302 1.6512-0.083 1.9532-0.8594 0.302-0.7767-0.083-1.6512-0.8594-1.9532l-98.156-38.312c-0.1874-0.0817-0.3894-0.12422-0.5938-0.125z",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1120.9 880.74 0.3571 34.643 3.9286 29.643 8.2143 24.643 14.643-1.7857-7.8572-23.572-2.8571-26.428v-35.714z",
    fill: "#dce2ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1172.3 851.46-51.429 28.929 16.429 4.2857 38.928-22.143z",
    fill: "#cad3de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1171.9 871.1-50.714 44.286 16.429 4.2857 38.571-34.286z",
    fill: "#cad3dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1174.4 889.67-49.643 55.357 16.071 3.2143 38.929-44.643z",
    fill: "#c9d3dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1172.3 851.46 16.428 3.9286-0.3571 18.214 2.5 18.214 2.8571 16.429-15.714-3.5714-3.5715-16.071-1.7857-18.214z",
    fill: "#dbe2e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1172.3 870.03 15.714 3.2143",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1174.4 887.53 16.072 3.5714",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1177.7 905.03-43.929 64.286 16.429 3.9286 43.929-64.643z",
    fill: "#c9d3dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1260.2 880.39 57.857 15c8.0722 1.5008 20.37 11.766 2.5 15.714l-47.143 10.714-24.286-7.4999c15.031-5.9149 11.712-19.717 11.071-33.929z",
    fill: "#e3e8ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1309.1 905.39-58.572 9.2857",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1262.1 646.46-7.3214 1.9643-1.7857 19.821 15.893 6.25 7.5-2.8571",
    fill: "#fdfffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1262.3 646.46 15.714 6.0714-1.7858 19.286-16.428-6.0714z",
    fill: "#fdfffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1259.6 665.39-6.7857 2.6786",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1325.5 783.78-22.143-8.3928-3.75 26.429 23.036 8.3928",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1146.2 984.2 59.544-80.889 111.22 41.194v7.4897l-75.272 74.149-95.494-34.827z",
    fill: "#a6b7c7",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1180.9 973.99-3.3203-14.23c-1.2881-4.5123 2.7529-9.6266 9.0203-11.416 6.2672-1.7891 12.399 0.4211 13.687 4.9334l3.0886 14.146",
    fill: "#cad4de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1134.1 1150.2 21.184 64.082-79.441-74.674-59.845-23.832 36.543-18.536z",
    fill: "#c9d3dd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1176.4 1000.9-6.1995-11.458c-1.542-2.8499 0.2038-6.9081 4.1256-9.1878s8.9689-0.275 10.613 2.517l5.7812 10.417",
    fill: "#cad4de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1202.7 991.22-1.9846-7.7586c-0.8197-3.2043 1.9302-6.7853 6.3789-8.0591 4.4487-1.2739 8.812 0.2688 9.7396 3.4436l1.8681 7.9659",
    fill: "#cad4de"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#c9d3dd",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1257 939.92a11.25 14.107 83.012 1 1-28.004 3.4328 11.25 14.107 83.012 1 1 28.004-3.4328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1257.9 943.85a11.25 14.107 83.012 1 1-28.005 3.4328 11.25 14.107 83.012 1 1 28.005-3.4328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1258.6 947.78a11.25 14.107 83.012 1 1-28.005 3.4327 11.25 14.107 83.012 1 1 28.005-3.4327z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1203.3 966.92a8.5012 11.807 74.068 1 1-22.708 6.4823 8.5012 11.807 74.068 1 1 22.708-6.4823z",
    fill: "#cad4de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1218.6 986.17a5.9917 8.3833 74.342 1 1-16.119 4.6155 5.9917 8.3833 74.342 1 1 16.119-4.6155z",
    fill: "#cad4de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1026.2 870.24a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z",
    fill: "#ecf0f3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m970.47 925.15c-0.4428-59.471 17.395-105.23 50.842-139.29",
    fill: "none",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1206.9 724.59 10.392 1.4043c3.5654 1.3595 3.7643 13.58-4.3066 13.107l-8.8941-5.2428",
    fill: "#b7c5d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1208.9 730.24a3.2457 4.7704 17.16 0 1-6.2024-1.9152 3.2457 4.7704 17.16 1 1 6.2024 1.9152z",
    fill: "#b7c5d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1221.1 625.73-45.313-8.5196 11.984 10.486 33.704 6.7408z",
    fill: "#cad4dd",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1151.2 685.94a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z",
    fill: "#ecf0f3",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1188.1 627.32-14.98 28.836-11.984 36.7-2.247 25.091-14.043 5.6173 2.4341-39.134 13.482-38.385 15.354-28.461z",
    fill: "#e2e8ed"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1160.4 646.04 53.177-1.498 0.3745 10.486-41.194 1.1235z",
    fill: "#c9d3dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160.4 694.35-12.733-9.7367 57.671-16.103-3.7449 15.354z",
    fill: "#c9d3dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1221.5 626.19 12.733 10.111-8.6132 17.601-10.111 25.465-7.9966 27.118-12.226-10.266 8.2387-26.963 9.3622-24.716z",
    fill: "#e3e8ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1195.6 696.22-51.679 27.338 13.107 11.609 50.666-28.658z",
    fill: "#c9d3dd"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1213.2 644.17 11.609 10.111",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1203.9 669.26 11.235 9.3622",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1079.8 931.24 15.888 5.8256-8.2089 18.007-15.888-6.8849z",
    fill: "#d1d8de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088.4 944.15a5.5592 3.2359 19.345 1 1-10.526-3.578 5.5592 3.2359 19.345 1 1 10.526 3.578z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069.5 951.1 15.358 7.1496-12.446 20.125-15.888-7.1496z",
    fill: "#d1d8de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1075.7 966.59a5.3442 3.3184 22.927 1 1-10.005-3.7109 5.3442 3.3184 22.927 1 1 10.005 3.7109z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1043.8 986.85 14.829 6.6201-14.829 15.358-14.299-6.62z",
    fill: "#d1d8de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1049.2 998.87a5.3442 3.3184 13.842 1 1-10.466-2.0845 5.3442 3.3184 13.842 1 1 10.466 2.0845z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1023.7 1008 13.24 5.8257-18.801 15.623-12.446-6.8848z",
    fill: "#d1d6dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1026.4 1019.1a4.8969 2.4528 8.9511 1 1-9.6739-1.5274 4.8969 2.4528 8.9511 1 1 9.6739 1.5274z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1134.6 824.53-17.742-7.4145-4.2369 22.508 16.947 7.4145z",
    fill: "#d1d8de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1128.2 834.74a5.4984 3.4283 33.945 1 1-9.4224-5.6199 5.4984 3.4283 33.945 1 1 9.4224 5.6199z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1134.9 821.08-16.947-6.6201 1.5888-18.007 16.947 6.3553z",
    fill: "#d1d8de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1131.4 810.68a5.6055 3.45 32.757 1 1-9.6407-5.6961 5.6055 3.45 32.757 1 1 9.6407 5.6961z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1135.2 758.33-16.153-6.0905 1.8536 23.567 16.418 6.6201z",
    fill: "#d1d8de",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1133.5 770.7a5.6055 3.45 32.757 1 1-9.6407-5.6961 5.6055 3.45 32.757 1 1 9.6407 5.6961z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1130.3 742.65a5.7103 3.4751 25.592 1 1-10.41-4.6843 5.7103 3.4751 25.592 1 1 10.41 4.6843z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "IP",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1197 568.99 15.822 7.0216 26.589-17.975-20.597-9.1749z",
    fill: "#cad4de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1273.9 579.58-29.393 40.25-33.895-37.072-0.2648-9.0033 22.773-14.829 41.574 16.153z",
    fill: "#b7c5d0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1278.4 556.28-56.668-21.449-23.303 15.359-1.5888 18.801 23.038-15.094 57.197 21.979z",
    fill: "#e3e8ec"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1260.7 573.49-15.888 27.539",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1210.6 577.73 22.508-14.299 23.832 9.2681",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1263.2 563.09 18.724 6.928c-0.6156 4.1861-3.0139 7.4808-8.6132 9.175l-19.099-6.928c5.2296-1.9415 8.7401-4.7425 8.9877-9.175z",
    fill: "#c9d4dd",
    fillRule: "evenodd",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1221.5 535.36-1.5888 18.271",
    fill: "#c9d4dd",
    fillRule: "evenodd",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1216.2 616.92c1.9942-13.99 9.6263-22.614 21.714-20.655l42.368 13.505c8.0757 3.7227 7.6682 19.285 1.9633 29.891z",
    fill: "#dbe2ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1216.8 616.27c-3.636-1.2819-6.2781 4.1215-2.247 6.3663l64.974 23.031c3.7485 1.3644 5.0545-5.1806 2.0597-6.3663z",
    fill: "#fcfcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1281.5 610.23c-12.366-3.4908-20.084 12.571-21.252 21.58",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1294.8 577.99-2.3832 18.007",
    fill: "#dce2ea",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ecf0f3",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1035 1116.9c-0.5049 0.023-0.9644 0.2979-1.2226 0.7324-0.2581 0.4344-0.2802 0.9697-0.059 1.4239l102.78 227.16c0.1971 0.5263 0.6718 0.8983 1.23 0.9638 0.5581 0.066 1.1061-0.1864 1.4197-0.6527s0.3403-1.0689 0.069-1.5611l-102.78-227.16c-0.2454-0.5705-0.8169-0.9309-1.4375-0.9063z",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1059.3 1128.7c-0.4767 0.028-0.9114 0.2822-1.1706 0.6833s-0.3119 0.9016-0.142 1.3479l78.25 214.5c0.1621 0.5317 0.6049 0.9302 1.1506 1.0355 0.5458 0.1053 1.1051-0.1 1.4534-0.5329 0.3483-0.4331 0.4286-1.0234 0.2086-1.5338l-78.25-214.5c-0.2216-0.6301-0.8331-1.0378-1.5-1z",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1142.8 1347a4.2857 4.2857 0 1 1-8.5714 0 4.2857 4.2857 0 1 1 8.5714 0z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1122.3 1354.1 46.428-19.822 42.5 17.5-5.7142 18.929-64.464-8.2143z",
    fill: "#b8c5d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1138.4 1379.7 41.786-18.572 30 12.5-41.786 18.214z",
    fill: "#c9d3dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1138 1379.7 1.4285-18.929 41.072-17.5-0.7143 17.857h0.3571z",
    fill: "#e3e8ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1180.6 1343.3 30.231 11.764-0.3815 18.63-30.542-12.559z",
    fill: "#e3e8ed"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m947.33 1020.7 6.7408 6.3663 7.3025 2.9959-3.7449 8.8004-7.8642 0.3745-5.0556-5.0556z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m944.71 1034 8.0515-0.5617 1.4979-6.3663",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m957.44 1038.7-4.6811-5.0556",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1048.1 1009.7 83.511 34.078 68.906 158.78-96.992-67.408-63.288-23.593z",
    fill: "#e3e8ec",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1183.9 1002.5c-0.4499 0.029-0.8629 0.2582-1.125 0.625l-68.312 89.375-38.281-84.219c-0.3452-0.7594-1.2406-1.0952-2-0.75s-1.0952 1.2406-0.75 2l39.344 86.5 2.5625 0.2813 69.812-91.375c0.3707-0.4614 0.4355-1.0975 0.1654-1.6241-0.27-0.5267-0.8244-0.8453-1.4154-0.8135z",
    fill: "#fefefe",
    fillRule: "evenodd",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1118.2 1092.9a4.2858 4.2858 0 1 1-8.5715 0 4.2858 4.2858 0 1 1 8.5715 0z",
    fill: "#ecf0f3"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1316.6 952-111.6-41.568-58.42 80.889",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1205 910.43 0.749-7.1152",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1276.5 937.77-61.042 75.646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1148.4 989.07 95.12 34.453"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1181.8 942.81 103.88 40.023 2.2191-2.4154-104.26-40.046z",
    fill: "#ccd5dc",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1204 912.12 36.079 113.63 2.875-0.9063-36.11-113.66z",
    fill: "#ccd5dc",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1190.5 992.56a5.8699 8.218 60.174 1 1-14.209 8.2597 5.8699 8.218 60.174 1 1 14.209-8.2597z",
    fill: "#cad4de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1131.2 1044.9 5.9918-14.98-46.811-18.35-4.8683 13.107z",
    fill: "#b7c5d1",
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1042.8 1073.7 121.33 45.313",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1071.2 1018.9 53.462-76.413-2.5517-20.815-63.224 92.197z",
    fill: "#e2e9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1123.4 933.15-59.087 83.097",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1017.8 1055.4 30.893-45.714-8.5714 101.79-24.286 5z",
    fill: "#c9d3dd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1469.2 662.8a6.3583 8.5429 52.054 1 1-14.24 9.3614 6.3583 8.5429 52.054 1 1 14.24-9.3614z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1469.3 664.03a5.6903 7.6353 51.509 1 1-12.7 8.3958 5.6903 7.6353 51.509 1 1 12.7-8.3958z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HVM",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e1d355"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2234.7 297.99c-0.3189 0.0471-0.6262 0.15306-0.9063 0.3125l-916.78 491.59c-1.2685 0.68174-1.7442 2.2628-1.0625 3.5313 0.6818 1.2685 2.2628 1.7442 3.5313 1.0625l916.78-491.59c1.1666-0.56231 1.7416-1.8974 1.3486-3.1314-0.3929-1.234-1.6341-1.9907-2.911-1.7749z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1499.1 691.53c0.372 2.7942-0.065 3.7536 3.2831 5.5558-2.0058 5.9838-8.0204 5.9568-11.743 6.0609-2.6627 0.34276-4.3891-3.0279-3.6618-5.0508 3.3605-3.856 6.8502-8.1248 12.122-6.566z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1933.4 459.57 2.3991 4.2932c1.6347 7.9946-4.396 6.482-12.627 6.8185-2.0281-0.98277-2.9802-2.4267-2.6517-4.4194 4.9882-5.8902 6.0816-10.819 12.88-6.6923z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1924.7 461.34c-0.2574 4.0034 2.4976 6.5095 4.5457 8.2075",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "labels",
    transform: "translate(-654.3,-118.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text",
    display: "none",
    fill: "#000000",
    fontFamily: "'DejaVu Sans'",
    fontSize: "56px",
    fontStretch: "semi-condensed"
  }, /*#__PURE__*/React.createElement("text", {
    x: 1773.8276,
    y: 1190.5469,
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1773.8276,
    y: 1190.5469,
    fontFamily: "'DejaVu Sans'",
    fontSize: "56px",
    fontStretch: "semi-condensed",
    style: {
      lineHeight: "125%"
    }
  }, "Trapped Radiation Detector")), /*#__PURE__*/React.createElement("text", {
    x: 1773.8276,
    y: 1282.5469,
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1773.8276,
    y: 1282.5469,
    fontFamily: "'DejaVu Sans'",
    fontSize: "56px",
    fontStretch: "semi-condensed",
    style: {
      lineHeight: "125%"
    }
  }, "Cosmic Ray Telescope")), /*#__PURE__*/React.createElement("text", {
    x: 1773.8276,
    y: 1382.5469,
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1773.8276,
    y: 1382.5469,
    fontFamily: "'DejaVu Sans'",
    fontSize: "56px",
    fontStretch: "semi-condensed",
    style: {
      lineHeight: "125%"
    }
  }, "Infrared Radiometer")), /*#__PURE__*/React.createElement("text", {
    x: 1773.8276,
    y: 1502.5469,
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1773.8276,
    y: 1502.5469,
    fontFamily: "'DejaVu Sans'",
    fontSize: "56px",
    fontStretch: "semi-condensed",
    style: {
      lineHeight: "125%"
    }
  }, "Charged Particle Instrument")), /*#__PURE__*/React.createElement("text", {
    x: 1773.8276,
    y: 142.54688,
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1773.8276,
    y: 142.54688,
    fontFamily: "'DejaVu Sans'",
    fontSize: "56px",
    fontStretch: "semi-condensed",
    style: {
      lineHeight: "125%"
    }
  }, "Geiger Tube Telescope")), /*#__PURE__*/React.createElement("text", {
    x: 1772.6519,
    y: 242.54688,
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1772.6519,
    y: 242.54688,
    fontFamily: "'DejaVu Sans'",
    fontSize: "56px",
    fontStretch: "semi-condensed",
    style: {
      lineHeight: "125%"
    }
  }, "Meteoroid Detector Sensor Panel")), /*#__PURE__*/React.createElement("text", {
    x: 720.40906,
    y: 342.13684,
    "text-align": "end",
    textAnchor: "end",
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 720.40906,
    y: 342.13684,
    fontFamily: "'DejaVu Sans'",
    fontSize: "56px",
    fontStretch: "semi-condensed",
    "text-align": "end",
    textAnchor: "end",
    style: {
      lineHeight: "125%"
    }
  }, "Ultraviolet Photometer")), /*#__PURE__*/React.createElement("text", {
    x: 544.52344,
    y: 784.13684,
    "text-align": "end",
    textAnchor: "end",
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 544.52344,
    y: 784.13684,
    "text-align": "end",
    style: {
      lineHeight: "125%"
    }
  }, "Asteroid\u2013Meteoroid"), /*#__PURE__*/React.createElement("tspan", {
    x: 544.52344,
    y: 854.13684,
    "text-align": "end",
    style: {
      lineHeight: "125%"
    }
  }, "Detector Sensor"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "leader-lines",
    display: "none",
    fill: "none",
    stroke: "#ea1414",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1751.4 1181.6h-170.77l-301.09-323.56",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1754.4 1271.4h-133.32l-295.1-320.56",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1757.4 1364.3h-133.32l-380.48-413.43",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1758.8 1481.1h-133.32l-437.78-478.22",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m567.97 772.62h74.145l146.17 141.93",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745.91 321.4h76.263l372.84 402.5",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1754.3 132.86h-67.79l-417.33 525.37",
    display: "inline"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1754.3 221.84h-40.25l-273.28 349.54",
    display: "inline"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "In-Use"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Label-MA"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1576.1 817.56 77.893-74.897h97.367",
    fill: "none",
    stroke: "#f44336",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "Main Antenna"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1786.7 716.67 14.255 35.578 14.255-35.578h7.457v43.604h-5.75v-16.98l0.5391-18.328-14.315 35.309h-4.4023l-14.285-35.219 0.569 18.238v16.98h-5.75v-43.604z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1852 760.28q-0.4792-0.95834-0.7787-3.4141-3.8632 4.013-9.2239 4.013-4.7917 0-7.8763-2.6953-3.0547-2.7253-3.0547-6.888 0-5.0612 3.8333-7.8464 3.8633-2.8151 10.841-2.8151h5.3906v-2.5456q0-2.905-1.737-4.612-1.737-1.737-5.1211-1.737-2.9648 0-4.9713 1.4974t-2.0065 3.6237h-5.5703q0-2.4258 1.707-4.6719 1.737-2.276 4.6719-3.5937 2.9648-1.3177 6.4987-1.3177 5.6002 0 8.7747 2.8151 3.1745 2.7852 3.2943 7.6966v14.914q0 4.4622 1.138 7.0976v0.47917zm-9.194-4.2227q2.6054 0 4.9414-1.3476 2.3359-1.3477 3.3841-3.5039v-6.6484h-4.3425q-10.182 0-10.182 5.9596 0 2.6055 1.7369 4.0729 1.737 1.4674 4.4623 1.4674z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1871.4 760.28h-5.5404v-32.404h5.5404zm-5.9896-40.999q0-1.3477 0.8086-2.276 0.8385-0.92839 2.4557-0.92839t2.4557 0.92839q0.8386 0.92838 0.8386 2.276 0 1.3476-0.8386 2.2461-0.8385 0.89844-2.4557 0.89844t-2.4557-0.89844q-0.8086-0.89844-0.8086-2.2461z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m1885.5 727.88 0.1797 4.0729q3.7135-4.6719 9.7031-4.6719 10.272 0 10.362 11.59v21.413h-5.5404v-21.443q-0.03-3.5039-1.6172-5.181-1.5573-1.6771-4.8815-1.6771-2.6953 0-4.7318 1.4375-2.0364 1.4375-3.1744 3.7734v23.09h-5.5404v-32.404z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1954.3 748.9h-18.268l-4.1028 11.38h-5.9297l16.651-43.604h5.0313l16.681 43.604h-5.8998zm-16.531-4.7318h14.824l-7.427-20.395z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m1974.6 727.88 0.1797 4.0729q3.7136-4.6719 9.7031-4.6719 10.272 0 10.362 11.59v21.413h-5.5403v-21.443q-0.03-3.5039-1.6172-5.181-1.5573-1.6771-4.8815-1.6771-2.6954 0-4.7318 1.4375-2.0365 1.4375-3.1745 3.7734v23.09h-5.5403v-32.404z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m2010.8 720.03v7.8464h6.0495v4.2826h-6.0495v20.095q0 1.9466 0.8086 2.9349 0.8086 0.95834 2.7552 0.95834 0.9583 0 2.6354-0.35938v4.4922q-2.1862 0.59895-4.2526 0.59895-3.7135 0-5.6002-2.2461-1.8868-2.2461-1.8868-6.3789v-20.095h-5.8997v-4.2826h5.8997v-7.8464z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m2036.7 760.88q-6.5886 0-10.721-4.3125-4.1328-4.3424-4.1328-11.59v-1.0182q0-4.8216 1.8268-8.595 1.8568-3.8034 5.1511-5.9297 3.3242-2.1562 7.1875-2.1562 6.319 0 9.8229 4.1628t3.5039 11.919v2.306h-21.952q0.1198 4.7917 2.7851 7.7565 2.6953 2.9349 6.8282 2.9349 2.9349 0 4.9713-1.1979 2.0365-1.1979 3.5638-3.1745l3.3841 2.6354q-4.0729 6.2591-12.219 6.2591zm-0.6888-29.049q-3.3542 0-5.6302 2.4557-2.2761 2.4258-2.8151 6.8281h16.232v-0.41927q-0.2396-4.2227-2.276-6.5286-2.0365-2.3359-5.5104-2.3359z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m2061 727.88 0.1797 4.0729q3.7135-4.6719 9.7031-4.6719 10.272 0 10.362 11.59v21.413h-5.5404v-21.443q-0.03-3.5039-1.6172-5.181-1.5573-1.6771-4.8815-1.6771-2.6953 0-4.7318 1.4375-2.0364 1.4375-3.1744 3.7734v23.09h-5.5404v-32.404z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m2094.9 727.88 0.1797 4.0729q3.7135-4.6719 9.7031-4.6719 10.272 0 10.362 11.59v21.413h-5.5404v-21.443q-0.03-3.5039-1.6172-5.181-1.5572-1.6771-4.8815-1.6771-2.6953 0-4.7317 1.4375-2.0365 1.4375-3.1745 3.7734v23.09h-5.5404v-32.404z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m2143.6 760.28q-0.4791-0.95834-0.7786-3.4141-3.8633 4.013-9.224 4.013-4.7916 0-7.8763-2.6953-3.0547-2.7253-3.0547-6.888 0-5.0612 3.8334-7.8464 3.8633-2.8151 10.841-2.8151h5.3906v-2.5456q0-2.905-1.7369-4.612-1.737-1.737-5.1211-1.737-2.9649 0-4.9714 1.4974t-2.0065 3.6237h-5.5703q0-2.4258 1.707-4.6719 1.737-2.276 4.6719-3.5937 2.9648-1.3177 6.4987-1.3177 5.6003 0 8.7747 2.8151 3.1745 2.7852 3.2943 7.6966v14.914q0 4.4622 1.138 7.0976v0.47917zm-9.194-4.2227q2.6055 0 4.9414-1.3476 2.336-1.3477 3.3841-3.5039v-6.6484h-4.3424q-10.182 0-10.182 5.9596 0 2.6055 1.737 4.0729t4.4622 1.4674z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m1773.8 705.98h381v65h-381z",
    strokeWidth: 0.65644
  })), /*#__PURE__*/React.createElement("g", {
    className: "captionText",
    transform: "translate(5.2652,-10.032)",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      inlineSize: 965.032,
      whiteSpace: "pre"
    },
    "aria-label": "The spacecraft is spin stabilized around the 2.74 meter diameter hexagonal high gain antenna"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1794.6 795.03h-8.6588v21.37h-3.2226v-21.37h-8.6587v-2.8646h20.54z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1812.8 816.4h-3.0599v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1718-1.0091-0.765-0.3418-1.9857-0.3418-1.2532 0-2.6204 0.61849-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4322-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.946 0 4.4922 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1833.9 807.62h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78124 2.002 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7271-0.73241 1.888-0.7487 2.6856-1.4648h0.1627v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0637-2.4414-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4252-7.08 2.4413-2.6204 6.4126-2.6204 3.6784 0 5.6641 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1863.3 811.16q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.1627q1.4486 1.0905 3.2226 1.7415 1.7741 0.63475 3.4017 0.63475 2.0182 0 3.1575-0.65103 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.6185-1.6276-0.6184-0.55338-2.3762-0.944-0.6511-0.14648-1.709-0.34179-1.0417-0.19531-1.9043-0.42318-2.3925-0.63476-3.4016-1.8554-0.9929-1.237-0.9929-3.0273 0-1.123 0.4558-2.1159 0.472-0.99283 1.416-1.7741 0.9114-0.76497 2.3111-1.2044 1.416-0.45572 3.1576-0.45572 1.6275 0 3.2877 0.40689 1.6764 0.39062 2.7832 0.96028v3.2714h-0.1628q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63475-1.1556 1.9043 0 1.123 0.6999 1.6927 0.6835 0.56966 2.2135 0.92773 0.8463 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1883.7 807.09q0 2.2135-0.6348 4.0527-0.6347 1.8229-1.7903 3.0924-1.0742 1.2044-2.5391 1.8717-1.4485 0.65103-3.0761 0.65103-1.416 0-2.5716-0.30924-1.1393-0.30924-2.3275-0.96028v7.6171h-3.0598v-24.886h3.0598v1.9043q1.2207-1.0254 2.7344-1.709 1.5299-0.69986 3.2552-0.69986 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1576 0.0814q0-3.2877-1.123-4.9153t-3.4505-1.6276q-1.3183 0-2.6529 0.56966-1.3347 0.56966-2.5554 1.4974v10.303q1.3021 0.58593 2.2298 0.79752 0.944 0.21159 2.1322 0.21159 2.5553 0 3.9876-1.7252 1.4322-1.7252 1.4322-5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1902.6 816.4h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6836 0.48828-1.3346 0.78125-0.765 0.37434-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1667-1.6276-1.7089-1.6276-1.7089-4.1504 0-2.067 0.8789-3.3366 0.8951-1.2858 2.539-2.0182 1.6601-0.73241 3.9876-0.99283 2.3274-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3744-1.7252-0.358-0.68359-1.0416-1.0742-0.6511-0.37434-1.5625-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1627v-3.1087q0.8951-0.24414 2.5878-0.53711 1.6927-0.29296 3.3366-0.29296 1.9205 0 3.3365 0.32551 1.4323 0.30924 2.474 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24413-1.888 0.16276-2.9948 0.472-1.3183 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3347-0.63476 2.474-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1921.9 815.26q-1.53 0.73241-2.9134 1.1393-1.3672 0.4069-2.9134 0.4069-1.9694 0-3.6132-0.56966-1.6439-0.58593-2.8158-1.7578-1.1881-1.1719-1.8391-2.9622-0.6511-1.7904-0.6511-4.1829 0-4.4596 2.4414-6.9986 2.4577-2.539 6.4778-2.539 1.5625 0 3.0599 0.43945 1.5136 0.43945 2.7669 1.0742v3.4017h-0.1628q-1.3997-1.0905-2.8971-1.6764-1.4811-0.58593-2.8971-0.58593-2.6041 0-4.1178 1.7578-1.4974 1.7415-1.4974 5.1269 0 3.2877 1.4648 5.0618 1.4811 1.7578 4.1504 1.7578 0.9277 0 1.888-0.24414t1.7252-0.63476q0.6673-0.34179 1.2533-0.71614 0.5859-0.39062 0.9277-0.66731h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1941.1 807.62h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78124 2.002 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7271-0.73241 1.888-0.7487 2.6856-1.4648h0.1627v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0637-2.4414-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1959.2 815.26q-1.53 0.73241-2.9134 1.1393-1.3672 0.4069-2.9134 0.4069-1.9694 0-3.6132-0.56966-1.6439-0.58593-2.8158-1.7578-1.1881-1.1719-1.8391-2.9622-0.6511-1.7904-0.6511-4.1829 0-4.4596 2.4414-6.9986 2.4577-2.539 6.4778-2.539 1.5625 0 3.0599 0.43945 1.5136 0.43945 2.7669 1.0742v3.4017h-0.1628q-1.3997-1.0905-2.8971-1.6764-1.4811-0.58593-2.8971-0.58593-2.6041 0-4.1178 1.7578-1.4974 1.7415-1.4974 5.1269 0 3.2877 1.4649 5.0618 1.4811 1.7578 4.1503 1.7578 0.9277 0 1.888-0.24414t1.7252-0.63476q0.6674-0.34179 1.2533-0.71614 0.5859-0.39062 0.9277-0.66731h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1974.5 801.55h-0.1627q-0.6836-0.16276-1.3346-0.22786-0.6348-0.0814-1.5137-0.0814-1.416 0-2.7344 0.63476-1.3183 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.61849 2.8482-0.61849 0.7976 0 1.1556 0.0488 0.3581 0.0326 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1991.5 816.4h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6836 0.48828-1.3346 0.78125-0.765 0.37434-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1667-1.6276-1.7089-1.6276-1.7089-4.1504 0-2.067 0.8789-3.3366 0.8951-1.2858 2.539-2.0182 1.6601-0.73241 3.9876-0.99283 2.3274-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3744-1.7252-0.358-0.68359-1.0416-1.0742-0.6511-0.37434-1.5625-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1627v-3.1087q0.8951-0.24414 2.5878-0.53711 1.6927-0.29296 3.3366-0.29296 1.9205 0 3.3365 0.32551 1.4323 0.30924 2.474 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24413-1.888 0.16276-2.9948 0.472-1.3183 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3347-0.63476 2.474-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2007.2 794.03h-0.1628q-0.5045-0.14648-1.3183-0.29296-0.8138-0.16276-1.4323-0.16276-1.9694 0-2.8645 0.8789-0.8789 0.86262-0.8789 3.1412v0.61848h5.5175v2.5716h-5.4199v15.609h-3.0598v-15.609h-2.0671v-2.5716h2.0671v-0.6022q0-3.2389 1.6113-4.9642 1.6113-1.7415 4.6549-1.7415 1.0254 0 1.8391 0.0977 0.8301 0.0977 1.5137 0.22786z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2018.6 816.23q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.065 2.2461 0.065 0.79751 0.4557 1.4974 0.3581 0.65103 0.9766 0.96027 0.6347 0.29297 1.9205 0.29297 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37434h0.1627z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2037.3 795.17h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2056.2 811.16q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.1627q1.4486 1.0905 3.2227 1.7415 1.774 0.63475 3.4016 0.63475 2.0182 0 3.1575-0.65103 1.1394-0.65104 1.1394-2.0508 0-1.0742-0.6185-1.6276t-2.3763-0.944q-0.651-0.14648-1.709-0.34179-1.0416-0.19531-1.9042-0.42318-2.3926-0.63476-3.4017-1.8554-0.9928-1.237-0.9928-3.0273 0-1.123 0.4557-2.1159 0.472-0.99283 1.416-1.7741 0.9114-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.40689 1.6764 0.39062 2.7832 0.96028v3.2714h-0.1628q-1.1718-0.86262-2.8482-1.4486-1.6765-0.60221-3.2878-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63475-1.1556 1.9043 0 1.123 0.6999 1.6927 0.6836 0.56966 2.2135 0.92773 0.8464 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1322 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2085.3 811.16q0 2.4902-2.0671 4.0852-2.0507 1.595-5.6151 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8158-1.0579v-3.4342h0.1628q1.4486 1.0905 3.2226 1.7415 1.7741 0.63475 3.4017 0.63475 2.0182 0 3.1575-0.65103 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.6185-1.6276t-2.3762-0.944q-0.6511-0.14648-1.709-0.34179-1.0417-0.19531-1.9043-0.42318-2.3925-0.63476-3.4016-1.8554-0.9929-1.237-0.9929-3.0273 0-1.123 0.4557-2.1159 0.472-0.99283 1.416-1.7741 0.9115-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2878 0.40689 1.6764 0.39062 2.7831 0.96028v3.2714h-0.1627q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63475-1.1556 1.9043 0 1.123 0.6999 1.6927 0.6835 0.56966 2.2135 0.92773 0.8463 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2105.7 807.09q0 2.2135-0.6348 4.0527-0.6348 1.8229-1.7904 3.0924-1.0742 1.2044-2.539 1.8717-1.4485 0.65103-3.0761 0.65103-1.416 0-2.5716-0.30924-1.1393-0.30924-2.3275-0.96028v7.6171h-3.0598v-24.886h3.0598v1.9043q1.2207-1.0254 2.7344-1.709 1.5299-0.69986 3.2552-0.69986 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1576 0.0814q0-3.2877-1.123-4.9153t-3.4505-1.6276q-1.3183 0-2.653 0.56966-1.3346 0.56966-2.5553 1.4974v10.303q1.3021 0.58593 2.2298 0.79752 0.944 0.21159 2.1322 0.21159 2.5553 0 3.9876-1.7252 1.4322-1.7252 1.4322-5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2113.7 795.17h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0598v-18.18h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2134.8 816.4h-3.0599v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1718-1.0091-0.765-0.3418-1.9857-0.3418-1.2532 0-2.6204 0.61849-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4322-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.9459 0 4.4922 1.7741 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2165.4 811.16q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.1627q1.4486 1.0905 3.2227 1.7415 1.774 0.63475 3.4016 0.63475 2.0182 0 3.1575-0.65103 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.6184-1.6276-0.6185-0.55338-2.3763-0.944-0.6511-0.14648-1.709-0.34179-1.0416-0.19531-1.9043-0.42318-2.3925-0.63476-3.4016-1.8554-0.9929-1.237-0.9929-3.0273 0-1.123 0.4558-2.1159 0.472-0.99283 1.416-1.7741 0.9114-0.76497 2.3111-1.2044 1.416-0.45572 3.1576-0.45572 1.6276 0 3.2877 0.40689 1.6764 0.39062 2.7832 0.96028v3.2714h-0.1628q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63475-1.1556 1.9043 0 1.123 0.6999 1.6927 0.6836 0.56966 2.2135 0.92773 0.8463 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2179.3 816.23q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.065 2.2461 0.065 0.79751 0.4557 1.4974 0.3581 0.65103 0.9766 0.96027 0.6347 0.29297 1.9205 0.29297 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37434h0.1627z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2197.1 816.4h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6835 0.48828-1.3346 0.78125-0.7649 0.37434-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1667-1.6276-1.7089-1.6276-1.7089-4.1504 0-2.067 0.8789-3.3366 0.8952-1.2858 2.539-2.0182 1.6602-0.73241 3.9876-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37434-1.5625-0.50455-0.9114-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0598 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.53711 1.6927-0.29296 3.3365-0.29296 1.9206 0 3.3366 0.32551 1.4322 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24413-1.888 0.16276-2.9948 0.472-1.3183 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.946-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2219 807.17q0 2.2786-0.651 4.1015-0.6348 1.8229-1.7253 3.0599-1.1556 1.2858-2.539 1.9368-1.3835 0.63476-3.0436 0.63476-1.5462 0-2.7018-0.37434-1.1556-0.35807-2.2786-0.97655l-0.1953 0.84634h-2.8646v-25.325h3.0599v9.0494q1.2858-1.0579 2.7343-1.7252 1.4486-0.68359 3.2552-0.68359 3.2226 0 5.0781 2.4739 1.8717 2.4739 1.8717 6.9824zm-3.1575 0.0814q0-3.2552-1.0742-4.9316-1.0742-1.6927-3.4668-1.6927-1.3346 0-2.7018 0.58594-1.3672 0.56965-2.539 1.4811v10.417q1.302 0.58594 2.2298 0.8138 0.944 0.22786 2.1321 0.22786 2.539 0 3.9713-1.6601 1.4486-1.6764 1.4486-5.2408z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2227.1 795.17h-3.4504v-3.1738h3.4504zm-0.1953 21.224h-3.0598v-18.18h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2236.1 816.4h-3.0598v-25.325h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2245.4 795.17h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0598v-18.18h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2264.5 816.4h-14.681v-2.2624l10.596-13.362h-10.368v-2.5553h14.176v2.181l-10.644 13.411h10.921z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2284.1 807.62h-13.395q0 1.6764 0.5046 2.9297 0.5046 1.237 1.3834 2.0345 0.8464 0.78124 2.002 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7271-0.73241 1.888-0.7487 2.6856-1.4648h0.1627v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4413-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4485 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2303.4 816.4h-3.0599v-1.9043q-1.3183 1.1393-2.7506 1.7741t-3.1087 0.63476q-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.651-4.1178 0.6673-1.8066 1.7904-3.0761 1.1067-1.237 2.5715-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29297 2.3275 0.92773v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.55338-2.2135-0.76497-0.9766-0.21159-2.1322-0.21159-2.5716 0-4.0038 1.7904-1.4323 1.7904-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1067 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56965 1.3346-0.58594 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2335.3 816.4h-3.0435v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6836 0.48828-1.3346 0.78125-0.765 0.37434-1.7578 0.61848-0.9929 0.26041-2.3275 0.26041-2.4576 0-4.1666-1.6276-1.709-1.6276-1.709-4.1504 0-2.067 0.8789-3.3366 0.8952-1.2858 2.5391-2.0182 1.6601-0.73241 3.9876-0.99283 2.3274-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3744-1.7252-0.3581-0.68359-1.0416-1.0742-0.6511-0.37434-1.5625-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.53711 1.6927-0.29296 3.3366-0.29296 1.9205 0 3.3365 0.32551 1.4323 0.30924 2.474 1.0742 1.0253 0.74869 1.5624 1.9368t0.5371 2.9459zm-3.0435-4.4759v-5.0618q-1.3998 0.0814-3.304 0.24413-1.8881 0.16276-2.9948 0.472-1.3184 0.37435-2.1322 1.1719-0.8137 0.78124-0.8137 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.474-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2352.6 801.55h-0.1627q-0.6836-0.16276-1.3346-0.22786-0.6348-0.0814-1.5137-0.0814-1.416 0-2.7343 0.63476-1.3184 0.61848-2.5391 1.6113v12.907h-3.0598v-18.18h3.0598v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.61849 2.8483-0.61849 0.7975 0 1.1555 0.0488 0.3581 0.0326 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2371 807.32q0 4.4433-2.2786 7.0149-2.2787 2.5716-6.1035 2.5716-3.8574 0-6.136-2.5716-2.2623-2.5716-2.2623-7.0149 0-4.4433 2.2623-7.0149 2.2786-2.5879 6.136-2.5879 3.8248 0 6.1035 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3835-5.2408-1.3834-1.7252-3.8411-1.7252-2.4902 0-3.8736 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3834 5.192 1.3835 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3998-1.7578 1.3998-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2390.8 816.4h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717-1.416 0.65103-3.1249 0.65103-2.8646 0-4.4596-1.7415-1.5951-1.7578-1.5951-5.1432v-11.8h3.0599v10.351q0 1.3834 0.1302 2.3763 0.1302 0.97655 0.5534 1.6764 0.4394 0.71614 1.1393 1.0416 0.6999 0.32552 2.0345 0.32552 1.1881 0 2.5878-0.61848 1.4161-0.61849 2.6367-1.5788v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2412 816.4h-3.0598v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.765-0.3418-1.9857-0.3418-1.2532 0-2.6204 0.61849-1.3671 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554 1.53-0.66731 3.1413-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2432.7 816.4h-3.0599v-1.9043q-1.3183 1.1393-2.7506 1.7741t-3.1087 0.63476q-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.651-4.1178 0.6673-1.8066 1.7904-3.0761 1.1067-1.237 2.5715-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29297 2.3275 0.92773v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.55338-2.2135-0.76497-0.9766-0.21159-2.1322-0.21159-2.5716 0-4.0038 1.7904-1.4323 1.7904-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1067 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56965 1.3346-0.58594 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2459.8 816.23q-0.8627 0.22786-1.888 0.37435-1.0091 0.14648-1.8067 0.14648-2.7831 0-4.2317-1.4974-1.4485-1.4974-1.4485-4.8014v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.79751 0.4557 1.4974 0.3581 0.65103 0.9766 0.96027 0.6348 0.29297 1.9206 0.29297 0.7486 0 1.5624-0.21159 0.8138-0.22786 1.1719-0.37434h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2478.8 816.4h-3.0599v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.7649-0.3418-1.9856-0.3418-1.2533 0-2.6204 0.61849-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4322-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.9459 0 4.4922 1.7741 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2499.9 807.62h-13.395q0 1.6764 0.5045 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8555 0 3.7272-0.73241 1.888-0.7487 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6114 0.43944-3.3854 0.43944-4.5247 0-7.0638-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9784-2.3437q-0.016-2.4088-1.2207-3.7272-1.1882-1.3184-3.6296-1.3184-2.4576 0-3.9224 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2532.2 816.4h-16.406v-3.4017q1.7089-1.4648 3.4179-2.9297 1.7252-1.4648 3.2064-2.9134 3.1249-3.0273 4.2805-4.8014 1.1556-1.7904 1.1556-3.8574 0-1.888-1.2532-2.9459-1.237-1.0742-3.4668-1.0742-1.4811 0-3.2064 0.52083-1.7252 0.52083-3.3691 1.595h-0.1627v-3.4179q1.1556-0.56965 3.0761-1.0416 1.9368-0.47201 3.7435-0.47201 3.7271 0 5.843 1.8066 2.1159 1.7903 2.1159 4.8665 0 1.3834-0.3581 2.5879-0.3418 1.1881-1.0254 2.2624-0.6347 1.0091-1.4974 1.9856-0.8463 0.97656-2.067 2.1647-1.7415 1.709-3.597 3.3203-1.8554 1.595-3.4667 2.9622h13.037z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2542.4 816.4h-3.8899v-4.6386h3.8899z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2565.6 795.79-10.97 20.605h-3.483l11.67-21.386h-13.802v-2.8483h16.585z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2587.4 809.58h-3.597v6.8196h-3.1249v-6.8196h-11.605v-3.7434l11.735-13.672h2.9947v14.811h3.597zm-6.7219-2.6041v-10.937l-9.3912 10.937z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2630.3 816.4h-3.0598v-10.351q0-1.1719-0.114-2.2624-0.098-1.0905-0.4394-1.7415-0.3744-0.69987-1.0742-1.0579-0.6999-0.35807-2.0182-0.35807-1.2858 0-2.5716 0.65104-1.2858 0.63476-2.5716 1.6276 0.049 0.37434 0.081 0.87889 0.032 0.48828 0.032 0.97656v11.637h-3.0599v-10.351q0-1.2044-0.1139-2.2786-0.098-1.0905-0.4394-1.7415-0.3744-0.69986-1.0742-1.0417-0.6999-0.35807-2.0183-0.35807-1.2532 0-2.5227 0.61849-1.2533 0.61848-2.5065 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.8483-1.8554 1.4323-0.66731 3.0436-0.66731 1.8554 0 3.1412 0.78124 1.3021 0.78125 1.9368 2.1647 1.8555-1.5625 3.3854-2.2461 1.53-0.69986 3.2715-0.69986 2.9947 0 4.4107 1.8229 1.4323 1.8066 1.4323 5.0618z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2651.4 807.62h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8555 0 3.7272-0.73241 1.888-0.7487 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0638-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1882-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2665.4 816.23q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2318-1.4974-1.4485-1.4974-1.4485-4.8014v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.79751 0.4558 1.4974 0.358 0.65103 0.9765 0.96027 0.6348 0.29297 1.9206 0.29297 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1718-0.37434h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2684.4 807.62h-13.395q0 1.6764 0.5045 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78124 2.0019 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.7487 2.6855-1.4648h0.1627v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4413-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4485 1.4486-1.6438 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2700.4 801.55h-0.1628q-0.6835-0.16276-1.3346-0.22786-0.6347-0.0814-1.5136-0.0814-1.416 0-2.7344 0.63476-1.3183 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2063-2.067 1.3998-0.61849 2.8483-0.61849 0.7975 0 1.1556 0.0488 0.3581 0.0326 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.7577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1791.8 858.06h-3.0598v-1.9043q-1.3184 1.1393-2.7507 1.7741-1.4322 0.63476-3.1086 0.63476-3.2552 0-5.1758-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.6511-4.1178 0.6673-1.8066 1.7903-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29297 2.3275 0.92773v-7.8775h3.0598zm-3.0598-4.4759v-10.433q-1.237-0.55338-2.2136-0.76497-0.9765-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7904-1.4322 1.7904-1.4322 5.0781 0 3.2389 1.1067 4.9316 1.1068 1.6764 3.5482 1.6764 1.302 0 2.6367-0.56965 1.3346-0.58594 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1801.1 836.84h-3.4504v-3.1738h3.4504zm-0.1953 21.224h-3.0598v-18.18h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1821.1 858.06h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6836 0.48828-1.3346 0.78125-0.765 0.37434-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1667-1.6276-1.7089-1.6276-1.7089-4.1504 0-2.067 0.8789-3.3366 0.8951-1.2858 2.539-2.0182 1.6601-0.73241 3.9876-0.99283 2.3274-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3744-1.7252-0.358-0.68359-1.0416-1.0742-0.6511-0.37434-1.5625-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1627v-3.1087q0.8951-0.24414 2.5878-0.53711 1.6927-0.29296 3.3366-0.29296 1.9205 0 3.3365 0.32551 1.4323 0.30925 2.474 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24413-1.888 0.16276-2.9948 0.47201-1.3183 0.37434-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78125 2.8808 0.78125 1.6113 0 2.9459-0.61849 1.3347-0.63476 2.474-1.5136z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1853.6 858.06h-3.0599v-10.351q0-1.1719-0.1139-2.2623-0.098-1.0905-0.4395-1.7415-0.3743-0.69987-1.0742-1.0579-0.6998-0.35806-2.0182-0.35806-1.2858 0-2.5716 0.65103-1.2858 0.63476-2.5716 1.6276 0.049 0.37434 0.081 0.8789 0.033 0.48827 0.033 0.97655v11.637h-3.0599v-10.351q0-1.2044-0.1139-2.2786-0.098-1.0905-0.4395-1.7415-0.3743-0.69986-1.0742-1.0417-0.6999-0.35806-2.0182-0.35806-1.2532 0-2.5228 0.61848-1.2532 0.61848-2.5064 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4322-1.1881 2.8482-1.8554 1.4323-0.66731 3.0436-0.66731 1.8555 0 3.1413 0.78124 1.302 0.78125 1.9368 2.1647 1.8554-1.5625 3.3854-2.2461 1.5299-0.69987 3.2714-0.69987 2.9948 0 4.4108 1.8229 1.4323 1.8066 1.4323 5.0618z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1874.7 849.29h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78124 2.002 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7271-0.73241 1.888-0.74869 2.6856-1.4648h0.1627v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0637-2.4414-2.5391-2.4576-2.5391-6.9661 0-4.4596 2.4252-7.08 2.4413-2.6204 6.4126-2.6204 3.6784 0 5.6641 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1888.8 857.9q-0.8626 0.22787-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.065 2.2461 0.065 0.79752 0.4557 1.4974 0.3581 0.65103 0.9766 0.96028 0.6347 0.29296 1.9205 0.29296 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37434h0.1627z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1907.7 849.29h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78124 2.002 1.1719 1.1718 0.39062 2.5715 0.39062 1.8555 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0637-2.4414-2.5391-2.4576-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1923.7 843.22h-0.1628q-0.6836-0.16276-1.3346-0.22786-0.6348-0.0814-1.5137-0.0814-1.416 0-2.7343 0.63476-1.3183 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2063-2.067 1.3997-0.61849 2.8483-0.61849 0.7975 0 1.1556 0.0488 0.358 0.0325 1.0742 0.14649z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1953.5 858.06h-3.0599v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1718-1.0091-0.765-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848t-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4322-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.946 0 4.4922 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1974.6 849.29h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78124 2.002 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7271-0.73241 1.888-0.74869 2.6856-1.4648h0.1627v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0637-2.4414-2.5391-2.4576-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.6641 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1995 858.06h-3.8574l-5.1595-6.9824-5.192 6.9824h-3.5644l7.0963-9.0657-7.0312-9.1145h3.8574l5.1269 6.8684 5.1432-6.8684h3.5807l-7.1451 8.9517z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2013.1 858.06h-3.0435v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6836 0.48828-1.3346 0.78125-0.765 0.37434-1.7578 0.61848-0.9928 0.26041-2.3275 0.26041-2.4576 0-4.1666-1.6276-1.709-1.6276-1.709-4.1504 0-2.067 0.8789-3.3366 0.8952-1.2858 2.5391-2.0182 1.6601-0.73241 3.9876-0.99283 2.3274-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3744-1.7252-0.3581-0.68359-1.0416-1.0742-0.6511-0.37434-1.5625-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1627v-3.1087q0.8951-0.24414 2.5878-0.53711 1.6927-0.29296 3.3366-0.29296 1.9205 0 3.3365 0.32551 1.4323 0.30925 2.474 1.0742 1.0253 0.74869 1.5624 1.9368t0.5371 2.9459zm-3.0435-4.4759v-5.0618q-1.3998 0.0814-3.304 0.24413-1.888 0.16276-2.9948 0.47201-1.3184 0.37434-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78125 2.8808 0.78125 1.6113 0 2.9459-0.61849 1.3346-0.63476 2.474-1.5136z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2033.8 856q0 4.6223-2.0996 6.787-2.0996 2.1647-6.4615 2.1647-1.4486 0-2.832-0.21159-1.3672-0.19531-2.7018-0.56965v-3.125h0.1628q0.7486 0.29296 2.3762 0.71614 1.6276 0.43945 3.2552 0.43945 1.5625 0 2.5879-0.37435t1.595-1.0417q0.5697-0.63476 0.8138-1.5299t0.2441-2.0019v-1.6601q-1.3834 1.1068-2.6529 1.6601-1.2533 0.5371-3.2064 0.5371-3.2551 0-5.1757-2.3437-1.9043-2.36-1.9043-6.6406 0-2.3437 0.6511-4.0364 0.6673-1.709 1.8066-2.9459 1.0579-1.1556 2.5716-1.7903 1.5136-0.65104 3.011-0.65104 1.5788 0 2.6367 0.32552 1.0742 0.30924 2.2623 0.96028l0.1954-0.78125h2.8645zm-3.0599-2.9297v-9.912q-1.2206-0.55338-2.2786-0.78125-1.0416-0.24413-2.0833-0.24413-2.5228 0-3.9713 1.6927-1.4486 1.6927-1.4486 4.9153 0 3.0599 1.0743 4.6386 1.0742 1.5788 3.5644 1.5788 1.3346 0 2.6692-0.50455 1.3509-0.52083 2.4739-1.3834z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2055.3 848.98q0 4.4433-2.2786 7.0149-2.2786 2.5716-6.1035 2.5716-3.8574 0-6.136-2.5716-2.2623-2.5716-2.2623-7.0149 0-4.4433 2.2623-7.0149 2.2786-2.5879 6.136-2.5879 3.8249 0 6.1035 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3835-5.2408-1.3834-1.7252-3.8411-1.7252-2.4902 0-3.8736 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3834 5.192 1.3835 1.7578 3.8574 1.7578 2.4414 0 3.8249-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2075.2 858.06h-3.0599v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.7649-0.34179-1.9856-0.34179-1.2533 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4322-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.9459 0 4.4922 1.7741 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2095.3 858.06h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6835 0.48828-1.3346 0.78125-0.7649 0.37434-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1667-1.6276-1.7089-1.6276-1.7089-4.1504 0-2.067 0.8789-3.3366 0.8952-1.2858 2.539-2.0182 1.6602-0.73241 3.9876-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37434-1.5625-0.50455-0.9114-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0598 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.53711 1.6927-0.29296 3.3365-0.29296 1.9206 0 3.3366 0.32551 1.4322 0.30925 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24413-1.888 0.16276-2.9948 0.47201-1.3183 0.37434-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78125 2.8808 0.78125 1.6113 0 2.946-0.61849 1.3346-0.63476 2.4739-1.5136z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2104.3 858.06h-3.0598v-25.325h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2137.3 858.06h-3.0599v-10.351q0-1.2532-0.1464-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.765-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848t-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4323-1.1881 2.9622-1.8554t3.1413-0.66731q2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2146.5 836.84h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2167.1 856q0 4.6223-2.0996 6.787-2.0996 2.1647-6.4615 2.1647-1.4486 0-2.832-0.21159-1.3672-0.19531-2.7018-0.56965v-3.125h0.1628q0.7486 0.29296 2.3762 0.71614 1.6276 0.43945 3.2552 0.43945 1.5625 0 2.5879-0.37435t1.595-1.0417q0.5697-0.63476 0.8138-1.5299t0.2441-2.0019v-1.6601q-1.3834 1.1068-2.6529 1.6601-1.2533 0.5371-3.2064 0.5371-3.2551 0-5.1757-2.3437-1.9043-2.36-1.9043-6.6406 0-2.3437 0.6511-4.0364 0.6673-1.709 1.8066-2.9459 1.0579-1.1556 2.5716-1.7903 1.5136-0.65104 3.011-0.65104 1.5788 0 2.6367 0.32552 1.0742 0.30924 2.2623 0.96028l0.1954-0.78125h2.8645zm-3.0599-2.9297v-9.912q-1.2206-0.55338-2.2786-0.78125-1.0416-0.24413-2.0833-0.24413-2.5228 0-3.9713 1.6927-1.4486 1.6927-1.4486 4.9153 0 3.0599 1.0743 4.6386 1.0742 1.5788 3.5644 1.5788 1.3346 0 2.6692-0.50455 1.3509-0.52083 2.4739-1.3834z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2188.3 858.06h-3.0598v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.7649-0.34179-1.9856-0.34179-1.2533 0-2.6204 0.61848-1.3672 0.61848-2.6205 1.5788v13.574h-3.0598v-25.325h3.0598v9.1633q1.4323-1.1881 2.9622-1.8554 1.53-0.66731 3.1413-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2220.7 856q0 4.6223-2.0996 6.787-2.0996 2.1647-6.4615 2.1647-1.4486 0-2.832-0.21159-1.3672-0.19531-2.7018-0.56965v-3.125h0.1628q0.7486 0.29296 2.3762 0.71614 1.6276 0.43945 3.2552 0.43945 1.5625 0 2.5879-0.37435t1.595-1.0417q0.5697-0.63476 0.8138-1.5299t0.2441-2.0019v-1.6601q-1.3834 1.1068-2.6529 1.6601-1.2533 0.5371-3.2064 0.5371-3.2551 0-5.1757-2.3437-1.9043-2.36-1.9043-6.6406 0-2.3437 0.6511-4.0364 0.6673-1.709 1.8066-2.9459 1.0579-1.1556 2.5716-1.7903 1.5136-0.65104 3.011-0.65104 1.5788 0 2.6367 0.32552 1.0742 0.30924 2.2623 0.96028l0.1954-0.78125h2.8645zm-3.0599-2.9297v-9.912q-1.2206-0.55338-2.2786-0.78125-1.0416-0.24413-2.0833-0.24413-2.5228 0-3.9713 1.6927-1.4486 1.6927-1.4486 4.9153 0 3.0599 1.0743 4.6386 1.0742 1.5788 3.5644 1.5788 1.3346 0 2.6692-0.50455 1.3509-0.52083 2.4739-1.3834z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2240.8 858.06h-3.0436v-1.9368q-0.4069 0.27669-1.1067 0.78124-0.6836 0.48828-1.3346 0.78125-0.765 0.37434-1.7578 0.61848-0.9929 0.26041-2.3275 0.26041-2.4576 0-4.1666-1.6276-1.709-1.6276-1.709-4.1504 0-2.067 0.8789-3.3366 0.8952-1.2858 2.5391-2.0182 1.6601-0.73241 3.9875-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37434-1.5624-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.53711 1.6927-0.29296 3.3366-0.29296 1.9205 0 3.3365 0.32551 1.4323 0.30925 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24413-1.888 0.16276-2.9947 0.47201-1.3184 0.37434-2.1322 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78125 2.8809 0.78125 1.6113 0 2.9459-0.61849 1.3346-0.63476 2.4739-1.5136z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2250.1 836.84h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2271.1 858.06h-3.0598v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.765-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3671 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554 1.53-0.66731 3.1413-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2302.9 858.06h-3.0436v-1.9368q-0.4069 0.27669-1.1067 0.78124-0.6836 0.48828-1.3347 0.78125-0.7649 0.37434-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1504 0-2.067 0.8789-3.3366 0.8952-1.2858 2.539-2.0182 1.6602-0.73241 3.9876-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37434-1.5625-0.50455-0.9114-0.13021-1.9042-0.13021-1.2045 0-2.6856 0.32552-1.4811 0.30924-3.0598 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.53711 1.6927-0.29296 3.3365-0.29296 1.9206 0 3.3366 0.32551 1.4323 0.30925 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24413-1.888 0.16276-2.9948 0.47201-1.3183 0.37434-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78125 2.8808 0.78125 1.6114 0 2.946-0.61849 1.3346-0.63476 2.4739-1.5136z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2324 858.06h-3.0599v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.7649-0.34179-1.9856-0.34179-1.2533 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4322-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.9459 0 4.4922 1.7741 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2339.3 857.9q-0.8627 0.22787-1.888 0.37435-1.0091 0.14648-1.8067 0.14648-2.7831 0-4.2317-1.4974-1.4485-1.4974-1.4485-4.8014v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.79752 0.4558 1.4974 0.358 0.65103 0.9765 0.96028 0.6348 0.29296 1.9206 0.29296 0.7487 0 1.5624-0.21159 0.8138-0.22786 1.1719-0.37434h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2358.3 849.29h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78124 2.002 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7271-0.73241 1.888-0.74869 2.6856-1.4648h0.1627v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43944-3.3854 0.43944-4.5247 0-7.0637-2.4414-2.5391-2.4576-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.6641 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2378.1 858.06h-3.0598v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.7649-0.34179-1.9856-0.34179-1.2533 0-2.6205 0.61848-1.3671 0.61848-2.6204 1.5788v13.574h-3.0598v-18.18h3.0598v2.0182q1.4323-1.1881 2.9622-1.8554 1.53-0.66731 3.1413-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2399.2 858.06h-3.0598v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68358-1.1719-1.0091-0.7649-0.34179-1.9856-0.34179-1.2533 0-2.6204 0.61848-1.3672 0.61848-2.6205 1.5788v13.574h-3.0598v-18.18h3.0598v2.0182q1.4323-1.1881 2.9622-1.8554 1.53-0.66731 3.1413-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2419.2 858.06h-3.0436v-1.9368q-0.4069 0.27669-1.1067 0.78124-0.6836 0.48828-1.3347 0.78125-0.7649 0.37434-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1504 0-2.067 0.8789-3.3366 0.8952-1.2858 2.539-2.0182 1.6602-0.73241 3.9876-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0416-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37434-1.5625-0.50455-0.9114-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0598 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.53711 1.6927-0.29296 3.3365-0.29296 1.9206 0 3.3366 0.32551 1.4323 0.30925 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24413-1.888 0.16276-2.9948 0.47201-1.3183 0.37434-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78125 2.8808 0.78125 1.6114 0 2.946-0.61849 1.3346-0.63476 2.4739-1.5136z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0872 0 0 .9997 -1248.6 668.57)",
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 109.66,
    width: 859.43,
    height: 39.433
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 149.66,
    width: 859.43,
    height: 39.433
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Label-RTG"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m798.87 1857.3 316.93-268.43 83.087-1e-4",
    fill: "none",
    stroke: "#f44336",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "Radioisotope Thermoelectric Generator"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m1240.9 1587.5h-10.02v17.256h-5.6543v-42.656h14.121q7.207 0 11.074 3.2812 3.8965 3.2813 3.8965 9.5508 0 3.9844-2.168 6.9434-2.1387 2.959-5.9765 4.4238l10.02 18.106v0.3515h-6.0352zm-10.02-4.5996h8.6426q4.1894 0 6.6504-2.168 2.4902-2.168 2.4902-5.8008 0-3.9551-2.3731-6.0644-2.3437-2.1094-6.7968-2.1387h-8.6133z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m1280.9 1604.8q-0.4687-0.9375-0.7617-3.3398-3.7793 3.9258-9.0234 3.9258-4.6875 0-7.7051-2.6367-2.9883-2.6661-2.9883-6.7383 0-4.9512 3.75-7.6758 3.7793-2.7539 10.606-2.7539h5.2734v-2.4902q0-2.8418-1.6992-4.5118-1.6992-1.6992-5.0097-1.6992-2.9004 0-4.8633 1.4649-1.9629 1.4648-1.9629 3.5449h-5.4492q0-2.3731 1.6699-4.5703 1.6992-2.2266 4.5703-3.5156 2.9004-1.2891 6.3574-1.2891 5.4785 0 8.584 2.7539 3.1055 2.7246 3.2227 7.5293v14.59q0 4.3653 1.1132 6.9434v0.4687zm-8.9941-4.1308q2.5488 0 4.834-1.3184 2.2851-1.3183 3.3105-3.4277v-6.5039h-4.248q-9.9609 0-9.9609 5.8301 0 2.5488 1.6992 3.9843 1.6992 1.4356 4.3652 1.4356z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m1292.7 1588.6q0-7.295 3.457-11.719 3.4571-4.4531 9.0528-4.4531 5.5664 0 8.8183 3.8086v-16.524h5.4199v45h-4.9804l-0.2637-3.3984q-3.252 3.9844-9.0527 3.9844-5.5079 0-8.9942-4.5117-3.457-4.5118-3.457-11.777zm5.4199 0.6152q0 5.3906 2.2266 8.4375 2.2265 3.0469 6.1523 3.0469 5.1563 0 7.5293-4.6289v-14.561q-2.4316-4.4824-7.4707-4.4824-3.9844 0-6.2109 3.0762-2.2266 3.0761-2.2266 9.1113z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m1333.8 1604.8h-5.4199v-31.699h5.4199zm-5.8594-40.107q0-1.3183 0.791-2.2265 0.8204-0.9082 2.4024-0.9082t2.4023 0.9082 0.8203 2.2265q0 1.3184-0.8203 2.1973t-2.4023 0.8789-2.4024-0.8789q-0.791-0.8789-0.791-2.1973z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m1341 1588.6q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0977-5.7422 3.2813-2.0215 7.4707-2.0215 6.4746 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.3809q0 4.6289-1.7871 8.3203-1.7579 3.6621-5.0684 5.7129-3.2813 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9844-4.4825-3.9844-11.865zm5.4493 0.6445q0 5.2734 2.4316 8.4668 2.4609 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2227 2.4316-3.252 2.4316-9.082 0-5.2149-2.4902-8.4375-2.4609-3.252-6.5625-3.252-4.0137 0-6.4746 3.1934-2.4609 3.1933-2.4609 9.1406z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m1382.5 1604.8h-5.4199v-31.699h5.4199zm-5.8594-40.107q0-1.3183 0.791-2.2265 0.8204-0.9082 2.4024-0.9082t2.4023 0.9082 0.8203 2.2265q0 1.3184-0.8203 2.1973t-2.4023 0.8789-2.4024-0.8789q-0.791-0.8789-0.791-2.1973z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m1409.6 1596.3q0-2.1972-1.6699-3.3984-1.6406-1.2305-5.7715-2.1094-4.1016-0.8789-6.5332-2.1093-2.4023-1.2305-3.5742-2.9297-1.1426-1.6993-1.1426-4.043 0-3.8965 3.2813-6.5918 3.3105-2.6953 8.4375-2.6953 5.3906 0 8.7304 2.7832 3.3692 2.7832 3.3692 7.1191h-5.4492q0-2.2265-1.9043-3.8379-1.875-1.6113-4.7461-1.6113-2.959 0-4.6289 1.2891-1.67 1.289-1.67 3.3691 0 1.9629 1.5528 2.959 1.5527 0.9961 5.5957 1.9043 4.0722 0.9082 6.5918 2.168 2.5195 1.2597 3.7207 3.0468 1.2304 1.7579 1.2304 4.3067 0 4.248-3.3984 6.8262-3.3984 2.5488-8.8184 2.5488-3.8086 0-6.7382-1.3477-2.9297-1.3476-4.5996-3.75-1.6407-2.4316-1.6407-5.2441h5.4199q0.1465 2.7246 2.168 4.3359 2.0508 1.5821 5.3906 1.5821 3.0762 0 4.9219-1.2305 1.875-1.2598 1.875-3.3399z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m1420.6 1588.6q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0977-5.7422 3.2813-2.0215 7.4707-2.0215 6.4746 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.3809q0 4.6289-1.7871 8.3203-1.7579 3.6621-5.0684 5.7129-3.2813 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9844-4.4825-3.9844-11.865zm5.4493 0.6445q0 5.2734 2.4316 8.4668 2.4609 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2227 2.4316-3.252 2.4316-9.082 0-5.2149-2.4902-8.4375-2.4609-3.252-6.5625-3.252-4.0137 0-6.4746 3.1934-2.4609 3.1933-2.4609 9.1406z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m1463.7 1565.4v7.6758h5.9179v4.1895h-5.9179v19.658q0 1.9043 0.791 2.8711 0.791 0.9375 2.6953 0.9375 0.9375 0 2.5781-0.3516v4.3945q-2.1387 0.586-4.1602 0.586-3.6328 0-5.4785-2.1973-1.8457-2.1972-1.8457-6.2402v-19.658h-5.7715v-4.1895h5.7715v-7.6758z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m1473.9 1588.6q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0976-5.7422 3.2813-2.0215 7.4707-2.0215 6.4746 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.3809q0 4.6289-1.7871 8.3203-1.7578 3.6621-5.0684 5.7129-3.2812 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9843-4.4825-3.9843-11.865zm5.4492 0.6445q0 5.2734 2.4316 8.4668 2.461 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2227 2.4317-3.252 2.4317-9.082 0-5.2149-2.4903-8.4375-2.4609-3.252-6.5625-3.252-4.0136 0-6.4746 3.1934-2.4609 3.1933-2.4609 9.1406z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m1536.3 1589.3q0 7.2363-3.3105 11.66-3.3106 4.4238-8.9649 4.4238-5.7715 0-9.082-3.6621v15.264h-5.4199v-43.887h4.9511l0.2637 3.5157q3.3106-4.1016 9.1992-4.1016 5.7129 0 9.0235 4.3066 3.3398 4.3067 3.3398 11.982zm-5.4199-0.6152q0-5.3614-2.2852-8.4668-2.2851-3.1055-6.2695-3.1055-4.9219 0-7.3828 4.3652v15.146q2.4316 4.336 7.4414 4.336 3.8965 0 6.1816-3.0762 2.3145-3.1055 2.3145-9.1992z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m1556.3 1605.3q-6.4453 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.9961q0-4.7167 1.7871-8.4082 1.8164-3.7207 5.0391-5.8007 3.2519-2.1094 7.0312-2.1094 6.1817 0 9.6094 4.0723 3.4278 4.0722 3.4278 11.66v2.2559h-21.475q0.1172 4.6875 2.7247 7.5879 2.6367 2.8711 6.6796 2.8711 2.8711 0 4.8633-1.1719t3.4863-3.1055l3.3106 2.5781q-3.9844 6.1231-11.953 6.1231zm-0.6739-28.418q-3.2812 0-5.5078 2.4024-2.2265 2.373-2.7539 6.6796h15.879v-0.4101q-0.2343-4.1309-2.2265-6.3867-1.9922-2.2852-5.3907-2.2852z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m1618.9 1566.7h-13.711v38.027h-5.5958v-38.027h-13.682v-4.6289h32.988z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m1629.9 1576.9q3.6035-4.4238 9.375-4.4238 10.049 0 10.137 11.338v20.947h-5.4199v-20.976q-0.029-3.4278-1.582-5.0684-1.5235-1.6406-4.7754-1.6406-2.6367 0-4.6289 1.4062-1.9922 1.4063-3.1055 3.6915v22.588h-5.4199v-45h5.4199z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m1670.7 1605.3q-6.4453 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.9961q0-4.7167 1.7871-8.4082 1.8164-3.7207 5.0391-5.8007 3.2519-2.1094 7.0312-2.1094 6.1817 0 9.6094 4.0723 3.4278 4.0722 3.4278 11.66v2.2559h-21.475q0.1172 4.6875 2.7247 7.5879 2.6367 2.8711 6.6796 2.8711 2.8711 0 4.8633-1.1719t3.4863-3.1055l3.3106 2.5781q-3.9844 6.1231-11.953 6.1231zm-0.6739-28.418q-3.2812 0-5.5078 2.4024-2.2265 2.373-2.7539 6.6796h15.879v-0.4101q-0.2343-4.1309-2.2265-6.3867-1.9922-2.2852-5.3907-2.2852z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m1704.6 1577.9q-1.2305-0.2051-2.6661-0.2051-5.332 0-7.2363 4.541v22.5h-5.4199v-31.699h5.2734l0.088 3.6621q2.666-4.248 7.5586-4.248 1.582 0 2.4024 0.4101z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m1714.6 1573.1 0.1465 3.5157q3.4863-4.1016 9.4043-4.1016 6.6504 0 9.0527 5.0976 1.582-2.2851 4.1016-3.6914 2.5488-1.4062 6.0058-1.4062 10.43 0 10.606 11.045v21.24h-5.4199v-20.918q0-3.3985-1.5528-5.0684-1.5527-1.6992-5.2148-1.6992-3.0176 0-5.0098 1.8164-1.9922 1.7871-2.3144 4.834v21.035h-5.4493v-20.771q0-6.9141-6.7675-6.9141-5.3321 0-7.295 4.541v23.144h-5.4199v-31.699z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m1760.7 1588.6q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0976-5.7422 3.2813-2.0215 7.4707-2.0215 6.4746 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.3809q0 4.6289-1.7871 8.3203-1.7578 3.6621-5.0684 5.7129-3.2812 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9843-4.4825-3.9843-11.865zm5.4492 0.6445q0 5.2734 2.4316 8.4668 2.461 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2227 2.4317-3.252 2.4317-9.082 0-5.2149-2.4903-8.4375-2.4609-3.252-6.5625-3.252-4.0136 0-6.4746 3.1934-2.4609 3.1933-2.4609 9.1406z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m1809.5 1605.3q-6.4454 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.9961q0-4.7167 1.7871-8.4082 1.8164-3.7207 5.0391-5.8007 3.2519-2.1094 7.0312-2.1094 6.1817 0 9.6094 4.0723 3.4277 4.0722 3.4277 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6368 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719t3.4863-3.1055l3.3106 2.5781q-3.9844 6.1231-11.953 6.1231zm-0.6739-28.418q-3.2812 0-5.5078 2.4024-2.2265 2.373-2.7539 6.6796h15.879v-0.4101q-0.2344-4.1309-2.2265-6.3867-1.9922-2.2852-5.3907-2.2852z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m1834 1604.8h-5.4199v-45h5.4199z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m1855.8 1605.3q-6.4453 0-10.488-4.2188-4.0429-4.248-4.0429-11.338v-0.9961q0-4.7167 1.7871-8.4082 1.8164-3.7207 5.039-5.8007 3.252-2.1094 7.0313-2.1094 6.1816 0 9.6094 4.0723 3.4277 4.0722 3.4277 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6367 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719t3.4863-3.1055l3.3105 2.5781q-3.9843 6.1231-11.953 6.1231zm-0.6738-28.418q-3.2813 0-5.5078 2.4024-2.2266 2.373-2.7539 6.6796h15.879v-0.4101q-0.2344-4.1309-2.2266-6.3867-1.9922-2.2852-5.3906-2.2852z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m1887.1 1600.9q2.9004 0 5.0683-1.7579 2.168-1.7578 2.4024-4.3945h5.1269q-0.1464 2.7246-1.875 5.1856-1.7285 2.4609-4.6289 3.9257-2.8711 1.4649-6.0937 1.4649-6.4746 0-10.312-4.3067-3.8086-4.3359-3.8086-11.836v-0.9082q0-4.6289 1.6992-8.2324t4.8633-5.5957q3.1933-1.9922 7.5293-1.9922 5.332 0 8.8476 3.1933 3.545 3.1934 3.7793 8.2911h-5.1269q-0.2344-3.0762-2.3438-5.0391-2.08-1.9922-5.1562-1.9922-4.1309 0-6.416 2.9883-2.2559 2.959-2.2559 8.584v1.0254q0 5.4785 2.2559 8.4375 2.2558 2.959 6.4453 2.959z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m1913.2 1565.4v7.6758h5.918v4.1895h-5.918v19.658q0 1.9043 0.791 2.8711 0.791 0.9375 2.6953 0.9375 0.9375 0 2.5782-0.3516v4.3945q-2.1387 0.586-4.1602 0.586-3.6328 0-5.4785-2.1973-1.8457-2.1972-1.8457-6.2402v-19.658h-5.7715v-4.1895h5.7715v-7.6758z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m1940.7 1577.9q-1.2305-0.2051-2.6661-0.2051-5.332 0-7.2363 4.541v22.5h-5.4199v-31.699h5.2734l0.088 3.6621q2.666-4.248 7.5586-4.248 1.5821 0 2.4024 0.4101z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m1951.6 1604.8h-5.4199v-31.699h5.4199zm-5.8594-40.107q0-1.3183 0.791-2.2265 0.8204-0.9082 2.4024-0.9082t2.4023 0.9082 0.8203 2.2265q0 1.3184-0.8203 2.1973t-2.4023 0.8789-2.4024-0.8789q-0.791-0.8789-0.791-2.1973z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m1972.9 1600.9q2.9004 0 5.0684-1.7579 2.168-1.7578 2.4023-4.3945h5.127q-0.1465 2.7246-1.875 5.1856-1.7285 2.4609-4.6289 3.9257-2.8711 1.4649-6.0938 1.4649-6.4746 0-10.312-4.3067-3.8086-4.3359-3.8086-11.836v-0.9082q0-4.6289 1.6993-8.2324 1.6992-3.6035 4.8632-5.5957 3.1934-1.9922 7.5293-1.9922 5.3321 0 8.8477 3.1933 3.5449 3.1934 3.7793 8.2911h-5.127q-0.2343-3.0762-2.3437-5.0391-2.0801-1.9922-5.1563-1.9922-4.1308 0-6.416 2.9883-2.2558 2.959-2.2558 8.584v1.0254q0 5.4785 2.2558 8.4375 2.2559 2.959 6.4453 2.959z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m2038.8 1599.2q-2.168 3.1055-6.0645 4.6582-3.8671 1.5235-9.0234 1.5235-5.2148 0-9.2578-2.4317-4.043-2.4609-6.2695-6.9726-2.1973-4.5117-2.2559-10.459v-3.7207q0-9.6387 4.4824-14.941 4.5117-5.3027 12.656-5.3027 6.6797 0 10.752 3.4277 4.0723 3.3984 4.9805 9.668h-5.625q-1.582-8.4668-10.078-8.4668-5.6543 0-8.584 3.9843-2.9004 3.9551-2.9297 11.484v3.4863q0 7.1778 3.2813 11.426 3.2812 4.2188 8.8769 4.2188 3.1641 0 5.5371-0.7032 2.3731-0.7031 3.9258-2.373v-9.5801h-9.8731v-4.5703h15.469z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m2060.5 1605.3q-6.4453 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.9961q0-4.7167 1.7871-8.4082 1.8164-3.7207 5.0391-5.8007 3.252-2.1094 7.0313-2.1094 6.1816 0 9.6093 4.0723 3.4278 4.0722 3.4278 11.66v2.2559h-21.475q0.1171 4.6875 2.7246 7.5879 2.6367 2.8711 6.6797 2.8711 2.871 0 4.8632-1.1719t3.4864-3.1055l3.3105 2.5781q-3.9844 6.1231-11.953 6.1231zm-0.6738-28.418q-3.2813 0-5.5079 2.4024-2.2265 2.373-2.7539 6.6796h15.879v-0.4101q-0.2343-4.1309-2.2265-6.3867-1.9922-2.2852-5.3906-2.2852z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m2084.3 1573.1 0.1757 3.9844q3.6328-4.5703 9.4922-4.5703 10.049 0 10.137 11.338v20.947h-5.4199v-20.976q-0.029-3.4278-1.582-5.0684-1.5235-1.6406-4.7754-1.6406-2.6367 0-4.6289 1.4062-1.9922 1.4063-3.1055 3.6915v22.588h-5.4199v-31.699z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m2125.5 1605.3q-6.4454 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.9961q0-4.7167 1.7871-8.4082 1.8164-3.7207 5.0391-5.8007 3.2519-2.1094 7.0312-2.1094 6.1817 0 9.6094 4.0723 3.4277 4.0722 3.4277 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6368 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719t3.4863-3.1055l3.3106 2.5781q-3.9844 6.1231-11.953 6.1231zm-0.6739-28.418q-3.2812 0-5.5078 2.4024-2.2265 2.373-2.7539 6.6796h15.879v-0.4101q-0.2344-4.1309-2.2265-6.3867-1.9922-2.2852-5.3907-2.2852z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m2159.4 1577.9q-1.2304-0.2051-2.666-0.2051-5.332 0-7.2363 4.541v22.5h-5.4199v-31.699h5.2734l0.088 3.6621q2.666-4.248 7.5586-4.248 1.582 0 2.4023 0.4101z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m2182.7 1604.8q-0.4687-0.9375-0.7617-3.3398-3.7793 3.9258-9.0234 3.9258-4.6875 0-7.7051-2.6367-2.9883-2.6661-2.9883-6.7383 0-4.9512 3.75-7.6758 3.7793-2.7539 10.606-2.7539h5.2734v-2.4902q0-2.8418-1.6992-4.5118-1.6992-1.6992-5.0097-1.6992-2.9004 0-4.8633 1.4649-1.9629 1.4648-1.9629 3.5449h-5.4492q0-2.3731 1.6699-4.5703 1.6992-2.2266 4.5703-3.5156 2.9004-1.2891 6.3574-1.2891 5.4785 0 8.584 2.7539 3.1055 2.7246 3.2227 7.5293v14.59q0 4.3653 1.1132 6.9434v0.4687zm-8.9941-4.1308q2.5488 0 4.834-1.3184 2.2851-1.3183 3.3105-3.4277v-6.5039h-4.248q-9.9609 0-9.9609 5.8301 0 2.5488 1.6992 3.9843 1.6992 1.4356 4.3652 1.4356z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m2203.2 1565.4v7.6758h5.9179v4.1895h-5.9179v19.658q0 1.9043 0.791 2.8711 0.791 0.9375 2.6953 0.9375 0.9375 0 2.5781-0.3516v4.3945q-2.1387 0.586-4.1601 0.586-3.6329 0-5.4786-2.1973-1.8457-2.1972-1.8457-6.2402v-19.658h-5.7714v-4.1895h5.7714v-7.6758z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m2213.4 1588.6q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0976-5.7422 3.2813-2.0215 7.4707-2.0215 6.4747 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.3809q0 4.6289-1.7871 8.3203-1.7578 3.6621-5.0684 5.7129-3.2812 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9844-4.4825-3.9844-11.865zm5.4492 0.6445q0 5.2734 2.4316 8.4668 2.461 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2227 2.4317-3.252 2.4317-9.082 0-5.2149-2.4903-8.4375-2.4609-3.252-6.5625-3.252-4.0136 0-6.4746 3.1934-2.4609 3.1933-2.4609 9.1406z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m2264.4 1577.9q-1.2304-0.2051-2.666-0.2051-5.332 0-7.2363 4.541v22.5h-5.4199v-31.699h5.2734l0.088 3.6621q2.666-4.248 7.5586-4.248 1.582 0 2.4023 0.4101z"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m1219.8 1555.8h1050v65h-1050z",
    strokeWidth: 1.0898
  })), /*#__PURE__*/React.createElement("g", {
    className: "captionText",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      whiteSpace: "pre"
    },
    "aria-label": "4 plutonium-238 fueled generators provide 155 W of electric power"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1243.5 1650.6h-3.597v6.8196h-3.125v-6.8196h-11.605v-3.7435l11.735-13.672h2.9948v14.811h3.597zm-6.722-2.6042v-10.937l-9.3911 10.937z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1275.9 1648.1q0 2.2135-0.6348 4.0527-0.6347 1.8228-1.7903 3.0924-1.0742 1.2044-2.539 1.8717-1.4486 0.651-3.0762 0.651-1.416 0-2.5716-0.3092-1.1393-0.3093-2.3274-0.9603v7.6171h-3.0599v-24.886h3.0599v1.9043q1.2207-1.0254 2.7343-1.709 1.53-0.6998 3.2552-0.6998 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1575 0.081q0-3.2877-1.1231-4.9153-1.123-1.6276-3.4504-1.6276-1.3184 0-2.653 0.5697-1.3346 0.5696-2.5553 1.4974v10.303q1.302 0.5859 2.2298 0.7975 0.944 0.2116 2.1321 0.2116 2.5553 0 3.9876-1.7252 1.4323-1.7253 1.4323-5.1107z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1283.8 1657.4h-3.0598v-25.325h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1304.9 1657.4h-3.0599v-2.0182q-1.5462 1.2206-2.9622 1.8717-1.416 0.651-3.125 0.651-2.8645 0-4.4595-1.7415-1.5951-1.7578-1.5951-5.1432v-11.8h3.0599v10.352q0 1.3834 0.1302 2.3762 0.1302 0.9766 0.5534 1.6765 0.4394 0.7161 1.1393 1.0416 0.6998 0.3255 2.0345 0.3255 1.1881 0 2.5878-0.6185 1.416-0.6184 2.6367-1.5787v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1320.4 1657.3q-0.8626 0.2279-1.888 0.3743-1.0091 0.1465-1.8067 0.1465-2.7831 0-4.2317-1.4974-1.4485-1.4973-1.4485-4.8013v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.7975 0.4558 1.4974 0.358 0.651 0.9765 0.9602 0.6348 0.293 1.9206 0.293 0.7487 0 1.5625-0.2116 0.8137-0.2278 1.1718-0.3743h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1339.6 1648.3q0 4.4433-2.2786 7.0149t-6.1035 2.5716q-3.8574 0-6.136-2.5716-2.2623-2.5716-2.2623-7.0149t2.2623-7.0149q2.2786-2.5878 6.136-2.5878 3.8249 0 6.1035 2.5878 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5318-1.3835-5.2408-1.3834-1.7253-3.8411-1.7253-2.4902 0-3.8736 1.7253-1.3672 1.709-1.3672 5.2408 0 3.418 1.3834 5.192 1.3835 1.7578 3.8574 1.7578 2.4414 0 3.8249-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1359.5 1657.4h-3.0598v-10.352q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7253-0.4069-0.6836-1.1719-1.0091-0.7649-0.3418-1.9856-0.3418-1.2533 0-2.6205 0.6185-1.3671 0.6185-2.6204 1.5788v13.574h-3.0598v-18.18h3.0598v2.0182q1.4323-1.1881 2.9622-1.8554 1.53-0.6673 3.1413-0.6673 2.9459 0 4.4921 1.774 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1368.7 1636.2h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0598v-18.18h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1389.7 1657.4h-3.0599v-2.0182q-1.5462 1.2206-2.9622 1.8717-1.416 0.651-3.125 0.651-2.8645 0-4.4596-1.7415-1.595-1.7578-1.595-5.1432v-11.8h3.0599v10.352q0 1.3834 0.1302 2.3762 0.1302 0.9766 0.5533 1.6765 0.4395 0.7161 1.1394 1.0416 0.6998 0.3255 2.0344 0.3255 1.1882 0 2.5879-0.6185 1.416-0.6184 2.6367-1.5787v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1422.2 1657.4h-3.0598v-10.352q0-1.1719-0.114-2.2623-0.098-1.0905-0.4394-1.7416-0.3744-0.6998-1.0742-1.0579-0.6999-0.3581-2.0182-0.3581-1.2858 0-2.5716 0.6511-1.2858 0.6347-2.5716 1.6276 0.049 0.3743 0.081 0.8789 0.033 0.4882 0.033 0.9765v11.637h-3.0599v-10.352q0-1.2044-0.1139-2.2786-0.098-1.0905-0.4394-1.7415-0.3744-0.6999-1.0742-1.0417-0.6999-0.3581-2.0183-0.3581-1.2532 0-2.5227 0.6185-1.2533 0.6185-2.5065 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.8483-1.8554 1.4323-0.6673 3.0436-0.6673 1.8554 0 3.1412 0.7812 1.3021 0.7812 1.9368 2.1647 1.8555-1.5625 3.3854-2.2461 1.53-0.6998 3.2715-0.6998 2.9947 0 4.4107 1.8228 1.4323 1.8067 1.4323 5.0618z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1437.8 1648.3h-10.156v-2.9459h10.156z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1459.3 1657.4h-16.406v-3.4017q1.709-1.4648 3.4179-2.9297 1.7253-1.4648 3.2064-2.9133 3.1249-3.0274 4.2805-4.8014 1.1556-1.7904 1.1556-3.8574 0-1.888-1.2532-2.9459-1.237-1.0742-3.4668-1.0742-1.4811 0-3.2063 0.5208-1.7253 0.5208-3.3691 1.595h-0.1628v-3.4179q1.1556-0.5697 3.0761-1.0417 1.9369-0.472 3.7435-0.472 3.7272 0 5.843 1.8066 2.1159 1.7904 2.1159 4.8665 0 1.3835-0.3581 2.5879-0.3418 1.1881-1.0253 2.2623-0.6348 1.0091-1.4974 1.9857-0.8464 0.9766-2.0671 2.1647-1.7415 1.709-3.5969 3.3203-1.8555 1.595-3.4668 2.9622h13.037z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1478.4 1645.8q0.7812 0.6998 1.2858 1.7577 0.5045 1.058 0.5045 2.7344 0 1.6601-0.6022 3.0436-0.6022 1.3834-1.6927 2.4088-1.2207 1.1393-2.8808 1.6927-1.6439 0.5371-3.6132 0.5371-2.0183 0-3.9714-0.4883-1.9531-0.472-3.2063-1.0416v-3.4017h0.2441q1.3835 0.9115 3.2552 1.5137t3.6132 0.6022q1.0254 0 2.181-0.3418t1.8717-1.0091q0.7487-0.7162 1.1068-1.5788 0.3743-0.8626 0.3743-2.1809 0-1.3021-0.4231-2.1485-0.4069-0.8626-1.1393-1.3509-0.7325-0.5045-1.7741-0.6835-1.0417-0.1954-2.2461-0.1954h-1.4648v-2.7017h1.1393q2.4739 0 3.9388-1.0254 1.4811-1.0417 1.4811-3.0273 0-0.8789-0.3744-1.53-0.3743-0.6673-1.0416-1.0905-0.6999-0.4231-1.4974-0.5859-0.7975-0.1627-1.8066-0.1627-1.5462 0-3.2878 0.5533-1.7415 0.5534-3.2877 1.5625h-0.1627v-3.4016q1.1555-0.5697 3.0761-1.0417 1.9368-0.4883 3.7434-0.4883 1.7741 0 3.125 0.3255 1.3509 0.3256 2.4414 1.0417 1.1719 0.7812 1.7741 1.888t0.6022 2.5879q0 2.0182-1.4323 3.5318-1.416 1.4974-3.3528 1.888v0.2279q0.7812 0.1302 1.7903 0.5534 1.0091 0.4069 1.709 1.0254z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1501.9 1650.7q0 3.1412-2.4577 5.2245-2.4413 2.0833-6.1522 2.0833-3.9388 0-6.2825-2.0344-2.3275-2.0345-2.3275-5.2083 0-2.0182 1.1719-3.6458 1.1718-1.6439 3.304-2.6042v-0.098q-1.9531-1.0417-2.8971-2.2786-0.9277-1.237-0.9277-3.0925 0-2.7343 2.246-4.5572 2.2461-1.8229 5.7129-1.8229 3.6295 0 5.7942 1.7415t2.1647 4.4271q0 1.6438-1.0254 3.2389-1.0254 1.5787-3.0111 2.4739v0.098q2.2787 0.9766 3.4831 2.4089 1.2044 1.4322 1.2044 3.6458zm-3.8574-11.833q0-1.7415-1.3509-2.7669-1.3346-1.0417-3.4179-1.0417-2.0508 0-3.3691 0.9766-1.3021 0.9766-1.3021 2.6367 0 1.1719 0.651 2.0345 0.6673 0.8463 2.002 1.5136 0.6022 0.293 1.7252 0.765 1.1393 0.472 2.2135 0.7812 1.6113-1.0742 2.2298-2.2298 0.6185-1.1555 0.6185-2.6692zm0.5046 12.142q0-1.4974-0.6673-2.3925-0.6511-0.9115-2.5716-1.8229-0.765-0.3581-1.6765-0.6674-0.9114-0.3092-2.4251-0.8626-1.4648 0.7975-2.36 2.1647-0.8789 1.3672-0.8789 3.0924 0 2.1973 1.5137 3.6296 1.5137 1.4322 3.8411 1.4322 2.3763 0 3.7923-1.2207 1.4323-1.2206 1.4323-3.3528z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1528.5 1635.1h-0.1628q-0.5045-0.1465-1.3183-0.293-0.8138-0.1627-1.4323-0.1627-1.9694 0-2.8646 0.8789-0.8789 0.8626-0.8789 3.1412v0.6185h5.5176v2.5716h-5.4199v15.609h-3.0599v-15.609h-2.067v-2.5716h2.067v-0.6022q0-3.2389 1.6113-4.9641 1.6114-1.7416 4.655-1.7416 1.0253 0 1.8391 0.098 0.8301 0.098 1.5137 0.2279z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1545.5 1657.4h-3.0599v-2.0182q-1.5462 1.2206-2.9622 1.8717-1.416 0.651-3.125 0.651-2.8645 0-4.4596-1.7415-1.595-1.7578-1.595-5.1432v-11.8h3.0599v10.352q0 1.3834 0.1302 2.3762 0.1302 0.9766 0.5534 1.6765 0.4394 0.7161 1.1393 1.0416 0.6998 0.3255 2.0344 0.3255 1.1882 0 2.5879-0.6185 1.416-0.6184 2.6367-1.5787v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1566.7 1648.7h-13.395q0 1.6764 0.5046 2.9296 0.5045 1.237 1.3834 2.0345 0.8464 0.7812 2.002 1.1719 1.1718 0.3906 2.5716 0.3906 1.8554 0 3.7271-0.7324 1.888-0.7487 2.6856-1.4649h0.1627v3.3366q-1.5462 0.651-3.1575 1.0905-1.6113 0.4394-3.3854 0.4394-4.5247 0-7.0637-2.4413-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4252-7.08 2.4413-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3438q-0.016-2.4088-1.2207-3.7271-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4485 1.4485-1.6439 3.5969z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1574.5 1657.4h-3.0598v-25.325h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1595.8 1648.7h-13.395q0 1.6764 0.5046 2.9296 0.5045 1.237 1.3834 2.0345 0.8464 0.7812 2.0019 1.1719 1.1719 0.3906 2.5716 0.3906 1.8555 0 3.7272-0.7324 1.888-0.7487 2.6855-1.4649h0.1628v3.3366q-1.5462 0.651-3.1575 1.0905-1.6113 0.4394-3.3854 0.4394-4.5247 0-7.0638-2.4413-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1034zm-2.9785-2.3438q-0.016-2.4088-1.2207-3.7271-1.1882-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4485-1.6439 3.5969z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1615.1 1657.4h-3.0599v-1.9043q-1.3184 1.1393-2.7506 1.7741-1.4323 0.6347-3.1087 0.6347-3.2552 0-5.1758-2.5065-1.9042-2.5065-1.9042-6.9498 0-2.3111 0.651-4.1178 0.6673-1.8066 1.7903-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.651 3.0599-0.651 1.4323 0 2.539 0.3092 1.1068 0.293 2.3275 0.9277v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.5534-2.2135-0.765-0.9766-0.2116-2.1322-0.2116-2.5716 0-4.0038 1.7903-1.4323 1.7904-1.4323 5.0781 0 3.2389 1.1067 4.9316 1.1068 1.6764 3.5482 1.6764 1.3021 0 2.6367-0.5696 1.3346-0.586 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1647.6 1655.4q0 4.6224-2.0996 6.7871t-6.4615 2.1647q-1.4486 0-2.832-0.2116-1.3672-0.1953-2.7018-0.5697v-3.125h0.1627q0.7487 0.293 2.3763 0.7162 1.6276 0.4394 3.2552 0.4394 1.5625 0 2.5879-0.3743 1.0253-0.3744 1.595-1.0417 0.5696-0.6347 0.8138-1.5299 0.2441-0.8952 0.2441-2.0019v-1.6602q-1.3834 1.1068-2.6529 1.6602-1.2533 0.5371-3.2064 0.5371-3.2552 0-5.1757-2.3438-1.9043-2.36-1.9043-6.6405 0-2.3437 0.651-4.0364 0.6673-1.709 1.8067-2.946 1.0579-1.1556 2.5715-1.7903 1.5137-0.651 3.0111-0.651 1.5787 0 2.6367 0.3255 1.0742 0.3092 2.2623 0.9602l0.1953-0.7812h2.8646zm-3.0599-2.9296v-9.912q-1.2207-0.5534-2.2786-0.7813-1.0417-0.2441-2.0833-0.2441-2.5228 0-3.9713 1.6927-1.4486 1.6927-1.4486 4.9153 0 3.0598 1.0742 4.6386t3.5644 1.5788q1.3347 0 2.6693-0.5046 1.3509-0.5208 2.4739-1.3834z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1668.9 1648.7h-13.395q0 1.6764 0.5045 2.9296 0.5046 1.237 1.3835 2.0345 0.8463 0.7812 2.0019 1.1719 1.1719 0.3906 2.5716 0.3906 1.8554 0 3.7272-0.7324 1.888-0.7487 2.6855-1.4649h0.1628v3.3366q-1.5463 0.651-3.1576 1.0905-1.6113 0.4394-3.3854 0.4394-4.5246 0-7.0637-2.4413-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3438q-0.016-2.4088-1.2207-3.7271-1.1881-1.3184-3.6295-1.3184-2.4576 0-3.9225 1.4486-1.4485 1.4485-1.6438 3.5969z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1688.7 1657.4h-3.0599v-10.352q0-1.2532-0.1464-2.3437-0.1465-1.1068-0.5371-1.7253-0.4069-0.6836-1.1719-1.0091-0.765-0.3418-1.9857-0.3418-1.2532 0-2.6204 0.6185t-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554t3.1413-0.6673q2.9459 0 4.4921 1.774 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1709.8 1648.7h-13.395q0 1.6764 0.5045 2.9296 0.5046 1.237 1.3835 2.0345 0.8463 0.7812 2.0019 1.1719 1.1719 0.3906 2.5716 0.3906 1.8554 0 3.7272-0.7324 1.888-0.7487 2.6855-1.4649h0.1628v3.3366q-1.5463 0.651-3.1576 1.0905-1.6113 0.4394-3.3853 0.4394-4.5247 0-7.0638-2.4413-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3438q-0.016-2.4088-1.2207-3.7271-1.1881-1.3184-3.6295-1.3184-2.4576 0-3.9225 1.4486-1.4485 1.4485-1.6438 3.5969z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1725.8 1642.6h-0.1627q-0.6836-0.1628-1.3346-0.2279-0.6348-0.081-1.5137-0.081-1.416 0-2.7344 0.6348-1.3183 0.6185-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.6185 2.8482-0.6185 0.7976 0 1.1556 0.049 0.3581 0.033 1.0742 0.1465z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1742.8 1657.4h-3.0436v-1.9369q-0.4069 0.2767-1.1068 0.7813-0.6835 0.4882-1.3346 0.7812-0.7649 0.3744-1.7578 0.6185-0.9928 0.2604-2.3274 0.2604-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.0671 0.8789-3.3366 0.8952-1.2858 2.539-2.0182 1.6602-0.7324 3.9876-0.9928 2.3275-0.2604 4.9967-0.3906v-0.472q0-1.0417-0.3743-1.7253-0.3581-0.6836-1.0417-1.0742-0.651-0.3743-1.5625-0.5045-0.9114-0.1303-1.9043-0.1303-1.2044 0-2.6855 0.3256-1.4811 0.3092-3.0598 0.9114h-0.1628v-3.1087q0.8952-0.2441 2.5879-0.5371 1.6927-0.2929 3.3365-0.2929 1.9206 0 3.3366 0.3255 1.4323 0.3092 2.4739 1.0742 1.0254 0.7487 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081-3.304 0.2441-1.888 0.1628-2.9948 0.472-1.3183 0.3744-2.1321 1.1719-0.8138 0.7812-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.7812 2.8808 0.7812 1.6114 0 2.946-0.6185 1.3346-0.6347 2.4739-1.5136z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1758.2 1657.3q-0.8626 0.2279-1.888 0.3743-1.0091 0.1465-1.8066 0.1465-2.7832 0-4.2317-1.4974-1.4486-1.4973-1.4486-4.8013v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.065 2.2461 0.065 0.7975 0.4557 1.4974 0.3581 0.651 0.9766 0.9602 0.6347 0.293 1.9205 0.293 0.7487 0 1.5625-0.2116 0.8138-0.2278 1.1719-0.3743h0.1627z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1777.4 1648.3q0 4.4433-2.2786 7.0149t-6.1034 2.5716q-3.8574 0-6.1361-2.5716-2.2623-2.5716-2.2623-7.0149t2.2623-7.0149q2.2787-2.5878 6.1361-2.5878 3.8248 0 6.1034 2.5878 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5318-1.3834-5.2408-1.3835-1.7253-3.8411-1.7253-2.4903 0-3.8737 1.7253-1.3672 1.709-1.3672 5.2408 0 3.418 1.3835 5.192 1.3834 1.7578 3.8574 1.7578 2.4413 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1793.5 1642.6h-0.1628q-0.6836-0.1628-1.3346-0.2279-0.6348-0.081-1.5137-0.081-1.416 0-2.7343 0.6348-1.3184 0.6185-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8228-1.4648 3.2063-2.067 1.3997-0.6185 2.8483-0.6185 0.7975 0 1.1556 0.049 0.358 0.033 1.0742 0.1465z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1809.4 1652.2q0 2.4902-2.067 4.0853-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.4883-2.8157-1.0579v-3.4342h0.1627q1.4486 1.0904 3.2227 1.7415 1.774 0.6347 3.4016 0.6347 2.0182 0 3.1575-0.651 1.1394-0.651 1.1394-2.0508 0-1.0742-0.6185-1.6275-0.6185-0.5534-2.3763-0.944-0.651-0.1465-1.709-0.3418-1.0416-0.1953-1.9042-0.4232-2.3926-0.6348-3.4017-1.8555-0.9928-1.2369-0.9928-3.0273 0-1.123 0.4557-2.1158 0.472-0.9929 1.416-1.7741 0.9114-0.765 2.3112-1.2044 1.416-0.4557 3.1575-0.4557 1.6276 0 3.2877 0.4069 1.6764 0.3906 2.7832 0.9602v3.2715h-0.1628q-1.1718-0.8626-2.8482-1.4486-1.6765-0.6022-3.2878-0.6022-1.6764 0-2.832 0.6511-1.1556 0.6347-1.1556 1.9042 0 1.1231 0.6999 1.6927 0.6836 0.5697 2.2135 0.9277 0.8464 0.1954 1.888 0.3907 1.058 0.1953 1.7578 0.358 2.1322 0.4883 3.2877 1.6765 1.1556 1.2044 1.1556 3.19z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1841.5 1648.1q0 2.2135-0.6347 4.0527-0.6348 1.8228-1.7904 3.0924-1.0742 1.2044-2.539 1.8717-1.4486 0.651-3.0762 0.651-1.416 0-2.5716-0.3092-1.1393-0.3093-2.3274-0.9603v7.6171h-3.0599v-24.886h3.0599v1.9043q1.2207-1.0254 2.7343-1.709 1.53-0.6998 3.2552-0.6998 3.2878 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1575 0.081q0-3.2877-1.123-4.9153-1.1231-1.6276-3.4505-1.6276-1.3184 0-2.653 0.5697-1.3346 0.5696-2.5553 1.4974v10.303q1.3021 0.5859 2.2298 0.7975 0.944 0.2116 2.1321 0.2116 2.5553 0 3.9876-1.7252 1.4323-1.7253 1.4323-5.1107z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1857.6 1642.6h-0.1628q-0.6836-0.1628-1.3346-0.2279-0.6348-0.081-1.5136-0.081-1.4161 0-2.7344 0.6348-1.3183 0.6185-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2063-2.067 1.3997-0.6185 2.8483-0.6185 0.7975 0 1.1556 0.049 0.358 0.033 1.0742 0.1465z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1876 1648.3q0 4.4433-2.2787 7.0149-2.2786 2.5716-6.1034 2.5716-3.8574 0-6.136-2.5716-2.2624-2.5716-2.2624-7.0149t2.2624-7.0149q2.2786-2.5878 6.136-2.5878 3.8248 0 6.1034 2.5878 2.2787 2.5716 2.2787 7.0149zm-3.1576 0q0-3.5318-1.3834-5.2408-1.3835-1.7253-3.8411-1.7253-2.4902 0-3.8737 1.7253-1.3671 1.709-1.3671 5.2408 0 3.418 1.3834 5.192 1.3835 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1896.5 1639.2-7.3567 18.18h-3.0761l-7.3079-18.18h3.3203l5.6314 14.469 5.5827-14.469z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1903.8 1636.2h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0598v-18.18h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1924.5 1657.4h-3.0599v-1.9043q-1.3183 1.1393-2.7506 1.7741-1.4323 0.6347-3.1087 0.6347-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3111 0.651-4.1178 0.6673-1.8066 1.7904-3.0761 1.1067-1.237 2.5716-1.888 1.4811-0.651 3.0598-0.651 1.4323 0 2.5391 0.3092 1.1067 0.293 2.3274 0.9277v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.5534-2.2135-0.765-0.9766-0.2116-2.1322-0.2116-2.5715 0-4.0038 1.7903-1.4323 1.7904-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1067 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.5696 1.3346-0.586 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1945.7 1648.7h-13.395q0 1.6764 0.5046 2.9296 0.5045 1.237 1.3834 2.0345 0.8464 0.7812 2.002 1.1719 1.1718 0.3906 2.5716 0.3906 1.8554 0 3.7271-0.7324 1.888-0.7487 2.6856-1.4649h0.1627v3.3366q-1.5462 0.651-3.1575 1.0905-1.6113 0.4394-3.3854 0.4394-4.5247 0-7.0637-2.4413-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1034zm-2.9785-2.3438q-0.016-2.4088-1.2207-3.7271-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4485-1.6439 3.5969z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1976.7 1657.4h-13.118v-2.474h5.0455v-16.243h-5.0455v-2.2135q1.0254 0 2.1972-0.1628 1.1719-0.179 1.7741-0.5045 0.7487-0.4069 1.1719-1.0254 0.4394-0.6348 0.5045-1.6927h2.5228v21.842h4.9478z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1999.1 1649.7q0 1.6927-0.6184 3.2389-0.6185 1.5462-1.6927 2.6041-1.1719 1.1393-2.7995 1.7578-1.6113 0.6022-3.7434 0.6022-1.9857 0-3.8249-0.4232-1.8391-0.4069-3.1087-0.9928v-3.4342h0.2279q1.3346 0.8463 3.125 1.4486 1.7903 0.5859 3.5156 0.5859 1.1555 0 2.2298-0.3255 1.0904-0.3256 1.9368-1.1393 0.7161-0.6999 1.0742-1.6765 0.3743-0.9765 0.3743-2.2623 0-1.2533-0.4394-2.1159-0.4232-0.8626-1.1882-1.3834-0.8463-0.6185-2.067-0.8626-1.2044-0.2605-2.7018-0.2605-1.4323 0-2.7669 0.1954-1.3183 0.1953-2.2786 0.3906v-12.484h14.583v2.8483h-11.442v6.4452q0.6999-0.065 1.4323-0.098t1.2695-0.033q1.9694 0 3.4505 0.3418 1.4811 0.3255 2.7181 1.1719 1.3021 0.8951 2.0182 2.3111t0.7161 3.5482z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2020.3 1649.7q0 1.6927-0.6185 3.2389t-1.6927 2.6041q-1.1718 1.1393-2.7994 1.7578-1.6113 0.6022-3.7435 0.6022-1.9856 0-3.8248-0.4232-1.8392-0.4069-3.1087-0.9928v-3.4342h0.2279q1.3346 0.8463 3.1249 1.4486 1.7904 0.5859 3.5156 0.5859 1.1556 0 2.2298-0.3255 1.0905-0.3256 1.9368-1.1393 0.7162-0.6999 1.0742-1.6765 0.3744-0.9765 0.3744-2.2623 0-1.2533-0.4395-2.1159-0.4231-0.8626-1.1881-1.3834-0.8463-0.6185-2.067-0.8626-1.2045-0.2605-2.7018-0.2605-1.4323 0-2.7669 0.1954-1.3184 0.1953-2.2787 0.3906v-12.484h14.583v2.8483h-11.442v6.4452q0.6999-0.065 1.4323-0.098t1.2695-0.033q1.9694 0 3.4505 0.3418 1.4811 0.3255 2.718 1.1719 1.3021 0.8951 2.0183 2.3111 0.7161 1.416 0.7161 3.5482z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2065.9 1633.2-6.2988 24.235h-3.6295l-5.0944-20.117-4.9804 20.117h-3.5481l-6.4127-24.235h3.304l5.0943 20.15 5.013-20.15h3.2714l5.0618 20.345 5.0618-20.345z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2097.6 1648.3q0 4.4433-2.2787 7.0149-2.2786 2.5716-6.1034 2.5716-3.8574 0-6.136-2.5716-2.2624-2.5716-2.2624-7.0149t2.2624-7.0149q2.2786-2.5878 6.136-2.5878 3.8248 0 6.1034 2.5878 2.2787 2.5716 2.2787 7.0149zm-3.1576 0q0-3.5318-1.3834-5.2408-1.3835-1.7253-3.8411-1.7253-2.4902 0-3.8737 1.7253-1.3671 1.709-1.3671 5.2408 0 3.418 1.3834 5.192 1.3835 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2112.1 1635.1h-0.1627q-0.5046-0.1465-1.3184-0.293-0.8138-0.1627-1.4323-0.1627-1.9693 0-2.8645 0.8789-0.8789 0.8626-0.8789 3.1412v0.6185h5.5175v2.5716h-5.4199v15.609h-3.0598v-15.609h-2.0671v-2.5716h2.0671v-0.6022q0-3.2389 1.6113-4.9641 1.6113-1.7416 4.6549-1.7416 1.0254 0 1.8392 0.098 0.83 0.098 1.5136 0.2279z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2141 1648.7h-13.395q0 1.6764 0.5045 2.9296 0.5046 1.237 1.3835 2.0345 0.8463 0.7812 2.0019 1.1719 1.1719 0.3906 2.5716 0.3906 1.8555 0 3.7272-0.7324 1.888-0.7487 2.6855-1.4649h0.1628v3.3366q-1.5463 0.651-3.1576 1.0905-1.6113 0.4394-3.3853 0.4394-4.5247 0-7.0638-2.4413-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3438q-0.016-2.4088-1.2206-3.7271-1.1882-1.3184-3.6296-1.3184-2.4576 0-3.9225 1.4486-1.4485 1.4485-1.6438 3.5969z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2148.7 1657.4h-3.0599v-25.325h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2170 1648.7h-13.395q0 1.6764 0.5046 2.9296 0.5045 1.237 1.3834 2.0345 0.8464 0.7812 2.0019 1.1719 1.1719 0.3906 2.5716 0.3906 1.8555 0 3.7272-0.7324 1.888-0.7487 2.6855-1.4649h0.1628v3.3366q-1.5462 0.651-3.1575 1.0905-1.6113 0.4394-3.3854 0.4394-4.5247 0-7.0637-2.4413-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1034zm-2.9785-2.3438q-0.016-2.4088-1.2207-3.7271-1.1882-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4485-1.6439 3.5969z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2188.1 1656.3q-1.5299 0.7325-2.9134 1.1394-1.3671 0.4069-2.9133 0.4069-1.9694 0-3.6133-0.5697-1.6439-0.5859-2.8157-1.7578-1.1882-1.1719-1.8392-2.9622-0.651-1.7904-0.651-4.1829 0-4.4596 2.4414-6.9986 2.4576-2.5391 6.4778-2.5391 1.5624 0 3.0598 0.4395 1.5137 0.4394 2.7669 1.0742v3.4016h-0.1627q-1.3998-1.0904-2.8971-1.6764-1.4812-0.5859-2.8972-0.5859-2.6041 0-4.1178 1.7578-1.4973 1.7415-1.4973 5.1269 0 3.2877 1.4648 5.0618 1.4811 1.7578 4.1503 1.7578 0.9278 0 1.888-0.2442 0.9603-0.2441 1.7253-0.6347 0.6673-0.3418 1.2532-0.7161 0.586-0.3907 0.9278-0.6674h0.1627z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2201.5 1657.3q-0.8626 0.2279-1.888 0.3743-1.0091 0.1465-1.8066 0.1465-2.7832 0-4.2318-1.4974-1.4485-1.4973-1.4485-4.8013v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.7975 0.4558 1.4974 0.358 0.651 0.9765 0.9602 0.6348 0.293 1.9206 0.293 0.7487 0 1.5625-0.2116 0.8138-0.2278 1.1718-0.3743h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2216.6 1642.6h-0.1627q-0.6836-0.1628-1.3346-0.2279-0.6348-0.081-1.5137-0.081-1.416 0-2.7343 0.6348-1.3184 0.6185-2.5391 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.6185 2.8482-0.6185 0.7976 0 1.1556 0.049 0.3581 0.033 1.0742 0.1465z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2222.8 1636.2h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2242.1 1656.3q-1.53 0.7325-2.9134 1.1394-1.3672 0.4069-2.9134 0.4069-1.9694 0-3.6132-0.5697-1.6439-0.5859-2.8158-1.7578-1.1881-1.1719-1.8391-2.9622-0.6511-1.7904-0.6511-4.1829 0-4.4596 2.4414-6.9986 2.4577-2.5391 6.4778-2.5391 1.5625 0 3.0599 0.4395 1.5136 0.4394 2.7669 1.0742v3.4016h-0.1628q-1.3997-1.0904-2.8971-1.6764-1.4811-0.5859-2.8971-0.5859-2.6041 0-4.1178 1.7578-1.4974 1.7415-1.4974 5.1269 0 3.2877 1.4649 5.0618 1.4811 1.7578 4.1503 1.7578 0.9277 0 1.888-0.2442 0.9603-0.2441 1.7253-0.6347 0.6673-0.3418 1.2532-0.7161 0.5859-0.3907 0.9277-0.6674h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2273.7 1648.1q0 2.2135-0.6348 4.0527-0.6348 1.8228-1.7904 3.0924-1.0742 1.2044-2.539 1.8717-1.4485 0.651-3.0761 0.651-1.416 0-2.5716-0.3092-1.1393-0.3093-2.3275-0.9603v7.6171h-3.0598v-24.886h3.0598v1.9043q1.2207-1.0254 2.7344-1.709 1.5299-0.6998 3.2552-0.6998 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1576 0.081q0-3.2877-1.123-4.9153t-3.4505-1.6276q-1.3183 0-2.653 0.5697-1.3346 0.5696-2.5553 1.4974v10.303q1.3021 0.5859 2.2298 0.7975 0.944 0.2116 2.1322 0.2116 2.5553 0 3.9876-1.7252 1.4322-1.7253 1.4322-5.1107z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2294 1648.3q0 4.4433-2.2787 7.0149-2.2786 2.5716-6.1034 2.5716-3.8574 0-6.136-2.5716-2.2624-2.5716-2.2624-7.0149t2.2624-7.0149q2.2786-2.5878 6.136-2.5878 3.8248 0 6.1034 2.5878 2.2787 2.5716 2.2787 7.0149zm-3.1576 0q0-3.5318-1.3834-5.2408-1.3835-1.7253-3.8411-1.7253-2.4902 0-3.8737 1.7253-1.3671 1.709-1.3671 5.2408 0 3.418 1.3834 5.192 1.3835 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2321.6 1639.2-4.7362 18.18h-2.8321l-4.6711-14.014-4.6387 14.014h-2.8157l-4.7851-18.18h3.1901l3.3365 14.079 4.541-14.079h2.5228l4.6549 14.079 3.1575-14.079z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2341.3 1648.7h-13.395q0 1.6764 0.5046 2.9296 0.5045 1.237 1.3834 2.0345 0.8464 0.7812 2.002 1.1719 1.1718 0.3906 2.5716 0.3906 1.8554 0 3.7271-0.7324 1.888-0.7487 2.6856-1.4649h0.1627v3.3366q-1.5462 0.651-3.1575 1.0905-1.6113 0.4394-3.3854 0.4394-4.5247 0-7.0637-2.4413-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4252-7.08 2.4413-2.6204 6.4126-2.6204 3.6784 0 5.6641 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3438q-0.016-2.4088-1.2207-3.7271-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4485 1.4485-1.6439 3.5969z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2357.2 1642.6h-0.1628q-0.6835-0.1628-1.3346-0.2279-0.6347-0.081-1.5136-0.081-1.416 0-2.7344 0.6348-1.3183 0.6185-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2063-2.067 1.3997-0.6185 2.8483-0.6185 0.7975 0 1.1556 0.049 0.3581 0.033 1.0742 0.1465z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.328 0 0 .99783 -2472.9 1519)",
    fill: "#c83737"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 109.66,
    width: 859.43,
    height: 39.433,
    fill: "#c83737"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Label-HVM"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m2257.7 310.86 6.4084 171.03 76.528 0.0393",
    fill: "none",
    stroke: "#f44336",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "Helium Vector Magnetometer"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m2398.6 466.01h-5.6543v-19.717h-21.504v19.717h-5.625v-42.656h5.625v18.34h21.504v-18.34h5.6543z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m2420.9 466.59q-6.4453 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.99609q0-4.7168 1.7871-8.4082 1.8164-3.7207 5.0391-5.8008 3.2519-2.1094 7.0312-2.1094 6.1817 0 9.6094 4.0723t3.4277 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6367 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719t3.4863-3.1055l3.3106 2.5781q-3.9844 6.123-11.953 6.123zm-0.6738-28.418q-3.2812 0-5.5078 2.4023-2.2266 2.373-2.7539 6.6797h15.879v-0.41015q-0.2344-4.1309-2.2266-6.3867-1.9921-2.2852-5.3906-2.2852z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m2445.4 466.01h-5.4199v-45h5.4199z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m2459.9 466.01h-5.4199v-31.699h5.4199zm-5.8594-40.107q0-1.3184 0.791-2.2266 0.8203-0.90821 2.4024-0.90821 1.582 0 2.4023 0.90821 0.8203 0.9082 0.8203 2.2266t-0.8203 2.1973-2.4023 0.8789q-1.5821 0-2.4024-0.8789-0.791-0.87891-0.791-2.1973z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m2488.1 462.87q-3.1641 3.7207-9.2871 3.7207-5.0684 0-7.7344-2.9297-2.6367-2.959-2.666-8.7305v-20.625h5.4199v20.479q0 7.207 5.8594 7.207 6.2109 0 8.2617-4.6289v-23.057h5.4199v31.699h-5.1562z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m2506.7 434.31 0.1465 3.5156q3.4863-4.1016 9.4043-4.1016 6.6504 0 9.0527 5.0976 1.582-2.2852 4.1016-3.6914 2.5488-1.4062 6.0058-1.4062 10.43 0 10.606 11.045v21.24h-5.4199v-20.918q0-3.3984-1.5528-5.0684-1.5527-1.6992-5.2148-1.6992-3.0176 0-5.0098 1.8164-1.9922 1.7871-2.3144 4.834v21.035h-5.4492v-20.771q0-6.9141-6.7676-6.9141-5.332 0-7.2949 4.541v23.145h-5.42v-31.699z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m2584.1 458.54 12.188-35.186h6.1524l-15.82 42.656h-4.9805l-15.791-42.656h6.123z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m2619.2 466.59q-6.4453 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.99609q0-4.7168 1.7872-8.4082 1.8164-3.7207 5.039-5.8008 3.252-2.1094 7.0313-2.1094 6.1816 0 9.6093 4.0723 3.4278 4.0723 3.4278 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6367 2.8711 6.6797 2.8711 2.8711 0 4.8632-1.1719 1.9922-1.1719 3.4864-3.1055l3.3105 2.5781q-3.9844 6.123-11.953 6.123zm-0.6738-28.418q-3.2813 0-5.5078 2.4023-2.2266 2.373-2.7539 6.6797h15.879v-0.41015q-0.2344-4.1309-2.2266-6.3867-1.9922-2.2852-5.3906-2.2852z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m2650.5 462.17q2.9003 0 5.0683-1.7578t2.4024-4.3945h5.1269q-0.1465 2.7246-1.875 5.1855t-4.6289 3.9258q-2.8711 1.4648-6.0937 1.4648-6.4747 0-10.312-4.3066-3.8086-4.3359-3.8086-11.836v-0.9082q0-4.6289 1.6992-8.2324t4.8633-5.5957q3.1933-1.9922 7.5293-1.9922 5.332 0 8.8476 3.1934 3.5449 3.1934 3.7793 8.291h-5.1269q-0.2344-3.0762-2.3438-5.0391-2.0801-1.9922-5.1562-1.9922-4.1309 0-6.4161 2.9883-2.2558 2.959-2.2558 8.584v1.0254q0 5.4785 2.2558 8.4375 2.2559 2.959 6.4454 2.959z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m2676.5 426.63v7.6758h5.9179v4.1895h-5.9179v19.658q0 1.9043 0.791 2.8711 0.791 0.9375 2.6953 0.9375 0.9375 0 2.5781-0.35156v4.3945q-2.1386 0.58594-4.1601 0.58594-3.6328 0-5.4785-2.1973t-1.8457-6.2402v-19.658h-5.7715v-4.1895h5.7715v-7.6758z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m2686.7 449.86q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0977-5.7422 3.2812-2.0215 7.4707-2.0215 6.4746 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.38086q0 4.6289-1.7871 8.3203-1.7578 3.6621-5.0684 5.7129-3.2812 2.0508-7.5585 2.0508-6.4454 0-10.459-4.4824-3.9844-4.4824-3.9844-11.865zm5.4492 0.64454q0 5.2734 2.4317 8.4668 2.4609 3.1934 6.5625 3.1934 4.1308 0 6.5625-3.2226 2.4316-3.252 2.4316-9.082 0-5.2148-2.4902-8.4375-2.461-3.252-6.5625-3.252-4.0137 0-6.4747 3.1934-2.4609 3.1934-2.4609 9.1406z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m2737.7 439.17q-1.2305-0.20507-2.6661-0.20507-5.332 0-7.2363 4.541v22.5h-5.4199v-31.699h5.2734l0.088 3.6621q2.666-4.248 7.5586-4.248 1.582 0 2.4024 0.41015z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m2373.1 498.35 13.945 34.805 13.945-34.805h7.2949v42.656h-5.625v-16.611l0.5273-17.93-14.004 34.541h-4.3066l-13.975-34.453 0.5566 17.842v16.611h-5.625v-42.656z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m2436.9 541.01q-0.4687-0.9375-0.7617-3.3398-3.7793 3.9258-9.0234 3.9258-4.6875 0-7.7051-2.6367-2.9883-2.666-2.9883-6.7383 0-4.9512 3.75-7.6758 3.7793-2.7539 10.606-2.7539h5.2734v-2.4902q0-2.8418-1.6992-4.5117-1.6992-1.6992-5.0098-1.6992-2.9003 0-4.8632 1.4648t-1.9629 3.5449h-5.4492q0-2.373 1.6699-4.5703 1.6992-2.2266 4.5703-3.5156 2.9004-1.2891 6.3574-1.2891 5.4785 0 8.584 2.7539 3.1055 2.7246 3.2227 7.5293v14.59q0 4.3652 1.1132 6.9434v0.46875zm-8.9941-4.1309q2.5488 0 4.834-1.3184 2.2851-1.3184 3.3105-3.4277v-6.5039h-4.248q-9.961 0-9.961 5.8301 0 2.5488 1.6993 3.9844 1.6992 1.4355 4.3652 1.4355z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m2448.7 524.89q0-7.4121 3.4277-11.777 3.4277-4.3945 9.082-4.3945 5.8008 0 9.0528 4.1016l0.2636-3.5156h4.9512v30.938q0 6.1524-3.6621 9.6973-3.6328 3.5449-9.7851 3.5449-3.4278 0-6.709-1.4648-3.2813-1.4648-5.0098-4.0137l2.8125-3.252q3.4863 4.3066 8.5254 4.3066 3.9551 0 6.1523-2.2266 2.2266-2.2266 2.2266-6.2695v-2.7246q-3.252 3.75-8.877 3.75-5.5664 0-9.0234-4.4824-3.4277-4.4824-3.4277-12.217zm5.4492 0.61524q0 5.3613 2.1973 8.4375 2.1972 3.0469 6.1523 3.0469 5.127 0 7.5293-4.6582v-14.473q-2.4902-4.541-7.4707-4.541-3.9551 0-6.1816 3.0762-2.2266 3.0762-2.2266 9.1113z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m2488.8 509.31 0.1758 3.9844q3.6328-4.5703 9.4922-4.5703 10.049 0 10.137 11.338v20.947h-5.4199v-20.977q-0.029-3.4277-1.5821-5.0684-1.5234-1.6406-4.7754-1.6406-2.6367 0-4.6289 1.4062-1.9921 1.4062-3.1054 3.6914v22.588h-5.4199v-31.699z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m2530 541.59q-6.4453 0-10.488-4.2188-4.0429-4.248-4.0429-11.338v-0.99609q0-4.7168 1.7871-8.4082 1.8164-3.7207 5.039-5.8008 3.252-2.1094 7.0313-2.1094 6.1816 0 9.6094 4.0723 3.4277 4.0723 3.4277 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6367 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719 1.9921-1.1719 3.4863-3.1055l3.3105 2.5781q-3.9843 6.123-11.953 6.123zm-0.6738-28.418q-3.2813 0-5.5078 2.4023-2.2266 2.373-2.7539 6.6797h15.879v-0.41015q-0.2344-4.1309-2.2266-6.3867-1.9922-2.2852-5.3906-2.2852z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m2555.9 501.63v7.6758h5.918v4.1895h-5.918v19.658q0 1.9043 0.7911 2.8711 0.791 0.9375 2.6953 0.9375 0.9375 0 2.5781-0.35156v4.3945q-2.1387 0.58594-4.1602 0.58594-3.6328 0-5.4785-2.1973t-1.8457-6.2402v-19.658h-5.7715v-4.1895h5.7715v-7.6758z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m2566.1 524.86q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0976-5.7422 3.2813-2.0215 7.4707-2.0215 6.4746 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.38086q0 4.6289-1.7871 8.3203-1.7578 3.6621-5.0684 5.7129-3.2812 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9843-4.4824-3.9843-11.865zm5.4492 0.64454q0 5.2734 2.4316 8.4668 2.461 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2226 2.4317-3.252 2.4317-9.082 0-5.2148-2.4903-8.4375-2.4609-3.252-6.5625-3.252-4.0137 0-6.4746 3.1934t-2.4609 9.1406z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m2606.9 509.31 0.1465 3.5156q3.4863-4.1016 9.4043-4.1016 6.6504 0 9.0527 5.0976 1.5821-2.2852 4.1016-3.6914 2.5488-1.4062 6.0058-1.4062 10.43 0 10.606 11.045v21.24h-5.4199v-20.918q0-3.3984-1.5527-5.0684-1.5528-1.6992-5.2149-1.6992-3.0176 0-5.0098 1.8164-1.9921 1.7871-2.3144 4.834v21.035h-5.4492v-20.771q0-6.9141-6.7676-6.9141-5.332 0-7.2949 4.541v23.145h-5.4199v-31.699z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m2667.6 541.59q-6.4453 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.99609q0-4.7168 1.7871-8.4082 1.8164-3.7207 5.0391-5.8008 3.2519-2.1094 7.0312-2.1094 6.1816 0 9.6094 4.0723 3.4277 4.0723 3.4277 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6367 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719t3.4863-3.1055l3.3106 2.5781q-3.9844 6.123-11.953 6.123zm-0.6738-28.418q-3.2812 0-5.5078 2.4023-2.2266 2.373-2.7539 6.6797h15.879v-0.41015q-0.2344-4.1309-2.2266-6.3867-1.9922-2.2852-5.3906-2.2852z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m2693.5 501.63v7.6758h5.9179v4.1895h-5.9179v19.658q0 1.9043 0.791 2.8711 0.791 0.9375 2.6953 0.9375 0.9375 0 2.5781-0.35156v4.3945q-2.1387 0.58594-4.1601 0.58594-3.6328 0-5.4786-2.1973-1.8457-2.1973-1.8457-6.2402v-19.658h-5.7714v-4.1895h5.7714v-7.6758z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m2718.9 541.59q-6.4454 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.99609q0-4.7168 1.7871-8.4082 1.8164-3.7207 5.0391-5.8008 3.2519-2.1094 7.0312-2.1094 6.1817 0 9.6094 4.0723t3.4277 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6368 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719t3.4863-3.1055l3.3106 2.5781q-3.9844 6.123-11.953 6.123zm-0.6739-28.418q-3.2812 0-5.5078 2.4023-2.2265 2.373-2.7539 6.6797h15.879v-0.41015q-0.2344-4.1309-2.2265-6.3867-1.9922-2.2852-5.3907-2.2852z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m2752.8 514.17q-1.2304-0.20507-2.666-0.20507-5.332 0-7.2363 4.541v22.5h-5.4199v-31.699h5.2734l0.088 3.6621q2.666-4.248 7.5586-4.248 1.582 0 2.4023 0.41015z"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m2360.3 411.96h398v65h-398zm0 80.281h398v65h-398z",
    strokeWidth: 0.67093
  })), /*#__PURE__*/React.createElement("g", {
    className: "captionText",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      inlineSize: 533.793,
      whiteSpace: "pre"
    },
    "aria-label": "Helium-filled cell used to map Jupiter's magnetic field"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2383.2 594h-3.2227v-11.865h-12.093v11.865h-3.2227v-24.235h3.2227v9.5051h12.093v-9.5051h3.2227z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2404.7 585.23h-13.395q0 1.6764 0.5045 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78125 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73242 1.888-0.74869 2.6855-1.4648h0.1627v3.3366q-1.5462 0.65103-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4576 0-3.9225 1.4486-1.4485 1.4486-1.6438 3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2412.4 594h-3.0598v-25.325h3.0598z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2421.8 572.78h-3.4505v-3.1738h3.4505zm-0.1954 21.224h-3.0598v-18.18h3.0598z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2442.8 594h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717-1.416 0.65103-3.125 0.65103-2.8645 0-4.4595-1.7415-1.5951-1.7578-1.5951-5.1432v-11.8h3.0599v10.351q0 1.3834 0.1302 2.3763 0.1302 0.97655 0.5534 1.6764 0.4394 0.71614 1.1393 1.0417 0.6998 0.32552 2.0345 0.32552 1.1881 0 2.5878-0.61848 1.416-0.61849 2.6367-1.5788v-13.574h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2475.3 594h-3.0598v-10.351q0-1.1719-0.1139-2.2624-0.098-1.0905-0.4395-1.7415-0.3743-0.69986-1.0742-1.0579t-2.0182-0.35807q-1.2858 0-2.5716 0.65104-1.2858 0.63476-2.5716 1.6276 0.049 0.37435 0.081 0.8789 0.033 0.48828 0.033 0.97656v11.637h-3.0598v-10.351q0-1.2044-0.114-2.2786-0.098-1.0905-0.4394-1.7415-0.3743-0.69987-1.0742-1.0417-0.6999-0.35807-2.0182-0.35807-1.2533 0-2.5228 0.61849-1.2532 0.61848-2.5065 1.5788v13.574h-3.0598v-18.18h3.0598v2.0182q1.4323-1.1881 2.8483-1.8554 1.4323-0.66731 3.0436-0.66731 1.8555 0 3.1412 0.78124 1.3021 0.78124 1.9369 2.1647 1.8554-1.5625 3.3854-2.2461 1.5299-0.69986 3.2714-0.69986 2.9948 0 4.4108 1.8229 1.4322 1.8066 1.4322 5.0618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2490.9 584.87h-10.156v-2.9459h10.156z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2506.2 571.64h-0.1627q-0.5046-0.14648-1.3184-0.29296-0.8138-0.16276-1.4322-0.16276-1.9694 0-2.8646 0.87889-0.8789 0.86263-0.8789 3.1412v0.61848h5.5175v2.5716h-5.4198v15.609h-3.0599v-15.609h-2.067v-2.5716h2.067v-0.60221q0-3.2389 1.6113-4.9641 1.6113-1.7415 4.6549-1.7415 1.0254 0 1.8392 0.0977 0.8301 0.0977 1.5136 0.22786z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2511.4 572.78h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2520.4 594h-3.0599v-25.325h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2529.6 594h-3.0599v-25.325h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2550.9 585.23h-13.395q0 1.6764 0.5046 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78125 2.0019 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7271-0.73242 1.8881-0.74869 2.6856-1.4648h0.1627v3.3366q-1.5462 0.65103-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4413-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4485 1.4486-1.6439 3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2570.3 594h-3.0599v-1.9043q-1.3183 1.1393-2.7506 1.7741t-3.1087 0.63476q-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.651-4.1178 0.6673-1.8066 1.7904-3.0761 1.1067-1.237 2.5716-1.888 1.4811-0.65103 3.0598-0.65103 1.4323 0 2.5391 0.30924 1.1067 0.29297 2.3274 0.92773v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.55338-2.2135-0.76496-0.9766-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7904-1.4323 1.7903-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1067 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2601.4 592.86q-1.53 0.73241-2.9134 1.1393-1.3672 0.4069-2.9134 0.4069-1.9694 0-3.6133-0.56966-1.6438-0.58593-2.8157-1.7578-1.1881-1.1719-1.8392-2.9622-0.651-1.7903-0.651-4.1829 0-4.4596 2.4414-6.9986 2.4577-2.539 6.4778-2.539 1.5625 0 3.0599 0.43945 1.5136 0.43945 2.7669 1.0742v3.4016h-0.1628q-1.3997-1.0905-2.8971-1.6764-1.4811-0.58593-2.8971-0.58593-2.6042 0-4.1178 1.7578-1.4974 1.7415-1.4974 5.1269 0 3.2877 1.4648 5.0618 1.4811 1.7578 4.1504 1.7578 0.9277 0 1.888-0.24414t1.7252-0.63476q0.6673-0.34179 1.2533-0.71614 0.5859-0.39062 0.9277-0.66731h0.1628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2620.6 585.23h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78125 2.002 1.1719 1.1718 0.39062 2.5715 0.39062 1.8555 0 3.7272-0.73242 1.888-0.74869 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65103-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2628.3 594h-3.0599v-25.325h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2637.5 594h-3.0599v-25.325h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2670.4 594h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717-1.416 0.65103-3.125 0.65103-2.8645 0-4.4596-1.7415-1.595-1.7578-1.595-5.1432v-11.8h3.0599v10.351q0 1.3834 0.1302 2.3763 0.1302 0.97655 0.5534 1.6764 0.4394 0.71614 1.1393 1.0417 0.6998 0.32552 2.0345 0.32552 1.1881 0 2.5878-0.61848 1.416-0.61849 2.6367-1.5788v-13.574h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2689.4 588.76q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.1627q1.4486 1.0905 3.2226 1.7415 1.7741 0.63476 3.4017 0.63476 2.0182 0 3.1575-0.65103 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.6185-1.6276-0.6184-0.55338-2.3762-0.944-0.6511-0.14649-1.709-0.3418-1.0417-0.19531-1.9043-0.42317-2.3925-0.63476-3.4016-1.8554-0.9929-1.237-0.9929-3.0273 0-1.123 0.4558-2.1159 0.472-0.99283 1.416-1.7741 0.9114-0.76496 2.3111-1.2044 1.416-0.45573 3.1576-0.45573 1.6275 0 3.2877 0.4069 1.6764 0.39062 2.7832 0.96028v3.2714h-0.1628q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65103-1.1556 0.63476-1.1556 1.9043 0 1.123 0.6999 1.6927 0.6836 0.56966 2.2135 0.92773 0.8463 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48827 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2709 585.23h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78125 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8555 0 3.7272-0.73242 1.888-0.74869 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65103-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1882-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2728.4 594h-3.0598v-1.9043q-1.3184 1.1393-2.7507 1.7741-1.4322 0.63476-3.1087 0.63476-3.2551 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.6511-4.1178 0.6673-1.8066 1.7903-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65103 3.0599-0.65103 1.4322 0 2.539 0.30924 1.1068 0.29297 2.3275 0.92773v-7.8775h3.0598zm-3.0598-4.4759v-10.433q-1.237-0.55338-2.2136-0.76496-0.9765-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7904-1.4322 1.7903-1.4322 5.0781 0 3.2389 1.1067 4.9316 1.1068 1.6764 3.5482 1.6764 1.302 0 2.6366-0.56966 1.3347-0.58593 2.4903-1.4974z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2755.6 593.84q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.065 2.2461 0.065 0.79752 0.4557 1.4974 0.3581 0.65103 0.9766 0.96027 0.6347 0.29297 1.9205 0.29297 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37434h0.1627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2774.8 584.92q0 4.4433-2.2787 7.0149-2.2786 2.5716-6.1034 2.5716-3.8574 0-6.136-2.5716-2.2624-2.5716-2.2624-7.0149 0-4.4433 2.2624-7.0149 2.2786-2.5879 6.136-2.5879 3.8248 0 6.1034 2.5879 2.2787 2.5716 2.2787 7.0149zm-3.1576 0q0-3.5319-1.3834-5.2408-1.3835-1.7252-3.8411-1.7252-2.4902 0-3.8737 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3835 5.192 1.3834 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2817.8 594h-3.0599v-10.351q0-1.1719-0.1139-2.2624-0.098-1.0905-0.4395-1.7415-0.3743-0.69986-1.0742-1.0579t-2.0182-0.35807q-1.2858 0-2.5716 0.65104-1.2858 0.63476-2.5716 1.6276 0.049 0.37435 0.081 0.8789 0.032 0.48828 0.032 0.97656v11.637h-3.0598v-10.351q0-1.2044-0.114-2.2786-0.098-1.0905-0.4394-1.7415-0.3743-0.69987-1.0742-1.0417-0.6999-0.35807-2.0182-0.35807-1.2533 0-2.5228 0.61849-1.2532 0.61848-2.5065 1.5788v13.574h-3.0598v-18.18h3.0598v2.0182q1.4323-1.1881 2.8483-1.8554 1.4323-0.66731 3.0436-0.66731 1.8555 0 3.1412 0.78124 1.3021 0.78124 1.9369 2.1647 1.8554-1.5625 3.3854-2.2461 1.5299-0.69986 3.2714-0.69986 2.9948 0 4.4108 1.8229 1.4323 1.8066 1.4323 5.0618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2837.8 594h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6836 0.48828-1.3346 0.78124-0.765 0.37435-1.7578 0.61849-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1667-1.6276-1.7089-1.6276-1.7089-4.1504 0-2.067 0.8789-3.3366 0.8951-1.2858 2.539-2.0182 1.6601-0.73241 3.9876-0.99283 2.3274-0.26041 4.9967-0.39062v-0.472q0-1.0417-0.3744-1.7252-0.358-0.68359-1.0416-1.0742-0.6511-0.37435-1.5625-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1627v-3.1087q0.8951-0.24414 2.5878-0.5371 1.6927-0.29297 3.3366-0.29297 1.9205 0 3.3366 0.32552 1.4322 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3183 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.946-0.61848 1.3346-0.63476 2.4739-1.5137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2859.7 584.69q0 2.2135-0.6348 4.0527-0.6347 1.8229-1.7903 3.0924-1.0742 1.2044-2.5391 1.8717-1.4485 0.65104-3.0761 0.65104-1.416 0-2.5716-0.30924-1.1393-0.30925-2.3274-0.96028v7.6171h-3.0599v-24.886h3.0599v1.9043q1.2206-1.0254 2.7343-1.709 1.5299-0.69986 3.2552-0.69986 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1575 0.0814q0-3.2877-1.1231-4.9153-1.123-1.6276-3.4505-1.6276-1.3183 0-2.6529 0.56966-1.3347 0.56965-2.5553 1.4974v10.303q1.302 0.58593 2.2298 0.79752 0.944 0.21158 2.1321 0.21158 2.5553 0 3.9876-1.7252t1.4323-5.1106z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2373.6 629.37q0 3.1901-1.9531 4.9153-1.9369 1.7252-5.2083 1.7252-0.7813 0-2.0833-0.14648-1.3021-0.13021-2.181-0.32552v-3.011h0.179q0.6674 0.22787 1.6439 0.47201 0.9766 0.24413 2.0019 0.24413 1.4974 0 2.3763-0.34179 0.8952-0.34179 1.3184-0.97655 0.4394-0.65104 0.5533-1.595 0.1303-0.944 0.1303-2.181v-14.144h-5.127v-2.5716h8.3496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2394.7 635.67h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717-1.416 0.65103-3.125 0.65103-2.8645 0-4.4595-1.7415-1.5951-1.7578-1.5951-5.1432v-11.8h3.0599v10.351q0 1.3834 0.1302 2.3763 0.1302 0.97655 0.5534 1.6764 0.4394 0.71613 1.1393 1.0416 0.6998 0.32552 2.0345 0.32552 1.1881 0 2.5878-0.61848 1.416-0.61849 2.6367-1.5788v-13.574h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2416.7 626.36q0 2.2135-0.6348 4.0527-0.6348 1.8229-1.7904 3.0924-1.0742 1.2044-2.539 1.8717-1.4485 0.65104-3.0761 0.65104-1.416 0-2.5716-0.30924-1.1393-0.30924-2.3275-0.96028v7.6171h-3.0598v-24.886h3.0598v1.9043q1.2207-1.0254 2.7344-1.709 1.5299-0.69986 3.2552-0.69986 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1576 0.0814q0-3.2877-1.123-4.9153t-3.4505-1.6276q-1.3183 0-2.653 0.56966-1.3346 0.56965-2.5553 1.4974v10.303q1.3021 0.58593 2.2298 0.79752 0.944 0.21159 2.1322 0.21159 2.5553 0 3.9876-1.7252 1.4322-1.7252 1.4322-5.1106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2424.7 614.44h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2440.1 635.5q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2318-1.4974-1.4485-1.4974-1.4485-4.8014v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.79751 0.4557 1.4974 0.358 0.65103 0.9765 0.96027 0.6348 0.29297 1.9206 0.29297 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1718-0.37434h0.1628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2459 626.89h-13.395q0 1.6764 0.5045 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78125 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8555 0 3.7272-0.73242 1.888-0.74869 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65103-3.1576 1.0905-1.6113 0.43945-3.3853 0.43945-4.5247 0-7.0638-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9784-2.3437q-0.016-2.4088-1.2207-3.7272-1.1882-1.3184-3.6296-1.3184-2.4576 0-3.9224 1.4486-1.4486 1.4486-1.6439 3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2475 620.82h-0.1628q-0.6836-0.16276-1.3346-0.22786-0.6348-0.0814-1.5137-0.0814-1.416 0-2.7343 0.63476-1.3184 0.61848-2.5391 1.6113v12.907h-3.0598v-18.18h3.0598v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.61849 2.8483-0.61849 0.7975 0 1.1555 0.0488 0.3581 0.0326 1.0743 0.14648z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2481.2 610.34-0.6999 9.4237h-2.2135l-0.6999-9.4237z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2499.9 630.43q0 2.4902-2.0671 4.0852-2.0507 1.595-5.6151 1.595-2.0182 0-3.7109-0.472-1.6765-0.48828-2.8158-1.0579v-3.4342h0.1628q1.4485 1.0905 3.2226 1.7415 1.7741 0.63476 3.4017 0.63476 2.0182 0 3.1575-0.65103 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.6185-1.6276t-2.3763-0.944q-0.651-0.14648-1.7089-0.34179-1.0417-0.19532-1.9043-0.42318-2.3926-0.63476-3.4017-1.8554-0.9928-1.237-0.9928-3.0273 0-1.123 0.4557-2.1159 0.472-0.99282 1.416-1.7741 0.9115-0.76496 2.3112-1.2044 1.416-0.45573 3.1575-0.45573 1.6276 0 3.2878 0.4069 1.6764 0.39062 2.7831 0.96028v3.2714h-0.1627q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65103-1.1556 0.63476-1.1556 1.9043 0 1.123 0.6998 1.6927 0.6836 0.56966 2.2136 0.92773 0.8463 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48827 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2542.5 635.67h-3.0599v-10.351q0-1.1719-0.1139-2.2624-0.098-1.0905-0.4395-1.7415-0.3743-0.69986-1.0742-1.0579-0.6998-0.35807-2.0182-0.35807-1.2858 0-2.5716 0.65104-1.2858 0.63476-2.5716 1.6276 0.049 0.37434 0.081 0.87889 0.033 0.48828 0.033 0.97656v11.637h-3.0599v-10.351q0-1.2044-0.1139-2.2786-0.098-1.0905-0.4395-1.7415-0.3743-0.69986-1.0742-1.0417-0.6998-0.35807-2.0182-0.35807-1.2532 0-2.5228 0.61849-1.2532 0.61848-2.5064 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4322-1.1881 2.8482-1.8554 1.4323-0.66731 3.0436-0.66731 1.8555 0 3.1413 0.78124 1.302 0.78124 1.9368 2.1647 1.8555-1.5625 3.3854-2.2461 1.5299-0.69986 3.2714-0.69986 2.9948 0 4.4108 1.8229 1.4323 1.8066 1.4323 5.0618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2562.5 635.67h-3.0436v-1.9368q-0.4069 0.27669-1.1067 0.78124-0.6836 0.48828-1.3347 0.78124-0.7649 0.37435-1.7578 0.61849-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1504 0-2.067 0.8789-3.3366 0.8952-1.2858 2.539-2.0182 1.6602-0.73241 3.9876-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0417-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37435-1.5625-0.50455-0.9114-0.13021-1.9042-0.13021-1.2045 0-2.6856 0.32552-1.4811 0.30924-3.0598 0.91145h-0.1628v-3.1087q0.8952-0.24413 2.5879-0.5371t3.3365-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368t0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.0814-3.304 0.24414-1.888 0.16276-2.9947 0.472-1.3184 0.37435-2.1322 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8809 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2583.2 633.6q0 4.6224-2.0996 6.787-2.0996 2.1647-6.4615 2.1647-1.4486 0-2.832-0.21159-1.3672-0.19531-2.7018-0.56966v-3.125h0.1627q0.7487 0.29296 2.3763 0.71613 1.6276 0.43945 3.2552 0.43945 1.5625 0 2.5878-0.37434 1.0254-0.37435 1.5951-1.0417 0.5696-0.63476 0.8138-1.5299 0.2441-0.89517 0.2441-2.0019v-1.6601q-1.3834 1.1068-2.653 1.6601-1.2532 0.5371-3.2063 0.5371-3.2552 0-5.1757-2.3437-1.9043-2.36-1.9043-6.6406 0-2.3437 0.651-4.0364 0.6673-1.709 1.8066-2.9459 1.058-1.1556 2.5716-1.7903 1.5137-0.65104 3.0111-0.65104 1.5787 0 2.6367 0.32552 1.0742 0.30924 2.2623 0.96027l0.1953-0.78124h2.8646zm-3.0599-2.9297v-9.912q-1.2207-0.55338-2.2786-0.78124-1.0417-0.24414-2.0833-0.24414-2.5228 0-3.9713 1.6927-1.4486 1.6927-1.4486 4.9153 0 3.0599 1.0742 4.6386t3.5644 1.5788q1.3347 0 2.6693-0.50456 1.3509-0.52082 2.4739-1.3834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2604.4 635.67h-3.0598v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.765-0.3418-1.9857-0.3418-1.2532 0-2.6204 0.61849-1.3671 0.61848-2.6204 1.5788v13.574h-3.0598v-18.18h3.0598v2.0182q1.4323-1.1881 2.9622-1.8554 1.53-0.66731 3.1413-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2625.5 626.89h-13.395q0 1.6764 0.5045 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78125 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8555 0 3.7272-0.73242 1.888-0.74869 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65103-3.1576 1.0905-1.6113 0.43945-3.3853 0.43945-4.5247 0-7.0638-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2206-3.7272-1.1882-1.3184-3.6296-1.3184-2.4576 0-3.9225 1.4486-1.4485 1.4486-1.6438 3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2639.6 635.5q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2318-1.4974-1.4485-1.4974-1.4485-4.8014v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.79751 0.4558 1.4974 0.358 0.65103 0.9765 0.96027 0.6348 0.29297 1.9206 0.29297 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1718-0.37434h0.1628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2646.6 614.44h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2666 634.53q-1.53 0.73241-2.9134 1.1393-1.3672 0.4069-2.9134 0.4069-1.9694 0-3.6133-0.56966-1.6438-0.58593-2.8157-1.7578-1.1881-1.1719-1.8392-2.9622-0.651-1.7904-0.651-4.1829 0-4.4596 2.4414-6.9986 2.4576-2.539 6.4778-2.539 1.5625 0 3.0599 0.43945 1.5136 0.43945 2.7669 1.0742v3.4017h-0.1628q-1.3997-1.0905-2.8971-1.6764-1.4811-0.58593-2.8971-0.58593-2.6042 0-4.1178 1.7578-1.4974 1.7415-1.4974 5.1269 0 3.2877 1.4648 5.0618 1.4811 1.7578 4.1504 1.7578 0.9277 0 1.888-0.24414t1.7252-0.63476q0.6673-0.34179 1.2533-0.71614 0.5859-0.39062 0.9277-0.66731h0.1628z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2691.4 613.3h-0.1627q-0.5046-0.14648-1.3184-0.29296-0.8138-0.16276-1.4322-0.16276-1.9694 0-2.8646 0.87889-0.8789 0.86263-0.8789 3.1412v0.61848h5.5175v2.5716h-5.4198v15.609h-3.0599v-15.609h-2.067v-2.5716h2.067v-0.6022q0-3.2389 1.6113-4.9642 1.6113-1.7415 4.6549-1.7415 1.0254 0 1.8392 0.0977 0.83 0.0977 1.5136 0.22786z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2696.6 614.44h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2717.7 626.89h-13.395q0 1.6764 0.5045 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78125 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73242 1.888-0.74869 2.6855-1.4648h0.1627v3.3366q-1.5462 0.65103-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4413-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1034zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3184-3.6295-1.3184-2.4577 0-3.9225 1.4486-1.4485 1.4486-1.6438 3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2725.5 635.67h-3.0599v-25.325h3.0599z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2746.3 635.67h-3.0599v-1.9043q-1.3183 1.1393-2.7506 1.7741t-3.1087 0.63476q-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.651-4.1178 0.6674-1.8066 1.7904-3.0761 1.1067-1.237 2.5716-1.888 1.4811-0.65104 3.0598-0.65104 1.4323 0 2.5391 0.30924 1.1067 0.29297 2.3274 0.92773v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.2369-0.55338-2.2135-0.76496-0.9765-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7904-1.4323 1.7903-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1067 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.59291 0 0 1.0016 711.88 455.89)",
    fill: "#c83737"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 109.66,
    width: 859.43,
    height: 39.433
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 149.66,
    width: 859.43,
    height: 39.433
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Label-PA"
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m1340.9 841.52 310.08 131.82h98.865",
    fill: "none",
    stroke: "#f44336",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "Plasma Analyzer"
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m1784.9 978.31v16.699h-5.625v-42.656h15.732q7.002 0 10.957 3.5742 3.9844 3.5742 3.9844 9.4629 0 6.2109-3.8965 9.5801-3.8672 3.3398-11.104 3.3398zm0-4.5996h10.107q4.5117 0 6.9141-2.1094 2.4023-2.1387 2.4023-6.1523 0-3.8086-2.4023-6.0938-2.4024-2.2852-6.5918-2.373h-10.43z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m1822.2 995h-5.4199v-45h5.4199z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m1850.4 995q-0.4687-0.9375-0.7617-3.3398-3.7793 3.9258-9.0235 3.9258-4.6875 0-7.705-2.6367-2.9883-2.666-2.9883-6.7383 0-4.9512 3.75-7.6758 3.7793-2.7539 10.606-2.7539h5.2734v-2.4902q0-2.8418-1.6992-4.5117-1.6992-1.6992-5.0098-1.6992-2.9004 0-4.8633 1.4648t-1.9629 3.5449h-5.4492q0-2.373 1.6699-4.5703 1.6993-2.2266 4.5704-3.5156 2.9003-1.2891 6.3574-1.2891 5.4785 0 8.584 2.7539 3.1054 2.7246 3.2226 7.5293v14.59q0 4.3652 1.1133 6.9434v0.46875zm-8.9941-4.1309q2.5488 0 4.8339-1.3184 2.2852-1.3184 3.3106-3.4277v-6.5039h-4.2481q-9.9609 0-9.9609 5.8301 0 2.5488 1.6992 3.9844 1.6992 1.4355 4.3653 1.4355z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m1882 986.6q0-2.1973-1.6699-3.3984-1.6406-1.2305-5.7715-2.1094-4.1015-0.87891-6.5332-2.1094-2.4023-1.2305-3.5742-2.9297-1.1426-1.6992-1.1426-4.043 0-3.8965 3.2813-6.5918 3.3105-2.6953 8.4375-2.6953 5.3906 0 8.7304 2.7832 3.3692 2.7832 3.3692 7.1191h-5.4492q0-2.2266-1.9043-3.8379-1.875-1.6113-4.7461-1.6113-2.959 0-4.6289 1.2891-1.67 1.2891-1.67 3.3691 0 1.9629 1.5528 2.959 1.5527 0.99609 5.5957 1.9043 4.0723 0.9082 6.5918 2.168t3.7207 3.0469q1.2305 1.7578 1.2305 4.3066 0 4.248-3.3985 6.8262-3.3984 2.5488-8.8183 2.5488-3.8086 0-6.7383-1.3476-2.9297-1.3477-4.5996-3.75-1.6407-2.4316-1.6407-5.2442h5.42q0.1464 2.7246 2.1679 4.3359 2.0508 1.582 5.3907 1.582 3.0761 0 4.9218-1.2305 1.875-1.2598 1.875-3.3398z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m1899.6 963.31 0.1464 3.5156q3.4864-4.1016 9.4043-4.1016 6.6504 0 9.0528 5.0976 1.582-2.2852 4.1015-3.6914 2.5489-1.4062 6.0059-1.4062 10.43 0 10.606 11.045v21.24h-5.42v-20.918q0-3.3984-1.5527-5.0684-1.5527-1.6992-5.2148-1.6992-3.0176 0-5.0098 1.8164-1.9922 1.7871-2.3145 4.834v21.035h-5.4492v-20.771q0-6.9141-6.7676-6.9141-5.332 0-7.2949 4.541v23.145h-5.4199v-31.699z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m1966.6 995q-0.4687-0.9375-0.7617-3.3398-3.7793 3.9258-9.0235 3.9258-4.6875 0-7.705-2.6367-2.9883-2.666-2.9883-6.7383 0-4.9512 3.75-7.6758 3.7793-2.7539 10.606-2.7539h5.2734v-2.4902q0-2.8418-1.6992-4.5117-1.6992-1.6992-5.0098-1.6992-2.9004 0-4.8633 1.4648t-1.9629 3.5449h-5.4492q0-2.373 1.6699-4.5703 1.6993-2.2266 4.5704-3.5156 2.9003-1.2891 6.3574-1.2891 5.4785 0 8.584 2.7539 3.1054 2.7246 3.2226 7.5293v14.59q0 4.3652 1.1133 6.9434v0.46875zm-8.9941-4.1309q2.5488 0 4.8339-1.3184 2.2852-1.3184 3.3106-3.4277v-6.5039h-4.2481q-9.9609 0-9.9609 5.8301 0 2.5488 1.6992 3.9844 1.6992 1.4355 4.3653 1.4355z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m2019.1 983.87h-17.871l-4.0137 11.133h-5.8007l16.289-42.656h4.9219l16.318 42.656h-5.7715zm-16.172-4.6289h14.502l-7.2656-19.951z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m2038.9 963.31 0.1758 3.9844q3.6328-4.5703 9.4922-4.5703 10.049 0 10.137 11.338v20.947h-5.4199v-20.977q-0.029-3.4277-1.5821-5.0684-1.5234-1.6406-4.7754-1.6406-2.6367 0-4.6289 1.4062t-3.1054 3.6914v22.588h-5.42v-31.699z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m2086.5 995q-0.4687-0.9375-0.7617-3.3398-3.7793 3.9258-9.0234 3.9258-4.6875 0-7.7051-2.6367-2.9883-2.666-2.9883-6.7383 0-4.9512 3.75-7.6758 3.7793-2.7539 10.606-2.7539h5.2734v-2.4902q0-2.8418-1.6992-4.5117-1.6992-1.6992-5.0098-1.6992-2.9004 0-4.8633 1.4648t-1.9629 3.5449h-5.4492q0-2.373 1.67-4.5703 1.6992-2.2266 4.5703-3.5156 2.9004-1.2891 6.3574-1.2891 5.4785 0 8.584 2.7539 3.1054 2.7246 3.2226 7.5293v14.59q0 4.3652 1.1133 6.9434v0.46875zm-8.9941-4.1309q2.5488 0 4.834-1.3184 2.2851-1.3184 3.3105-3.4277v-6.5039h-4.248q-9.961 0-9.961 5.8301 0 2.5488 1.6992 3.9844 1.6993 1.4355 4.3653 1.4355z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m2105.5 995h-5.4199v-45h5.4199z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m2124.6 987.07 7.3828-23.76h5.8008l-12.744 36.592q-2.959 7.9102-9.4043 7.9102l-1.0254-0.088-2.0215-0.3809v-4.3945l1.4649 0.1172q2.7539 0 4.2773-1.1133 1.5528-1.1133 2.5489-4.0723l1.2011-3.2227-11.309-31.348h5.918z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m2147.6 990.58h18.545v4.4238h-25.166v-3.9844l17.49-23.232h-17.226v-4.4824h24.023v3.8379z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m2185 995.59q-6.4453 0-10.488-4.2188-4.0429-4.248-4.0429-11.338v-0.99609q0-4.7168 1.7871-8.4082 1.8164-3.7207 5.039-5.8008 3.252-2.1094 7.0313-2.1094 6.1816 0 9.6094 4.0723 3.4277 4.0723 3.4277 11.66v2.2559h-21.475q0.1172 4.6875 2.7246 7.5879 2.6367 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719 1.9921-1.1719 3.4863-3.1055l3.3105 2.5781q-3.9843 6.123-11.953 6.123zm-0.6738-28.418q-3.2813 0-5.5078 2.4024-2.2266 2.373-2.7539 6.6797h15.879v-0.41015q-0.2344-4.1309-2.2266-6.3867-1.9922-2.2852-5.3906-2.2852z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m2218.9 968.17q-1.2305-0.20508-2.666-0.20508-5.3321 0-7.2364 4.541v22.5h-5.4199v-31.699h5.2735l0.088 3.6621q2.666-4.248 7.5585-4.248 1.5821 0 2.4024 0.41015z"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m1774.1 946.41h450v65h-450z",
    strokeWidth: 0.71341
  })), /*#__PURE__*/React.createElement("g", {
    className: "captionText",
    transform: "translate(1773.8 1284.9)",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect1316)",
      whiteSpace: "pre"
    },
    "aria-label": "Detects solar wind particles through a hole in the antenna dish"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.2459 -239.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.73-12.093q0 3.304-1.4486 5.9895-1.4323 2.6855-3.8248 4.1666-1.6601 1.0254-3.7109 1.4811-2.0345 0.45572-5.371 0.45572h-6.1197v-24.235h6.0546q3.5481 0 5.6315 0.52083 2.0996 0.50455 3.5481 1.3997 2.4739 1.5462 3.8574 4.1178t1.3834 6.1035zm-3.3691-0.04883q0-2.8483-0.99283-4.8014-0.99283-1.9531-2.9622-3.0761-1.4323-0.81379-3.0436-1.123-1.6113-0.32552-3.8574-0.32552h-3.0273v18.701h3.0273q2.3275 0 4.0527-0.34179 1.7415-0.34179 3.1901-1.2695 1.8066-1.1556 2.7018-3.0436 0.91145-1.888 0.91145-4.72z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.945-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.01628-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.024-0.16276q-0.86262 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45572 1.4974 0.35807 0.65104 0.97655 0.96028 0.63476 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.81379-0.22786 1.1719-0.37435h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.952-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8555 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.01628-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.035-1.1393q-1.5299 0.73241-2.9134 1.1393-1.3672 0.4069-2.9134 0.4069-1.9694 0-3.6132-0.56966-1.6439-0.58593-2.8157-1.7578-1.1881-1.1719-1.8392-2.9622t-0.65104-4.1829q0-4.4596 2.4414-6.9986 2.4577-2.539 6.4778-2.539 1.5625 0 3.0599 0.43945 1.5137 0.43945 2.7669 1.0742v3.4017h-0.16276q-1.3997-1.0905-2.8971-1.6764-1.4811-0.58593-2.8971-0.58593-2.6041 0-4.1178 1.7578-1.4974 1.7415-1.4974 5.1269 0 3.2877 1.4648 5.0618 1.4811 1.7578 4.1503 1.7578 0.92772 0 1.888-0.24414t1.7252-0.63476q0.66731-0.34179 1.2532-0.71614 0.58593-0.39062 0.92772-0.66731h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.41-0.16276q-0.86262 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45572 1.4974 0.35807 0.65104 0.97655 0.96028 0.63476 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.81379-0.22786 1.1719-0.37435h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.11-5.2408q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.16276q1.4486 1.0905 3.2226 1.7415 1.7741 0.63476 3.4017 0.63476 2.0182 0 3.1575-0.65104 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.61849-1.6276-0.61848-0.55338-2.3763-0.944-0.65103-0.14648-1.709-0.34179-1.0417-0.19531-1.9043-0.42317-2.3926-0.63476-3.4017-1.8554-0.99283-1.237-0.99283-3.0273 0-1.123 0.45573-2.1159 0.472-0.99283 1.416-1.7741 0.91145-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.4069 1.6764 0.39062 2.7832 0.96028v3.2715h-0.16276q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63476-1.1556 1.9043 0 1.123 0.69986 1.6927 0.68359 0.56966 2.2135 0.92772 0.84635 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.21-5.2408q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.16276q1.4486 1.0905 3.2226 1.7415 1.7741 0.63476 3.4017 0.63476 2.0182 0 3.1575-0.65104 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.61849-1.6276-0.61848-0.55338-2.3763-0.944-0.65104-0.14648-1.709-0.34179-1.0417-0.19531-1.9043-0.42317-2.3926-0.63476-3.4017-1.8554-0.99283-1.237-0.99283-3.0273 0-1.123 0.45573-2.1159 0.472-0.99283 1.416-1.7741 0.91145-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.4069 1.6764 0.39062 2.7832 0.96028v3.2715h-0.16276q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63476-1.1556 1.9043 0 1.123 0.69987 1.6927 0.68358 0.56966 2.2135 0.92772 0.84635 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.1-9.0819q0 4.4433-2.2786 7.0149-2.2786 2.5716-6.1034 2.5716-3.8574 0-6.136-2.5716-2.2623-2.5716-2.2623-7.0149 0-4.4433 2.2623-7.0149 2.2786-2.5879 6.136-2.5879 3.8248 0 6.1034 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3834-5.2408-1.3834-1.7252-3.8411-1.7252-2.4902 0-3.8737 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3834 5.192 1.3834 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.95 0h-3.0599v-25.325h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.16 0h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.68359 0.48828-1.3346 0.78124-0.76497 0.37435-1.7578 0.61848-0.99282 0.26041-2.3274 0.26041-2.4576 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.89517-1.2858 2.539-2.0182 1.6601-0.73242 3.9876-0.99283t4.9967-0.39062v-0.472q0-1.0417-0.37434-1.7252-0.35807-0.68359-1.0417-1.0742-0.65103-0.37435-1.5625-0.50455t-1.9043-0.13021q-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.16276v-3.1087q0.89518-0.24414 2.5879-0.5371t3.3366-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3184 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.43-14.844h-0.16276q-0.68359-0.16276-1.3346-0.22786-0.63475-0.08138-1.5136-0.08138-1.416 0-2.7344 0.63476-1.3184 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.61848 2.8483-0.61848 0.79752 0 1.1556 0.04883 0.35807 0.03255 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.93-18.18-4.7363 18.18h-2.832l-4.6712-14.014-4.6386 14.014h-2.8157l-4.7851-18.18h3.1901l3.3366 14.079 4.541-14.079h2.5228l4.6549 14.079 3.1575-14.079z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.63-21.224h-3.4505v-3.1738h3.4505zm-0.19531 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.72 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14649-1.1068-0.53711-1.7252-0.4069-0.68359-1.1719-1.0091-0.76497-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.9459 0 4.4922 1.7741 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.36 0h-3.0599v-1.9043q-1.3184 1.1393-2.7506 1.7741-1.4323 0.63476-3.1087 0.63476-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.65103-4.1178 0.66731-1.8066 1.7904-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29296 2.3274 0.92772v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.55338-2.2135-0.76497-0.97655-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7903-1.4323 1.7903-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1068 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.1-9.3098q0 2.2135-0.63476 4.0527-0.63476 1.8229-1.7903 3.0924-1.0742 1.2044-2.539 1.8717-1.4486 0.65104-3.0761 0.65104-1.416 0-2.5716-0.30924-1.1393-0.30924-2.3274-0.96028v7.6171h-3.0599v-24.886h3.0599v1.9043q1.2207-1.0254 2.7344-1.709 1.5299-0.69986 3.2552-0.69986 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1575 0.081379q0-3.2877-1.123-4.9153-1.123-1.6276-3.4505-1.6276-1.3184 0-2.653 0.56966t-2.5553 1.4974v10.303q1.3021 0.58593 2.2298 0.79752 0.944 0.21159 2.1321 0.21159 2.5553 0 3.9876-1.7252 1.4323-1.7252 1.4323-5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m359 0h-3.0436v-1.9368q-0.40689 0.27669-1.1068 0.78124-0.68358 0.48828-1.3346 0.78124-0.76497 0.37435-1.7578 0.61848-0.99283 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.89517-1.2858 2.539-2.0182 1.6601-0.73242 3.9876-0.99283t4.9967-0.39062v-0.472q0-1.0417-0.37434-1.7252-0.35807-0.68359-1.0417-1.0742-0.65103-0.37435-1.5625-0.50455t-1.9043-0.13021q-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.16276v-3.1087q0.89518-0.24414 2.5879-0.5371t3.3366-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3184 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.94401 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.27-14.844h-0.16276q-0.68359-0.16276-1.3346-0.22786-0.63476-0.08138-1.5137-0.08138-1.416 0-2.7344 0.63476-1.3183 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.61848 2.8483-0.61848 0.79752 0 1.1556 0.04883 0.35807 0.03255 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.62-0.16276q-0.86262 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45573 1.4974 0.35807 0.65104 0.97655 0.96028 0.63476 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.81379-0.22786 1.1719-0.37435h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.62-21.224h-3.4505v-3.1738h3.4505zm-0.19531 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.95-1.1393q-1.5299 0.73241-2.9134 1.1393-1.3672 0.4069-2.9134 0.4069-1.9694 0-3.6132-0.56966-1.6439-0.58593-2.8157-1.7578-1.1881-1.1719-1.8392-2.9622-0.65104-1.7903-0.65104-4.1829 0-4.4596 2.4414-6.9986 2.4576-2.539 6.4778-2.539 1.5625 0 3.0599 0.43945 1.5137 0.43945 2.7669 1.0742v3.4017h-0.16276q-1.3997-1.0905-2.8971-1.6764-1.4811-0.58593-2.8971-0.58593-2.6041 0-4.1178 1.7578-1.4974 1.7415-1.4974 5.1269 0 3.2877 1.4648 5.0618 1.4811 1.7578 4.1504 1.7578 0.92772 0 1.888-0.24414t1.7252-0.63476q0.66731-0.34179 1.2532-0.71614 0.58593-0.39062 0.92772-0.66731h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.98 0h-3.0599v-25.325h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m443.29-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43945-3.3854 0.43945-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.92-5.2408q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.16276q1.4486 1.0905 3.2226 1.7415 1.7741 0.63476 3.4017 0.63476 2.0182 0 3.1575-0.65104 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.61848-1.6276-0.61849-0.55338-2.3763-0.944-0.65104-0.14648-1.709-0.34179-1.0417-0.19531-1.9043-0.42317-2.3926-0.63476-3.4017-1.8554-0.99282-1.237-0.99282-3.0273 0-1.123 0.45572-2.1159 0.472-0.99283 1.416-1.7741 0.91145-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.4069 1.6764 0.39062 2.7832 0.96028v3.2715h-0.16276q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63476-1.1556 1.9043 0 1.123 0.69987 1.6927 0.68358 0.56966 2.2135 0.92772 0.84634 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.47-0.16276q-0.86262 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45572 1.4974 0.35807 0.65104 0.97655 0.96028 0.63476 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37435h0.16275z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.38 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14649-1.1068-0.53711-1.7252-0.40689-0.68359-1.1719-1.0091-0.76497-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.9459 0 4.4922 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m522.62-14.844h-0.16276q-0.68359-0.16276-1.3346-0.22786-0.63476-0.08138-1.5137-0.08138-1.416 0-2.7344 0.63476-1.3183 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2063-2.067 1.3997-0.61848 2.8483-0.61848 0.79752 0 1.1556 0.04883 0.35807 0.03255 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m541.03-9.0819q0 4.4433-2.2786 7.0149-2.2786 2.5716-6.1034 2.5716-3.8574 0-6.136-2.5716-2.2623-2.5716-2.2623-7.0149 0-4.4433 2.2623-7.0149 2.2786-2.5879 6.136-2.5879 3.8248 0 6.1034 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3834-5.2408-1.3834-1.7252-3.8411-1.7252-2.4902 0-3.8737 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3834 5.192 1.3834 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m560.85 0h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717t-3.125 0.65104q-2.8646 0-4.4596-1.7415-1.595-1.7578-1.595-5.1432v-11.8h3.0599v10.351q0 1.3834 0.13021 2.3763 0.13021 0.97655 0.55338 1.6764 0.43945 0.71614 1.1393 1.0417t2.0345 0.32552q1.1881 0 2.5879-0.61848 1.416-0.61848 2.6367-1.5788v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m581.62-2.067q0 4.6223-2.0996 6.787t-6.4615 2.1647q-1.4486 0-2.832-0.21159-1.3672-0.19531-2.7018-0.56966v-3.125h0.16275q0.74869 0.29297 2.3763 0.71614 1.6276 0.43945 3.2552 0.43945 1.5625 0 2.5879-0.37435 1.0254-0.37435 1.595-1.0417 0.56965-0.63476 0.81379-1.5299 0.24414-0.89517 0.24414-2.0019v-1.6601q-1.3834 1.1068-2.653 1.6601-1.2532 0.5371-3.2064 0.5371-3.2552 0-5.1757-2.3437-1.9043-2.36-1.9043-6.6406 0-2.3437 0.65103-4.0364 0.66731-1.709 1.8066-2.9459 1.0579-1.1556 2.5716-1.7903 1.5137-0.65104 3.011-0.65104 1.5788 0 2.6367 0.32552 1.0742 0.30924 2.2624 0.96028l0.19531-0.78124h2.8646zm-3.0599-2.9297v-9.912q-1.2207-0.55338-2.2786-0.78124-1.0417-0.24414-2.0833-0.24414-2.5228 0-3.9713 1.6927-1.4486 1.6927-1.4486 4.9153 0 3.0599 1.0742 4.6386 1.0742 1.5788 3.5644 1.5788 1.3346 0 2.6692-0.50455 1.3509-0.52083 2.4739-1.3834z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602.84 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14648-1.1068-0.53711-1.7252-0.40689-0.68359-1.1719-1.0091-0.76497-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.58 0h-3.0436v-1.9368q-0.40689 0.27669-1.1068 0.78124-0.68358 0.48828-1.3346 0.78124-0.76496 0.37435-1.7578 0.61848-0.99283 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.89517-1.2858 2.539-2.0182 1.6601-0.73242 3.9876-0.99283t4.9967-0.39062v-0.472q0-1.0417-0.37434-1.7252-0.35807-0.68359-1.0417-1.0742-0.65103-0.37435-1.5625-0.50455t-1.9043-0.13021q-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.16275v-3.1087q0.89517-0.24414 2.5879-0.5371t3.3366-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3184 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.94401 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m667.42 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14648-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.76496-0.34179-1.9856-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4323-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m688.81-9.0819q0 4.4433-2.2786 7.0149-2.2786 2.5716-6.1035 2.5716-3.8574 0-6.136-2.5716-2.2624-2.5716-2.2624-7.0149 0-4.4433 2.2624-7.0149 2.2786-2.5879 6.136-2.5879 3.8248 0 6.1035 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3834-5.2408-1.3834-1.7252-3.8411-1.7252-2.4902 0-3.8737 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3834 5.192 1.3834 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m696.66 0h-3.0599v-25.325h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m717.96-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50456 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-728.65 -195.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m737.61-21.224h-3.4505v-3.1738h3.4505zm-0.19532 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m758.7 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14649-1.1068-0.53711-1.7252-0.40689-0.68359-1.1719-1.0091-0.76497-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.9459 0 4.4922 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785.75-0.16276q-0.86262 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45573 1.4974 0.35806 0.65104 0.97655 0.96028 0.63476 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.81379-0.22786 1.1719-0.37435h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m804.66 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14648-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.76496-0.34179-1.9856-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4323-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m825.77-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50456 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4576 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m856.26 0h-3.0436v-1.9368q-0.40689 0.27669-1.1068 0.78124-0.68358 0.48828-1.3346 0.78124-0.76497 0.37435-1.7578 0.61848-0.99283 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.89517-1.2858 2.539-2.0182 1.6601-0.73242 3.9876-0.99283t4.9967-0.39062v-0.472q0-1.0417-0.37434-1.7252-0.35807-0.68359-1.0417-1.0742-0.65103-0.37435-1.5625-0.50455t-1.9043-0.13021q-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.16275v-3.1087q0.89517-0.24414 2.5879-0.5371t3.3366-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3184 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.94401 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m877.38 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14648-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.76496-0.34179-1.9856-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m892.72-0.16276q-0.86263 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45572 1.4974 0.35807 0.65104 0.97656 0.96028 0.63475 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37435h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m911.64-8.7727h-13.395q0 1.6764 0.50456 2.9297 0.50455 1.237 1.3834 2.0345 0.84634 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4576 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m931.48 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14649-1.1068-0.53711-1.7252-0.40689-0.68359-1.1719-1.0091-0.76497-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.9459 0 4.4922 1.7741 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m952.58 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14648-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.76496-0.34179-1.9856-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554 1.5299-0.66731 3.1412-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m972.6 0h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.68359 0.48828-1.3346 0.78124-0.76497 0.37435-1.7578 0.61848-0.99283 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.89517-1.2858 2.539-2.0182 1.6601-0.73242 3.9876-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0417-0.37435-1.7252-0.35806-0.68359-1.0416-1.0742-0.65104-0.37435-1.5625-0.50455t-1.9043-0.13021q-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.16276v-3.1087q0.89518-0.24414 2.5879-0.5371t3.3366-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3183 0.37435-2.1321 1.1719-0.81379 0.78124-0.81379 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1005 0h-3.0598v-1.9043q-1.3184 1.1393-2.7507 1.7741-1.4323 0.63476-3.1087 0.63476-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.65104-4.1178 0.66731-1.8066 1.7903-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29296 2.3275 0.92772v-7.8775h3.0598zm-3.0598-4.4759v-10.433q-1.237-0.55338-2.2136-0.76497-0.97656-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7903-1.4323 1.7903-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1068 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1014.3-21.224h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1033.2-5.2408q0 2.4902-2.0671 4.0852-2.0507 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.1628q1.4485 1.0905 3.2226 1.7415 1.7741 0.63476 3.4017 0.63476 2.0182 0 3.1575-0.65104 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.6185-1.6276-0.6185-0.55338-2.3763-0.944-0.651-0.14648-1.7089-0.34179-1.0417-0.19531-1.9043-0.42317-2.3926-0.63476-3.4017-1.8554-0.9928-1.237-0.9928-3.0273 0-1.123 0.4557-2.1159 0.472-0.99283 1.416-1.7741 0.9115-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.4069 1.6765 0.39062 2.7832 0.96028v3.2715h-0.1627q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6765 0-2.832 0.65104-1.1556 0.63476-1.1556 1.9043 0 1.123 0.6998 1.6927 0.6836 0.56966 2.2135 0.92772 0.8464 0.19531 1.888 0.39062 1.058 0.19531 1.7578 0.35807 2.1322 0.48828 3.2878 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1052.8 0h-3.0598v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.7649-0.34179-1.9856-0.34179-1.2533 0-2.6204 0.61848-1.3672 0.61848-2.6205 1.5788v13.574h-3.0598v-25.325h3.0598v9.1633q1.4323-1.1881 2.9622-1.8554 1.53-0.66731 3.1413-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.84297 0 0 1.0006 -568.78 907.1)",
    fill: "#f00"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 109.66,
    width: 859.43,
    height: 39.433
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 149.66,
    width: 859.43,
    height: 39.433
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Label-IP"
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m1245.9 535.36 203.08-386.12 119.59 1e-5",
    fill: "none",
    stroke: "#f44336",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": "Imaging Photopolarimeter"
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m1598.7 167.71h-5.625v-42.656h5.625z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m1613.2 136.01 0.1465 3.5156q3.4863-4.1016 9.4043-4.1016 6.6503 0 9.0527 5.0977 1.582-2.2852 4.1016-3.6914 2.5488-1.4062 6.0058-1.4062 10.43 0 10.606 11.045v21.24h-5.4199v-20.918q0-3.3984-1.5528-5.0684-1.5527-1.6992-5.2148-1.6992-3.0176 0-5.0098 1.8164-1.9922 1.7871-2.3144 4.834v21.035h-5.4493v-20.771q0-6.9141-6.7675-6.9141-5.3321 0-7.295 4.541v23.145h-5.4199v-31.699z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m1680.3 167.71q-0.4687-0.9375-0.7617-3.3398-3.7793 3.9258-9.0234 3.9258-4.6875 0-7.7051-2.6367-2.9883-2.666-2.9883-6.7383 0-4.9512 3.75-7.6758 3.7793-2.7539 10.606-2.7539h5.2734v-2.4902q0-2.8418-1.6992-4.5117-1.6992-1.6992-5.0098-1.6992-2.9004 0-4.8633 1.4648-1.9628 1.4648-1.9628 3.5449h-5.4493q0-2.373 1.67-4.5703 1.6992-2.2266 4.5703-3.5156 2.9004-1.2891 6.3574-1.2891 5.4785 0 8.584 2.7539 3.1054 2.7246 3.2226 7.5293v14.59q0 4.3652 1.1133 6.9434v0.46875zm-8.9941-4.1309q2.5488 0 4.834-1.3184 2.2851-1.3184 3.3105-3.4277v-6.5039h-4.248q-9.961 0-9.961 5.8301 0 2.5488 1.6992 3.9844 1.6993 1.4356 4.3653 1.4356z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m1692.1 151.59q0-7.4121 3.4277-11.777 3.4277-4.3945 9.082-4.3945 5.8008 0 9.0528 4.1016l0.2636-3.5156h4.9512v30.938q0 6.1523-3.6621 9.6973-3.6328 3.5449-9.7852 3.5449-3.4277 0-6.709-1.4648-3.2812-1.4648-5.0097-4.0137l2.8125-3.252q3.4863 4.3066 8.5254 4.3066 3.9551 0 6.1523-2.2266 2.2266-2.2266 2.2266-6.2695v-2.7246q-3.252 3.75-8.877 3.75-5.5664 0-9.0234-4.4824-3.4277-4.4824-3.4277-12.217zm5.4492 0.61523q0 5.3613 2.1972 8.4375 2.1973 3.0469 6.1524 3.0469 5.1269 0 7.5293-4.6582v-14.473q-2.4903-4.541-7.4707-4.541-3.9551 0-6.1817 3.0762-2.2265 3.0762-2.2265 9.1113z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m1732.9 167.71h-5.4199v-31.699h5.4199zm-5.8594-40.107q0-1.3184 0.791-2.2266 0.8204-0.90821 2.4024-0.90821t2.4023 0.90821q0.8203 0.9082 0.8203 2.2266t-0.8203 2.1973q-0.8203 0.87891-2.4023 0.87891t-2.4024-0.87891q-0.791-0.8789-0.791-2.1973z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m1746.7 136.01 0.1758 3.9844q3.6328-4.5703 9.4922-4.5703 10.049 0 10.137 11.338v20.947h-5.4199v-20.977q-0.029-3.4277-1.582-5.0684-1.5235-1.6406-4.7754-1.6406-2.6367 0-4.6289 1.4062t-3.1055 3.6914v22.588h-5.4199v-31.699z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m1773.4 151.59q0-7.4121 3.4277-11.777 3.4277-4.3945 9.082-4.3945 5.8008 0 9.0528 4.1016l0.2637-3.5156h4.9511v30.938q0 6.1523-3.6621 9.6973-3.6328 3.5449-9.7851 3.5449-3.4278 0-6.709-1.4648-3.2813-1.4648-5.0098-4.0137l2.8125-3.252q3.4863 4.3066 8.5254 4.3066 3.9551 0 6.1523-2.2266 2.2266-2.2266 2.2266-6.2695v-2.7246q-3.2519 3.75-8.8769 3.75-5.5665 0-9.0235-4.4824-3.4277-4.4824-3.4277-12.217zm5.4492 0.61523q0 5.3613 2.1973 8.4375 2.1972 3.0469 6.1523 3.0469 5.127 0 7.5293-4.6582v-14.473q-2.4902-4.541-7.4707-4.541-3.9551 0-6.1816 3.0762-2.2266 3.0762-2.2266 9.1113z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m1829.7 151.01v16.699h-5.625v-42.656h15.732q7.002 0 10.957 3.5742 3.9844 3.5742 3.9844 9.4629 0 6.2109-3.8965 9.5801-3.8672 3.3398-11.104 3.3398zm0-4.5996h10.107q4.5117 0 6.9141-2.1094 2.4023-2.1387 2.4023-6.1524 0-3.8086-2.4023-6.0938-2.4024-2.2852-6.5918-2.373h-10.43z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m1866.5 139.84q3.6035-4.4238 9.375-4.4238 10.049 0 10.137 11.338v20.947h-5.42v-20.977q-0.029-3.4277-1.582-5.0684-1.5234-1.6406-4.7754-1.6406-2.6367 0-4.6289 1.4062t-3.1054 3.6914v22.588h-5.42v-45h5.42z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m1892.7 151.56q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0976-5.7422 3.2813-2.0215 7.4707-2.0215 6.4746 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.38086q0 4.6289-1.7871 8.3203-1.7578 3.6621-5.0684 5.7129-3.2812 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9843-4.4824-3.9843-11.865zm5.4492 0.64453q0 5.2734 2.4316 8.4668 2.461 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2227 2.4317-3.252 2.4317-9.082 0-5.2148-2.4903-8.4375-2.4609-3.252-6.5625-3.252-4.0136 0-6.4746 3.1934-2.4609 3.1934-2.4609 9.1406z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m1935.7 128.33v7.6758h5.9179v4.1894h-5.9179v19.658q0 1.9043 0.791 2.8711 0.791 0.9375 2.6953 0.9375 0.9375 0 2.5781-0.35156v4.3945q-2.1386 0.58594-4.1601 0.58594-3.6328 0-5.4785-2.1973-1.8458-2.1973-1.8458-6.2402v-19.658h-5.7714v-4.1894h5.7714v-7.6758z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m1945.9 151.56q0-4.6582 1.8164-8.3789 1.8457-3.7207 5.0976-5.7422 3.2813-2.0215 7.4707-2.0215 6.4747 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.38086q0 4.6289-1.7871 8.3203-1.7578 3.6621-5.0684 5.7129-3.2812 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9844-4.4824-3.9844-11.865zm5.4492 0.64453q0 5.2734 2.4316 8.4668 2.461 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2227 2.4317-3.252 2.4317-9.082 0-5.2148-2.4903-8.4375-2.4609-3.252-6.5625-3.252-4.0136 0-6.4746 3.1934-2.4609 3.1934-2.4609 9.1406z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m2008.3 152.21q0 7.2363-3.3105 11.66-3.3106 4.4238-8.9649 4.4238-5.7715 0-9.082-3.6621v15.264h-5.4199v-43.887h4.9512l0.2636 3.5156q3.3106-4.1016 9.1992-4.1016 5.7129 0 9.0235 4.3066 3.3398 4.3066 3.3398 11.982zm-5.4199-0.61523q0-5.3613-2.2852-8.4668-2.2851-3.1055-6.2695-3.1055-4.9219 0-7.3828 4.3652v15.146q2.4316 4.3359 7.4414 4.3359 3.8965 0 6.1816-3.0762 2.3145-3.1055 2.3145-9.1992z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m2013.7 151.56q0-4.6582 1.8165-8.3789 1.8457-3.7207 5.0976-5.7422 3.2813-2.0215 7.4707-2.0215 6.4746 0 10.459 4.4824 4.0137 4.4824 4.0137 11.924v0.38086q0 4.6289-1.7871 8.3203-1.7579 3.6621-5.0684 5.7129-3.2813 2.0508-7.5586 2.0508-6.4453 0-10.459-4.4824-3.9844-4.4824-3.9844-11.865zm5.4493 0.64453q0 5.2734 2.4316 8.4668 2.4609 3.1934 6.5625 3.1934 4.1309 0 6.5625-3.2227 2.4316-3.252 2.4316-9.082 0-5.2148-2.4902-8.4375-2.4609-3.252-6.5625-3.252-4.0137 0-6.4746 3.1934t-2.4609 9.1406z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m2055.3 167.71h-5.4199v-45h5.4199z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m2083.5 167.71q-0.4687-0.9375-0.7617-3.3398-3.7793 3.9258-9.0235 3.9258-4.6875 0-7.705-2.6367-2.9883-2.666-2.9883-6.7383 0-4.9512 3.75-7.6758 3.7793-2.7539 10.606-2.7539h5.2734v-2.4902q0-2.8418-1.6992-4.5117-1.6992-1.6992-5.0098-1.6992-2.9004 0-4.8633 1.4648t-1.9629 3.5449h-5.4492q0-2.373 1.6699-4.5703 1.6993-2.2266 4.5704-3.5156 2.9003-1.2891 6.3574-1.2891 5.4785 0 8.584 2.7539 3.1054 2.7246 3.2226 7.5293v14.59q0 4.3652 1.1133 6.9434v0.46875zm-8.9941-4.1309q2.5488 0 4.8339-1.3184 2.2852-1.3184 3.3106-3.4277v-6.5039h-4.2481q-9.9609 0-9.9609 5.8301 0 2.5488 1.6992 3.9844t4.3653 1.4356z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m2111.9 140.87q-1.2305-0.20508-2.666-0.20508-5.3321 0-7.2364 4.541v22.5h-5.4199v-31.699h5.2734l0.088 3.6621q2.666-4.248 7.5586-4.248 1.5821 0 2.4024 0.41016z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m2122.8 167.71h-5.4199v-31.699h5.4199zm-5.8594-40.107q0-1.3184 0.7911-2.2266 0.8203-0.90821 2.4023-0.90821t2.4023 0.90821q0.8204 0.9082 0.8204 2.2266t-0.8204 2.1973q-0.8203 0.87891-2.4023 0.87891t-2.4023-0.87891q-0.7911-0.8789-0.7911-2.1973z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m2136.5 136.01 0.1465 3.5156q3.4864-4.1016 9.4043-4.1016 6.6504 0 9.0528 5.0977 1.582-2.2852 4.1015-3.6914 2.5489-1.4062 6.0059-1.4062 10.43 0 10.606 11.045v21.24h-5.42v-20.918q0-3.3984-1.5527-5.0684-1.5527-1.6992-5.2148-1.6992-3.0176 0-5.0098 1.8164-1.9922 1.7871-2.3145 4.834v21.035h-5.4492v-20.771q0-6.9141-6.7676-6.9141-5.332 0-7.2949 4.541v23.145h-5.4199v-31.699z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m2197.2 168.29q-6.4453 0-10.488-4.2188-4.043-4.248-4.043-11.338v-0.9961q0-4.7168 1.7871-8.4082 1.8164-3.7207 5.0391-5.8008 3.252-2.1094 7.0312-2.1094 6.1817 0 9.6094 4.0723 3.4278 4.0723 3.4278 11.66v2.2558h-21.475q0.1172 4.6875 2.7247 7.5879 2.6367 2.8711 6.6796 2.8711 2.8711 0 4.8633-1.1719t3.4864-3.1055l3.3105 2.5781q-3.9844 6.123-11.953 6.123zm-0.6739-28.418q-3.2812 0-5.5078 2.4023-2.2265 2.373-2.7539 6.6797h15.879v-0.41016q-0.2343-4.1309-2.2265-6.3867-1.9922-2.2852-5.3907-2.2852z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m2223.2 128.33v7.6758h5.918v4.1894h-5.918v19.658q0 1.9043 0.791 2.8711 0.791 0.9375 2.6953 0.9375 0.9375 0 2.5782-0.35156v4.3945q-2.1387 0.58594-4.1602 0.58594-3.6328 0-5.4785-2.1973t-1.8457-6.2402v-19.658h-5.7715v-4.1894h5.7715v-7.6758z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m2248.5 168.29q-6.4453 0-10.488-4.2188-4.0429-4.248-4.0429-11.338v-0.9961q0-4.7168 1.7871-8.4082 1.8164-3.7207 5.039-5.8008 3.252-2.1094 7.0313-2.1094 6.1816 0 9.6093 4.0723 3.4278 4.0723 3.4278 11.66v2.2558h-21.475q0.1172 4.6875 2.7246 7.5879 2.6367 2.8711 6.6797 2.8711 2.8711 0 4.8633-1.1719 1.9921-1.1719 3.4863-3.1055l3.3105 2.5781q-3.9843 6.123-11.953 6.123zm-0.6738-28.418q-3.2813 0-5.5078 2.4023-2.2266 2.373-2.7539 6.6797h15.879v-0.41016q-0.2344-4.1309-2.2266-6.3867-1.9922-2.2852-5.3906-2.2852z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m2282.5 140.87q-1.2305-0.20508-2.666-0.20508-5.3321 0-7.2364 4.541v22.5h-5.4199v-31.699h5.2735l0.088 3.6621q2.6661-4.248 7.5586-4.248 1.5821 0 2.4024 0.41016z"
  }))), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m1587.7 118.95h700v65h-700z",
    strokeWidth: 0.88978
  })), /*#__PURE__*/React.createElement("g", {
    className: "captionText",
    transform: "translate(-14.149 248.46)",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      shapeInside: "url(#rect1304)",
      whiteSpace: "pre"
    },
    "aria-label": "Captures 0.3 degree wide sections of Jupiter in red and blue light to build a visual image of the planet"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1602 -26.949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.972-1.7578q-0.89517 0.39062-1.6276 0.73241-0.71614 0.34179-1.888 0.71614-0.99283 0.30924-2.1647 0.52083-1.1556 0.22786-2.5553 0.22786-2.6367 0-4.8014-0.73241-2.1484-0.74869-3.7435-2.3275-1.5625-1.5462-2.4414-3.9225-0.8789-2.3926-0.8789-5.5501 0-2.9948 0.84635-5.3548 0.84635-2.36 2.4414-3.9876 1.5462-1.5788 3.7272-2.4088 2.1972-0.83007 4.8665-0.83007 1.9531 0 3.8899 0.472 1.9531 0.472 4.3294 1.6601v3.8248h-0.24414q-2.0019-1.6764-3.9713-2.4414-1.9694-0.76497-4.2155-0.76497-1.8392 0-3.3203 0.60221-1.4648 0.58593-2.6204 1.8392-1.123 1.2207-1.7578 3.0924-0.61848 1.8554-0.61848 4.2968 0 2.5553 0.68359 4.3945 0.69986 1.8392 1.7903 2.9948 1.1393 1.2044 2.653 1.7903 1.5299 0.56966 3.2226 0.56966 2.3275 0 4.3619-0.79752 2.0345-0.79752 3.8086-2.3926h0.22786z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.446 0h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.68359 0.48828-1.3346 0.78124-0.76497 0.37435-1.7578 0.61848-0.99283 0.26041-2.3275 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.89517-1.2858 2.539-2.0182 1.6601-0.73242 3.9876-0.99283 2.3274-0.26041 4.9967-0.39062v-0.472q0-1.0417-0.37435-1.7252-0.35807-0.68359-1.0417-1.0742-0.65104-0.37435-1.5625-0.50455-0.91145-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.16276v-3.1087q0.89517-0.24414 2.5879-0.5371 1.6927-0.29297 3.3366-0.29297 1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3183 0.37435-2.1321 1.1719-0.81379 0.78124-0.81379 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.369-9.3098q0 2.2135-0.63476 4.0527-0.63476 1.8229-1.7903 3.0924-1.0742 1.2044-2.539 1.8717-1.4486 0.65104-3.0761 0.65104-1.416 0-2.5716-0.30924-1.1393-0.30924-2.3275-0.96028v7.6171h-3.0599v-24.886h3.0599v1.9043q1.2207-1.0254 2.7343-1.709 1.5299-0.69986 3.2552-0.69986 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1575 0.081379q0-3.2877-1.123-4.9153-1.123-1.6276-3.4505-1.6276-1.3183 0-2.653 0.56966t-2.5553 1.4974v10.303q1.3021 0.58593 2.2298 0.79752 0.944 0.21159 2.1321 0.21159 2.5553 0 3.9876-1.7252t1.4323-5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.578-0.16276q-0.86262 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45572 1.4974 0.35807 0.65104 0.97655 0.96028 0.63476 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.81379-0.22786 1.1719-0.37435h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.36 0h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717-1.416 0.65104-3.125 0.65104-2.8646 0-4.4596-1.7415-1.595-1.7578-1.595-5.1432v-11.8h3.0599v10.351q0 1.3834 0.13021 2.3763 0.13021 0.97655 0.55338 1.6764 0.43945 0.71614 1.1393 1.0417t2.0345 0.32552q1.1881 0 2.5879-0.61848 1.416-0.61848 2.6367-1.5788v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.73-14.844h-0.16276q-0.68359-0.16276-1.3346-0.22786-0.63476-0.08138-1.5137-0.08138-1.416 0-2.7344 0.63476-1.3183 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.61848 2.8483-0.61848 0.79752 0 1.1556 0.04883 0.35807 0.03255 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.86-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43945-3.3854 0.43945-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.48-5.2408q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.16276q1.4486 1.0905 3.2226 1.7415 1.7741 0.63476 3.4016 0.63476 2.0182 0 3.1575-0.65104 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.61849-1.6276-0.61848-0.55338-2.3763-0.944-0.65104-0.14648-1.709-0.34179-1.0417-0.19531-1.9043-0.42317-2.3926-0.63476-3.4017-1.8554-0.99283-1.237-0.99283-3.0273 0-1.123 0.45573-2.1159 0.472-0.99283 1.416-1.7741 0.91145-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.4069 1.6764 0.39062 2.7832 0.96028v3.2715h-0.16276q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63476-1.1556 1.9043 0 1.123 0.69986 1.6927 0.68359 0.56966 2.2135 0.92772 0.84635 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.58-12.126q0 6.5266-2.0508 9.5865-2.0345 3.0436-6.3313 3.0436-4.3619 0-6.3801-3.0924-2.0019-3.0924-2.0019-9.5051 0-6.4615 2.0345-9.5377 2.0345-3.0924 6.3476-3.0924 4.3619 0 6.3639 3.1412 2.0182 3.125 2.0182 9.4563zm-4.2806 7.3892q0.56966-1.3183 0.76497-3.0924 0.21159-1.7903 0.21159-4.2968 0-2.4739-0.21159-4.2968-0.19531-1.8229-0.78124-3.0924-0.56966-1.2532-1.5625-1.888-0.97655-0.63476-2.5228-0.63476-1.5299 0-2.539 0.63476-0.99283 0.63476-1.5788 1.9206-0.55338 1.2044-0.76497 3.1412-0.19531 1.9368-0.19531 4.248 0 2.539 0.17903 4.248 0.17904 1.709 0.76497 3.0599 0.5371 1.2695 1.5137 1.9368 0.99282 0.66731 2.6204 0.66731 1.5299 0 2.539-0.63476 1.0091-0.63476 1.5625-1.9206z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.82 0h-3.8899v-4.6386h3.8899z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.81-11.67q0.78125 0.69986 1.2858 1.7578 0.50455 1.0579 0.50455 2.7343 0 1.6601-0.60221 3.0436-0.6022 1.3834-1.6927 2.4088-1.2207 1.1393-2.8808 1.6927-1.6439 0.5371-3.6132 0.5371-2.0182 0-3.9713-0.48828-1.9531-0.472-3.2064-1.0417v-3.4017h0.24414q1.3834 0.91145 3.2552 1.5137 1.8717 0.60221 3.6132 0.60221 1.0254 0 2.181-0.34179 1.1556-0.34179 1.8717-1.0091 0.74869-0.71614 1.1068-1.5788 0.37434-0.86262 0.37434-2.181 0-1.3021-0.42317-2.1484-0.4069-0.86262-1.1393-1.3509-0.73242-0.50455-1.7741-0.68359-1.0417-0.19531-2.2461-0.19531h-1.4648v-2.7018h1.1393q2.4739 0 3.9388-1.0254 1.4811-1.0417 1.4811-3.0273 0-0.8789-0.37435-1.5299-0.37435-0.66731-1.0417-1.0905-0.69986-0.42317-1.4974-0.58593t-1.8066-0.16276q-1.5462 0-3.2877 0.55338t-3.2877 1.5625h-0.16276v-3.4017q1.1556-0.56966 3.0761-1.0417 1.9368-0.48828 3.7434-0.48828 1.7741 0 3.125 0.32552 1.3509 0.32552 2.4414 1.0417 1.1719 0.78124 1.7741 1.888 0.60221 1.1068 0.60221 2.5879 0 2.0182-1.4323 3.5319-1.416 1.4974-3.3528 1.888v0.22786q0.78124 0.13021 1.7904 0.55338 1.0091 0.4069 1.709 1.0254z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.62 0h-3.0599v-1.9043q-1.3183 1.1393-2.7506 1.7741t-3.1087 0.63476q-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.65103-4.1178 0.66732-1.8066 1.7904-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29296 2.3274 0.92772v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.55338-2.2135-0.76497-0.97655-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7903-1.4323 1.7903-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1068 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.86-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50456 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.24-2.067q0 4.6223-2.0996 6.787-2.0996 2.1647-6.4615 2.1647-1.4486 0-2.832-0.21159-1.3672-0.19531-2.7018-0.56966v-3.125h0.16276q0.74869 0.29297 2.3763 0.71614 1.6276 0.43945 3.2552 0.43945 1.5625 0 2.5879-0.37435 1.0254-0.37435 1.595-1.0417 0.56966-0.63476 0.8138-1.5299 0.24414-0.89517 0.24414-2.0019v-1.6601q-1.3834 1.1068-2.653 1.6601-1.2532 0.5371-3.2064 0.5371-3.2552 0-5.1757-2.3437-1.9043-2.36-1.9043-6.6406 0-2.3437 0.65104-4.0364 0.66731-1.709 1.8066-2.9459 1.0579-1.1556 2.5716-1.7903 1.5137-0.65104 3.011-0.65104 1.5788 0 2.6367 0.32552 1.0742 0.30924 2.2624 0.96028l0.19531-0.78124h2.8646zm-3.0599-2.9297v-9.912q-1.2207-0.55338-2.2786-0.78124-1.0416-0.24414-2.0833-0.24414-2.5228 0-3.9713 1.6927-1.4486 1.6927-1.4486 4.9153 0 3.0599 1.0742 4.6386 1.0742 1.5788 3.5644 1.5788 1.3346 0 2.6692-0.50455 1.3509-0.52083 2.4739-1.3834z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.61-14.844h-0.16276q-0.68359-0.16276-1.3346-0.22786-0.63476-0.08138-1.5137-0.08138-1.416 0-2.7344 0.63476-1.3183 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2063-2.067 1.3997-0.61848 2.8483-0.61848 0.79752 0 1.1556 0.04883 0.35807 0.03255 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.74-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.6-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84634 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43945-3.3854 0.43945-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.82-18.18-4.7363 18.18h-2.832l-4.6712-14.014-4.6386 14.014h-2.8157l-4.7851-18.18h3.1901l3.3366 14.079 4.541-14.079h2.5228l4.6549 14.079 3.1575-14.079z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.52-21.224h-3.4505v-3.1738h3.4505zm-0.19531 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.16 0h-3.0599v-1.9043q-1.3183 1.1393-2.7506 1.7741t-3.1087 0.63476q-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.65103-4.1178 0.66731-1.8066 1.7904-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29296 2.3274 0.92772v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.55338-2.2135-0.76497-0.97655-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7903-1.4323 1.7903-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1068 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.4-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84634 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16275v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6113 0.43945-3.3854 0.43945-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.74-5.2408q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.16276q1.4486 1.0905 3.2226 1.7415 1.7741 0.63476 3.4017 0.63476 2.0182 0 3.1575-0.65104 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.61849-1.6276-0.61848-0.55338-2.3763-0.944-0.65103-0.14648-1.709-0.34179-1.0417-0.19531-1.9043-0.42317-2.3926-0.63476-3.4017-1.8554-0.99283-1.237-0.99283-3.0273 0-1.123 0.45573-2.1159 0.472-0.99283 1.416-1.7741 0.91145-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.4069 1.6764 0.39062 2.7832 0.96028v3.2715h-0.16276q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63476-1.1556 1.9043 0 1.123 0.69986 1.6927 0.68359 0.56966 2.2135 0.92772 0.84635 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.36-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.44-1.1393q-1.5299 0.73241-2.9134 1.1393-1.3672 0.4069-2.9134 0.4069-1.9694 0-3.6132-0.56966-1.6439-0.58593-2.8157-1.7578-1.1881-1.1719-1.8392-2.9622-0.65103-1.7903-0.65103-4.1829 0-4.4596 2.4414-6.9986 2.4577-2.539 6.4778-2.539 1.5625 0 3.0599 0.43945 1.5136 0.43945 2.7669 1.0742v3.4017h-0.16276q-1.3997-1.0905-2.8971-1.6764-1.4811-0.58593-2.8971-0.58593-2.6041 0-4.1178 1.7578-1.4974 1.7415-1.4974 5.1269 0 3.2877 1.4648 5.0618 1.4811 1.7578 4.1504 1.7578 0.92773 0 1.888-0.24414 0.96027-0.24414 1.7252-0.63476 0.66731-0.34179 1.2532-0.71614 0.58593-0.39062 0.92773-0.66731h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.82-0.16276q-0.86262 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45573 1.4974 0.35807 0.65104 0.97655 0.96028 0.63476 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.81379-0.22786 1.1719-0.37435h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m517.82-21.224h-3.4505v-3.1738h3.4505zm-0.19531 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.2-9.0819q0 4.4433-2.2786 7.0149-2.2786 2.5716-6.1035 2.5716-3.8574 0-6.136-2.5716-2.2624-2.5716-2.2624-7.0149 0-4.4433 2.2624-7.0149 2.2786-2.5879 6.136-2.5879 3.8248 0 6.1035 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3834-5.2408-1.3834-1.7252-3.8411-1.7252-2.4902 0-3.8737 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3834 5.192 1.3834 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.16 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14648-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.76496-0.34179-1.9856-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m578.04-5.2408q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.16276q1.4486 1.0905 3.2226 1.7415 1.7741 0.63476 3.4017 0.63476 2.0182 0 3.1575-0.65104 1.1393-0.65104 1.1393-2.0508 0-1.0742-0.61849-1.6276-0.61848-0.55338-2.3763-0.944-0.65103-0.14648-1.709-0.34179-1.0417-0.19531-1.9043-0.42317-2.3926-0.63476-3.4017-1.8554-0.99283-1.237-0.99283-3.0273 0-1.123 0.45573-2.1159 0.472-0.99283 1.416-1.7741 0.91145-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.4069 1.6764 0.39062 2.7832 0.96028v3.2715h-0.16276q-1.1719-0.86262-2.8483-1.4486-1.6764-0.60221-3.2877-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63476-1.1556 1.9043 0 1.123 0.69986 1.6927 0.68359 0.56966 2.2135 0.92772 0.84635 0.19531 1.888 0.39062 1.0579 0.19531 1.7578 0.35807 2.1321 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609.65-9.0819q0 4.4433-2.2786 7.0149-2.2786 2.5716-6.1034 2.5716-3.8574 0-6.136-2.5716-2.2623-2.5716-2.2623-7.0149 0-4.4433 2.2623-7.0149 2.2786-2.5879 6.136-2.5879 3.8248 0 6.1034 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3834-5.2408-1.3834-1.7252-3.8411-1.7252-2.4902 0-3.8737 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3834 5.192 1.3834 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624.18-22.363h-0.16276q-0.50455-0.14648-1.3184-0.29297-0.81379-0.16276-1.4323-0.16276-1.9694 0-2.8646 0.8789-0.8789 0.86262-0.8789 3.1412v0.61848h5.5175v2.5716h-5.4199v15.609h-3.0599v-15.609h-2.067v-2.5716h2.067v-0.60221q0-3.2389 1.6113-4.9641 1.6113-1.7415 4.6549-1.7415 1.0254 0 1.8392 0.09766 0.83007 0.09765 1.5137 0.22786z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m646.97-6.2988q0 3.1901-1.9531 4.9153-1.9368 1.7252-5.2083 1.7252-0.78124 0-2.0833-0.14648-1.3021-0.13021-2.181-0.32552v-3.011h0.17904q0.66731 0.22786 1.6439 0.472 0.97655 0.24414 2.0019 0.24414 1.4974 0 2.3763-0.34179 0.89517-0.34179 1.3184-0.97655 0.43945-0.65104 0.55338-1.595 0.1302-0.944 0.1302-2.181v-14.144h-5.1269v-2.5716h8.3495z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m668.08 0h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717t-3.125 0.65104q-2.8646 0-4.4596-1.7415-1.595-1.7578-1.595-5.1432v-11.8h3.0599v10.351q0 1.3834 0.1302 2.3763 0.13021 0.97655 0.55338 1.6764 0.43945 0.71614 1.1393 1.0417 0.69987 0.32552 2.0345 0.32552 1.1881 0 2.5879-0.61848 1.416-0.61848 2.6367-1.5788v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m690.1-9.3098q0 2.2135-0.63476 4.0527-0.63476 1.8229-1.7903 3.0924-1.0742 1.2044-2.539 1.8717-1.4486 0.65104-3.0761 0.65104-1.416 0-2.5716-0.30924-1.1393-0.30924-2.3274-0.96028v7.6171h-3.0599v-24.886h3.0599v1.9043q1.2207-1.0254 2.7344-1.709 1.5299-0.69986 3.2552-0.69986 3.2877 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1575 0.081379q0-3.2877-1.123-4.9153-1.123-1.6276-3.4505-1.6276-1.3184 0-2.653 0.56966t-2.5553 1.4974v10.303q1.3021 0.58593 2.2298 0.79752 0.94401 0.21159 2.1321 0.21159 2.5553 0 3.9876-1.7252 1.4323-1.7252 1.4323-5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m698.15-21.224h-3.4505v-3.1738h3.4505zm-0.19531 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m713.49-0.16276q-0.86263 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.0651 2.2461 0.0651 0.79752 0.45572 1.4974 0.35807 0.65104 0.97656 0.96028 0.63475 0.29297 1.9206 0.29297 0.74869 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37435h0.16276z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m732.41-8.7727h-13.395q0 1.6764 0.50456 2.9297 0.50455 1.237 1.3834 2.0345 0.84634 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4576 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m748.4-14.844h-0.16276q-0.68359-0.16276-1.3346-0.22786-0.63476-0.08138-1.5137-0.08138-1.416 0-2.7343 0.63476-1.3184 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2064-2.067 1.3997-0.61848 2.8483-0.61848 0.79751 0 1.1556 0.04883 0.35807 0.03255 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m766.32-21.224h-3.4505v-3.1738h3.4505zm-0.19531 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m787.41 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14648-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.76496-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m816.37-14.844h-0.16276q-0.68359-0.16276-1.3346-0.22786-0.63476-0.08138-1.5137-0.08138-1.416 0-2.7344 0.63476-1.3183 0.61848-2.539 1.6113v12.907h-3.0599v-18.18h3.0599v2.6855q1.8229-1.4648 3.2063-2.067 1.3997-0.61848 2.8483-0.61848 0.79752 0 1.1556 0.04883 0.35807 0.03255 1.0742 0.14648z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m834.5-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.84635 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.16276v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.0163-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m853.88 0h-3.0599v-1.9043q-1.3184 1.1393-2.7506 1.7741-1.4323 0.63476-3.1087 0.63476-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.65103-4.1178 0.66731-1.8066 1.7904-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29296 2.3274 0.92772v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.55338-2.2135-0.76497-0.97655-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7903-1.4323 1.7903-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1068 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(733.55 13.051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m885.75 0h-3.0436v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.68359 0.48828-1.3346 0.78124-0.76496 0.37435-1.7578 0.61848-0.99283 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.87889-3.3366 0.89518-1.2858 2.539-2.0182 1.6601-0.73242 3.9876-0.99283t4.9967-0.39062v-0.472q0-1.0417-0.37435-1.7252-0.35807-0.68359-1.0417-1.0742-0.65103-0.37435-1.5625-0.50455t-1.9043-0.13021q-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.16276v-3.1087q0.89517-0.24414 2.5879-0.5371t3.3366-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.53711 1.1881 0.53711 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3184 0.37435-2.1321 1.1719-0.81379 0.78124-0.81379 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m906.88 0h-3.0599v-10.351q0-1.2532-0.14648-2.3437-0.14649-1.1068-0.53711-1.7252-0.4069-0.68359-1.1719-1.0091-0.76497-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.9459 0 4.4921 1.7741 1.5462 1.7741 1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m927.51 0h-3.0599v-1.9043q-1.3184 1.1393-2.7506 1.7741-1.4323 0.63476-3.1087 0.63476-3.2552 0-5.1757-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.65103-4.1178 0.66731-1.8066 1.7904-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29296 2.3274 0.92772v-7.8775h3.0599zm-3.0599-4.4759v-10.433q-1.237-0.55338-2.2135-0.76497-0.97655-0.21159-2.1321-0.21159-2.5716 0-4.0039 1.7903-1.4323 1.7903-1.4323 5.0781 0 3.2389 1.1068 4.9316 1.1068 1.6764 3.5481 1.6764 1.3021 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m961.25-9.2284q0 2.2786-0.65103 4.1015-0.63476 1.8229-1.7252 3.0599-1.1556 1.2858-2.539 1.9368-1.3834 0.63476-3.0436 0.63476-1.5462 0-2.7018-0.37435-1.1556-0.35807-2.2786-0.97655l-0.19531 0.84635h-2.8646v-25.325h3.0599v9.0494q1.2858-1.0579 2.7344-1.7252 1.4486-0.68359 3.2552-0.68359 3.2226 0 5.0781 2.4739 1.8717 2.4739 1.8717 6.9824zm-3.1575 0.081379q0-3.2552-1.0742-4.9316-1.0742-1.6927-3.4668-1.6927-1.3346 0-2.7018 0.58593-1.3672 0.56966-2.539 1.4811v10.417q1.3021 0.58593 2.2298 0.81379 0.944 0.22786 2.1321 0.22786 2.539 0 3.9713-1.6601 1.4486-1.6764 1.4486-5.2408z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m969.11 0h-3.0599v-25.325h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m990.27 0h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717t-3.125 0.65104q-2.8646 0-4.4596-1.7415-1.595-1.7578-1.595-5.1432v-11.8h3.0599v10.351q0 1.3834 0.13021 2.3763 0.13021 0.97655 0.55338 1.6764 0.43945 0.71614 1.1393 1.0417t2.0345 0.32552q1.1881 0 2.5879-0.61848 1.416-0.61848 2.6367-1.5788v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1011.5-8.7727h-13.395q0 1.6764 0.50455 2.9297 0.50455 1.237 1.3834 2.0345 0.8463 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8555 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65104-3.1575 1.0905-1.6114 0.43945-3.3854 0.43945-4.5247 0-7.0638-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9784-2.3437q-0.016-2.4088-1.2207-3.7272-1.1882-1.3183-3.6296-1.3183-2.4576 0-3.9224 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1031 0h-3.0599v-25.325h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1040.3-21.224h-3.4504v-3.1738h3.4504zm-0.1953 21.224h-3.0598v-18.18h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1061-2.067q0 4.6223-2.0996 6.787-2.0995 2.1647-6.4615 2.1647-1.4485 0-2.832-0.21159-1.3672-0.19531-2.7018-0.56966v-3.125h0.1628q0.7487 0.29297 2.3763 0.71614 1.6275 0.43945 3.2551 0.43945 1.5625 0 2.5879-0.37435 1.0254-0.37435 1.595-1.0417 0.5697-0.63476 0.8138-1.5299 0.2442-0.89517 0.2442-2.0019v-1.6601q-1.3835 1.1068-2.653 1.6601-1.2532 0.5371-3.2063 0.5371-3.2552 0-5.1758-2.3437-1.9043-2.36-1.9043-6.6406 0-2.3437 0.6511-4.0364 0.6673-1.709 1.8066-2.9459 1.0579-1.1556 2.5716-1.7903 1.5136-0.65104 3.011-0.65104 1.5788 0 2.6367 0.32552 1.0742 0.30924 2.2624 0.96028l0.1953-0.78124h2.8645zm-3.0598-2.9297v-9.912q-1.2207-0.55338-2.2787-0.78124-1.0416-0.24414-2.0833-0.24414-2.5227 0-3.9713 1.6927-1.4485 1.6927-1.4485 4.9153 0 3.0599 1.0742 4.6386 1.0742 1.5788 3.5644 1.5788 1.3346 0 2.6692-0.50455 1.3509-0.52083 2.474-1.3834z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1082.2 0h-3.0598v-10.351q0-1.2532-0.1465-2.3437-0.1465-1.1068-0.5371-1.7252-0.4069-0.68359-1.1719-1.0091-0.765-0.34179-1.9856-0.34179-1.2533 0-2.6205 0.61848-1.3671 0.61848-2.6204 1.5788v13.574h-3.0598v-25.325h3.0598v9.1633q1.4323-1.1881 2.9622-1.8554 1.53-0.66731 3.1413-0.66731 2.9459 0 4.4921 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1097.5-0.16276q-0.8627 0.22786-1.888 0.37435-1.0091 0.14648-1.8067 0.14648-2.7831 0-4.2317-1.4974-1.4485-1.4974-1.4485-4.8014v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.79752 0.4558 1.4974 0.358 0.65104 0.9765 0.96028 0.6348 0.29297 1.9206 0.29297 0.7487 0 1.5624-0.21159 0.8138-0.22786 1.1719-0.37435h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1122.4-0.16276q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2318-1.4974-1.4485-1.4974-1.4485-4.8014v-9.6679h-2.0671v-2.5716h2.0671v-5.2246h3.0598v5.2246h6.3151v2.5716h-6.3151v8.2844q0 1.4323 0.065 2.2461 0.065 0.79752 0.4558 1.4974 0.358 0.65104 0.9765 0.96028 0.6348 0.29297 1.9206 0.29297 0.7487 0 1.5625-0.21159 0.8137-0.22786 1.1718-0.37435h0.1628z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1141.6-9.0819q0 4.4433-2.2786 7.0149-2.2787 2.5716-6.1035 2.5716-3.8574 0-6.136-2.5716-2.2623-2.5716-2.2623-7.0149 0-4.4433 2.2623-7.0149 2.2786-2.5879 6.136-2.5879 3.8248 0 6.1035 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3835-5.2408-1.3834-1.7252-3.8411-1.7252-2.4902 0-3.8737 1.7252-1.3671 1.709-1.3671 5.2408 0 3.4179 1.3834 5.192 1.3835 1.7578 3.8574 1.7578 2.4414 0 3.8248-1.7415 1.3998-1.7578 1.3998-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1174.1-9.2284q0 2.2786-0.6511 4.1015-0.6347 1.8229-1.7252 3.0599-1.1556 1.2858-2.539 1.9368-1.3835 0.63476-3.0436 0.63476-1.5462 0-2.7018-0.37435-1.1556-0.35807-2.2786-0.97655l-0.1954 0.84635h-2.8645v-25.325h3.0599v9.0494q1.2857-1.0579 2.7343-1.7252 1.4486-0.68359 3.2552-0.68359 3.2226 0 5.0781 2.4739 1.8717 2.4739 1.8717 6.9824zm-3.1575 0.081379q0-3.2552-1.0743-4.9316-1.0742-1.6927-3.4667-1.6927-1.3346 0-2.7018 0.58593-1.3672 0.56966-2.539 1.4811v10.417q1.302 0.58593 2.2297 0.81379 0.944 0.22786 2.1322 0.22786 2.539 0 3.9713-1.6601 1.4486-1.6764 1.4486-5.2408z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1193.9 0h-3.0599v-2.0182q-1.5462 1.2207-2.9622 1.8717t-3.1249 0.65104q-2.8646 0-4.4596-1.7415-1.5951-1.7578-1.5951-5.1432v-11.8h3.0599v10.351q0 1.3834 0.1302 2.3763 0.1302 0.97655 0.5534 1.6764 0.4394 0.71614 1.1393 1.0417t2.0345 0.32552q1.1881 0 2.5878-0.61848 1.416-0.61848 2.6367-1.5788v-13.574h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1203.2-21.224h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1212.2 0h-3.0598v-25.325h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1233 0h-3.0598v-1.9043q-1.3184 1.1393-2.7507 1.7741-1.4322 0.63476-3.1086 0.63476-3.2552 0-5.1758-2.5065-1.9043-2.5065-1.9043-6.9498 0-2.3112 0.6511-4.1178 0.6673-1.8066 1.7903-3.0761 1.1068-1.237 2.5716-1.888 1.4811-0.65104 3.0599-0.65104 1.4323 0 2.539 0.30924 1.1068 0.29296 2.3275 0.92772v-7.8775h3.0598zm-3.0598-4.4759v-10.433q-1.237-0.55338-2.2135-0.76497-0.9766-0.21159-2.1322-0.21159-2.5716 0-4.0039 1.7903-1.4322 1.7903-1.4322 5.0781 0 3.2389 1.1067 4.9316 1.1068 1.6764 3.5482 1.6764 1.302 0 2.6367-0.56966 1.3346-0.58593 2.4902-1.4974z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1264.9 0h-3.0435v-1.9368q-0.4069 0.27669-1.1068 0.78124-0.6836 0.48828-1.3346 0.78124-0.765 0.37435-1.7578 0.61848-0.9928 0.26041-2.3275 0.26041-2.4576 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.8952-1.2858 2.5391-2.0182 1.6601-0.73242 3.9876-0.99283 2.3274-0.26041 4.9967-0.39062v-0.472q0-1.0417-0.3744-1.7252-0.3581-0.68359-1.0416-1.0742-0.6511-0.37435-1.5625-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1627v-3.1087q0.8951-0.24414 2.5878-0.5371t3.3366-0.29297q1.9205 0 3.3365 0.32552 1.4323 0.30924 2.474 1.0742 1.0253 0.74869 1.5624 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0435-4.4759v-5.0618q-1.3998 0.081379-3.304 0.24414-1.888 0.16276-2.9948 0.472-1.3184 0.37435-2.1321 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.474-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1298.3-18.18-7.3567 18.18h-3.0761l-7.3079-18.18h3.3203l5.6314 14.469 5.5826-14.469z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1305.6-21.224h-3.4504v-3.1738h3.4504zm-0.1953 21.224h-3.0598v-18.18h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1324.4-5.2408q0 2.4902-2.067 4.0852-2.0508 1.595-5.6152 1.595-2.0182 0-3.7109-0.472-1.6764-0.48828-2.8157-1.0579v-3.4342h0.1627q1.4486 1.0905 3.2227 1.7415 1.774 0.63476 3.4016 0.63476 2.0182 0 3.1575-0.65104 1.1394-0.65104 1.1394-2.0508 0-1.0742-0.6185-1.6276-0.6185-0.55338-2.3763-0.944-0.651-0.14648-1.709-0.34179-1.0416-0.19531-1.9042-0.42317-2.3926-0.63476-3.4017-1.8554-0.9928-1.237-0.9928-3.0273 0-1.123 0.4557-2.1159 0.472-0.99283 1.416-1.7741 0.9114-0.76497 2.3112-1.2044 1.416-0.45572 3.1575-0.45572 1.6276 0 3.2877 0.4069 1.6764 0.39062 2.7832 0.96028v3.2715h-0.1628q-1.1718-0.86262-2.8482-1.4486-1.6765-0.60221-3.2878-0.60221-1.6764 0-2.832 0.65104-1.1556 0.63476-1.1556 1.9043 0 1.123 0.6999 1.6927 0.6836 0.56966 2.2135 0.92772 0.8464 0.19531 1.888 0.39062 1.058 0.19531 1.7578 0.35807 2.1322 0.48828 3.2877 1.6764 1.1556 1.2044 1.1556 3.1901z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1343.9 0h-3.0598v-2.0182q-1.5462 1.2207-2.9622 1.8717t-3.125 0.65104q-2.8646 0-4.4596-1.7415-1.595-1.7578-1.595-5.1432v-11.8h3.0598v10.351q0 1.3834 0.1302 2.3763 0.1302 0.97655 0.5534 1.6764 0.4395 0.71614 1.1393 1.0417 0.6999 0.32552 2.0345 0.32552 1.1881 0 2.5879-0.61848 1.416-0.61848 2.6367-1.5788v-13.574h3.0598z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1364.1 0h-3.0436v-1.9368q-0.4069 0.27669-1.1067 0.78124-0.6836 0.48828-1.3346 0.78124-0.765 0.37435-1.7578 0.61848-0.9929 0.26041-2.3275 0.26041-2.4576 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.8952-1.2858 2.5391-2.0182 1.6601-0.73242 3.9876-0.99283 2.3274-0.26041 4.9966-0.39062v-0.472q0-1.0417-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37435-1.5624-0.50455-0.9115-0.13021-1.9043-0.13021-1.2044 0-2.6855 0.32552-1.4811 0.30924-3.0599 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.5371t3.3366-0.29297q1.9205 0 3.3365 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9947 0.472-1.3184 0.37435-2.1322 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8809 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1373.1 0h-3.0599v-25.325h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1394.2-21.224h-3.4505v-3.1738h3.4505zm-0.1953 21.224h-3.0599v-18.18h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1426.6 0h-3.0598v-10.351q0-1.1719-0.114-2.2623-0.098-1.0905-0.4394-1.7415-0.3744-0.69986-1.0742-1.0579-0.6999-0.35807-2.0182-0.35807-1.2858 0-2.5716 0.65104-1.2858 0.63476-2.5716 1.6276 0.049 0.37435 0.081 0.8789 0.033 0.48828 0.033 0.97655v11.637h-3.0599v-10.351q0-1.2044-0.1139-2.2786-0.098-1.0905-0.4394-1.7415-0.3744-0.69986-1.0742-1.0417-0.6999-0.35807-2.0183-0.35807-1.2532 0-2.5227 0.61848-1.2533 0.61848-2.5065 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.8483-1.8554 1.4323-0.66731 3.0436-0.66731 1.8554 0 3.1412 0.78124 1.3021 0.78124 1.9368 2.1647 1.8555-1.5625 3.3854-2.2461 1.53-0.69986 3.2715-0.69986 2.9947 0 4.4107 1.8229 1.4323 1.8066 1.4323 5.0618z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1446.6 0h-3.0436v-1.9368q-0.4069 0.27669-1.1067 0.78124-0.6836 0.48828-1.3347 0.78124-0.7649 0.37435-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.8952-1.2858 2.539-2.0182 1.6602-0.73242 3.9876-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0417-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37435-1.5625-0.50455-0.9114-0.13021-1.9042-0.13021-1.2045 0-2.6856 0.32552-1.4811 0.30924-3.0598 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.5371t3.3365-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9947 0.472-1.3184 0.37435-2.1322 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8808 0.78124 1.6114 0 2.946-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1467.3-2.067q0 4.6223-2.0996 6.787t-6.4615 2.1647q-1.4486 0-2.832-0.21159-1.3672-0.19531-2.7018-0.56966v-3.125h0.1627q0.7487 0.29297 2.3763 0.71614 1.6276 0.43945 3.2552 0.43945 1.5625 0 2.5878-0.37435 1.0254-0.37435 1.5951-1.0417 0.5696-0.63476 0.8138-1.5299 0.2441-0.89517 0.2441-2.0019v-1.6601q-1.3834 1.1068-2.653 1.6601-1.2532 0.5371-3.2063 0.5371-3.2552 0-5.1757-2.3437-1.9043-2.36-1.9043-6.6406 0-2.3437 0.651-4.0364 0.6673-1.709 1.8066-2.9459 1.058-1.1556 2.5716-1.7903 1.5137-0.65104 3.0111-0.65104 1.5787 0 2.6367 0.32552 1.0742 0.30924 2.2623 0.96028l0.1953-0.78124h2.8646zm-3.0599-2.9297v-9.912q-1.2207-0.55338-2.2786-0.78124-1.0417-0.24414-2.0833-0.24414-2.5228 0-3.9713 1.6927-1.4486 1.6927-1.4486 4.9153 0 3.0599 1.0742 4.6386 1.0742 1.5788 3.5644 1.5788 1.3346 0 2.6693-0.50455 1.3509-0.52083 2.4739-1.3834z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1488.5-8.7727h-13.395q0 1.6764 0.5045 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78124 2.0019 1.1719 1.1719 0.39062 2.5716 0.39062 1.8555 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65104-3.1576 1.0905-1.6113 0.43945-3.3853 0.43945-4.5247 0-7.0638-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9784-2.3437q-0.016-2.4088-1.2207-3.7272-1.1882-1.3183-3.6296-1.3183-2.4576 0-3.9224 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1520.4-9.0819q0 4.4433-2.2786 7.0149-2.2786 2.5716-6.1035 2.5716-3.8573 0-6.136-2.5716-2.2623-2.5716-2.2623-7.0149 0-4.4433 2.2623-7.0149 2.2787-2.5879 6.136-2.5879 3.8249 0 6.1035 2.5879 2.2786 2.5716 2.2786 7.0149zm-3.1575 0q0-3.5319-1.3834-5.2408-1.3835-1.7252-3.8412-1.7252-2.4902 0-3.8736 1.7252-1.3672 1.709-1.3672 5.2408 0 3.4179 1.3835 5.192 1.3834 1.7578 3.8573 1.7578 2.4414 0 3.8249-1.7415 1.3997-1.7578 1.3997-5.2083z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1534.9-22.363h-0.1628q-0.5045-0.14648-1.3183-0.29297-0.8138-0.16276-1.4323-0.16276-1.9694 0-2.8646 0.8789-0.8789 0.86262-0.8789 3.1412v0.61848h5.5176v2.5716h-5.4199v15.609h-3.0599v-15.609h-2.067v-2.5716h2.067v-0.60221q0-3.2389 1.6113-4.9641 1.6114-1.7415 4.6549-1.7415 1.0254 0 1.8392 0.09766 0.8301 0.09765 1.5137 0.22786z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1558-0.16276q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.065 2.2461 0.065 0.79752 0.4557 1.4974 0.3581 0.65104 0.9766 0.96028 0.6347 0.29297 1.9205 0.29297 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37435h0.1627z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1576.9 0h-3.0599v-10.351q0-1.2532-0.1465-2.3437-0.1464-1.1068-0.5371-1.7252-0.4069-0.68359-1.1718-1.0091-0.765-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-25.325h3.0599v9.1633q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.946 0 4.4922 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1598-8.7727h-13.395q0 1.6764 0.5046 2.9297 0.5045 1.237 1.3834 2.0345 0.8464 0.78124 2.002 1.1719 1.1718 0.39062 2.5715 0.39062 1.8555 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.1628v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.5391-2.4577-2.5391-6.9661 0-4.4596 2.4251-7.08 2.4414-2.6204 6.4127-2.6204 3.6784 0 5.664 2.1484 2.002 2.1484 2.002 6.1035zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1882-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4486 1.4486-1.6439 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1630.4-9.3098q0 2.2135-0.6347 4.0527-0.6348 1.8229-1.7904 3.0924-1.0742 1.2044-2.539 1.8717-1.4486 0.65104-3.0762 0.65104-1.416 0-2.5715-0.30924-1.1394-0.30924-2.3275-0.96028v7.6171h-3.0599v-24.886h3.0599v1.9043q1.2207-1.0254 2.7343-1.709 1.53-0.69986 3.2552-0.69986 3.2878 0 5.1106 2.4902 1.8392 2.4739 1.8392 6.8847zm-3.1575 0.081379q0-3.2877-1.123-4.9153-1.1231-1.6276-3.4505-1.6276-1.3184 0-2.653 0.56966t-2.5553 1.4974v10.303q1.3021 0.58593 2.2298 0.79752 0.944 0.21159 2.1321 0.21159 2.5553 0 3.9876-1.7252t1.4323-5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1638.2 0h-3.0599v-25.325h3.0599z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1658.5 0h-3.0436v-1.9368q-0.4069 0.27669-1.1067 0.78124-0.6836 0.48828-1.3347 0.78124-0.7649 0.37435-1.7578 0.61848-0.9928 0.26041-2.3274 0.26041-2.4577 0-4.1666-1.6276-1.709-1.6276-1.709-4.1503 0-2.067 0.8789-3.3366 0.8952-1.2858 2.539-2.0182 1.6602-0.73242 3.9876-0.99283 2.3275-0.26041 4.9967-0.39062v-0.472q0-1.0417-0.3743-1.7252-0.3581-0.68359-1.0417-1.0742-0.651-0.37435-1.5625-0.50455-0.9114-0.13021-1.9042-0.13021-1.2045 0-2.6856 0.32552-1.4811 0.30924-3.0598 0.91145h-0.1628v-3.1087q0.8952-0.24414 2.5879-0.5371t3.3365-0.29297q1.9206 0 3.3366 0.32552 1.4323 0.30924 2.4739 1.0742 1.0254 0.74869 1.5625 1.9368 0.5371 1.1881 0.5371 2.9459zm-3.0436-4.4759v-5.0618q-1.3997 0.081379-3.304 0.24414-1.888 0.16276-2.9947 0.472-1.3184 0.37435-2.1322 1.1719-0.8138 0.78124-0.8138 2.1647 0 1.5625 0.944 2.36 0.944 0.78124 2.8809 0.78124 1.6113 0 2.9459-0.61848 1.3346-0.63476 2.4739-1.5137z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1679.6 0h-3.0599v-10.351q0-1.2532-0.1465-2.3437-0.1464-1.1068-0.5371-1.7252-0.4069-0.68359-1.1718-1.0091-0.765-0.34179-1.9857-0.34179-1.2532 0-2.6204 0.61848-1.3672 0.61848-2.6204 1.5788v13.574h-3.0599v-18.18h3.0599v2.0182q1.4323-1.1881 2.9622-1.8554t3.1412-0.66731q2.946 0 4.4922 1.7741t1.5462 5.1106z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1700.7-8.7727h-13.395q0 1.6764 0.5045 2.9297 0.5046 1.237 1.3835 2.0345 0.8463 0.78124 2.0019 1.1719 1.1718 0.39062 2.5716 0.39062 1.8554 0 3.7272-0.73241 1.888-0.74869 2.6855-1.4648h0.1627v3.3366q-1.5462 0.65104-3.1575 1.0905t-3.3854 0.43945q-4.5247 0-7.0637-2.4414-2.539-2.4577-2.539-6.9661 0-4.4596 2.4251-7.08 2.4413-2.6204 6.4127-2.6204 3.6783 0 5.664 2.1484 2.0019 2.1484 2.0019 6.1035zm-2.9785-2.3437q-0.016-2.4088-1.2207-3.7272-1.1881-1.3183-3.6295-1.3183-2.4577 0-3.9225 1.4486-1.4485 1.4486-1.6438 3.597z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1714.8-0.16276q-0.8626 0.22786-1.888 0.37435-1.0091 0.14648-1.8066 0.14648-2.7832 0-4.2317-1.4974-1.4486-1.4974-1.4486-4.8014v-9.6679h-2.067v-2.5716h2.067v-5.2246h3.0599v5.2246h6.315v2.5716h-6.315v8.2844q0 1.4323 0.065 2.2461 0.065 0.79752 0.4557 1.4974 0.3581 0.65104 0.9766 0.96028 0.6347 0.29297 1.9205 0.29297 0.7487 0 1.5625-0.21159 0.8138-0.22786 1.1719-0.37435h0.1627z",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1193.2 82.833)",
    fill: "#d40000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 109.66,
    width: 859.43,
    height: 39.433
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2780.9,
    y: 149.66,
    width: 859.43,
    height: 39.433
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fontFamily: "sans-serif",
    fontSize: "40px"
  }, /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect1338)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect1350)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect1356)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "HVM-Cap",
    transform: "translate(-654.3 -118.95)",
    fill: "#e1d355",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2234.2 290.88c-13.029 9.3566 6.0097 20.327 17.93 8.5863z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2283.4 276.73 20.203 19.193c0.8605 6.4504-1.0399 11.897-7.5762 15.657l-27.527-4.0406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2234.6 257.17 49.107 19.286c3.9778 6.063-0.582 32.789-16.071 30.714l-45.357-20.893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2237.6 275.79a9.2857 15.893 24.109 1 1-16.952-7.5859 9.2857 15.893 24.109 1 1 16.952 7.5859z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPioneer10Optimized);
export default __webpack_public_path__ + "static/media/Pioneer-10-optimized.06e2ea67.svg";
export { ForwardRef as ReactComponent };